import { useState, useEffect, Fragment } from "react";
import { supabase, SUPABASE_URL, TABLE_PREFIX, DEMO_MODE } from "./supabaseClient";
import { useTable, useVenueInventory, useReceived } from "./dataLayer";

const LOGO_SRC = "data:image/png;base64,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";


const C = {
  bg: "#FAF7F2", surface: "#FFFFFF", border: "#E8DDD0",
  amber: "#2D1B00", gold: "#E8A020", goldLight: "#FFF3D6", goldDark: "#B87A10",
  muted: "#6B5B45", sage: "#7A9E7E", sageDark: "#4E7452", sageLight: "#EBF3EC",
  danger: "#C0392B", dangerLight: "#FDECEA", text: "#1A0F00", textSoft: "#7A6A55",
  purple: "#6B46C1", purpleLight: "#EDE9FE",
};

const styles = {
  app: { fontFamily: "'Inter', 'Segoe UI', sans-serif", background: C.bg, minHeight: "100vh", color: C.text },
  header: { background: C.amber, color: "#FFF", padding: "0 24px", display: "flex", alignItems: "center", justifyContent: "space-between", height: 60, boxShadow: "0 2px 8px rgba(45,27,0,0.25)" },
  headerTitle: { fontSize: 20, fontWeight: 700, letterSpacing: "-0.3px", display: "flex", alignItems: "center", gap: 10 },
  nav: { display: "flex", gap: 4, padding: "12px 24px 0", borderBottom: `2px solid ${C.border}`, background: C.surface, flexWrap: "wrap" },
  navBtn: (active) => ({ padding: "10px 18px", border: "none", background: active ? C.goldLight : "transparent", color: active ? C.goldDark : C.muted, fontWeight: active ? 700 : 500, fontSize: 14, borderRadius: "8px 8px 0 0", cursor: "pointer", borderBottom: active ? `3px solid ${C.gold}` : "3px solid transparent" }),
  subNav: { display: "flex", gap: 8, marginBottom: 20 },
  subNavBtn: (active, color = C.gold) => ({ padding: "8px 16px", border: `2px solid ${active ? color : C.border}`, background: active ? C.goldLight : C.surface, color: active ? C.goldDark : C.muted, fontWeight: active ? 700 : 500, fontSize: 13, borderRadius: 8, cursor: "pointer" }),
  page: { maxWidth: 1100, margin: "0 auto", padding: "28px 24px" },
  card: { background: C.surface, border: `1px solid ${C.border}`, borderRadius: 12, padding: 20, marginBottom: 20 },
  sectionTitle: { fontSize: 18, fontWeight: 700, marginBottom: 16, color: C.amber, display: "flex", alignItems: "center", gap: 8 },
  grid2: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 },
  grid4: { display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 16, marginBottom: 20 },
  statCard: (color = C.goldLight) => ({ background: color, borderRadius: 10, padding: "16px 20px", display: "flex", flexDirection: "column", gap: 4 }),
  statNum: { fontSize: 28, fontWeight: 800, color: C.amber, lineHeight: 1 },
  statLabel: { fontSize: 12, fontWeight: 600, color: C.muted, textTransform: "uppercase", letterSpacing: "0.5px" },
  table: { width: "100%", borderCollapse: "collapse", fontSize: 14 },
  th: { textAlign: "left", padding: "10px 12px", background: C.goldLight, color: C.goldDark, fontWeight: 700, fontSize: 12, textTransform: "uppercase", letterSpacing: "0.4px", borderBottom: `2px solid ${C.gold}` },
  td: { padding: "11px 12px", borderBottom: `1px solid ${C.border}`, color: C.text, verticalAlign: "middle" },
  badge: (type) => {
    const map = {
      low: { bg: C.dangerLight, color: C.danger },
      ok: { bg: C.sageLight, color: C.sageDark },
      warn: { bg: "#FFF8E1", color: "#B8860B" },
      store: { bg: C.goldLight, color: C.goldDark },
      event: { bg: C.purpleLight, color: C.purple },
    };
    const t = map[type] || map.ok;
    return { background: t.bg, color: t.color, borderRadius: 20, padding: "3px 10px", fontSize: 12, fontWeight: 700, display: "inline-block" };
  },
  input: { width: "100%", padding: "9px 12px", border: `1.5px solid ${C.border}`, borderRadius: 8, fontSize: 14, color: C.text, background: C.bg, boxSizing: "border-box", outline: "none" },
  label: { fontSize: 12, fontWeight: 600, color: C.muted, marginBottom: 5, display: "block", textTransform: "uppercase", letterSpacing: "0.3px" },
  btn: (variant = "primary") => {
    const map = {
      primary: { bg: C.gold, color: C.amber, border: "#cf8a13" },
      danger:  { bg: "#fff", color: C.danger, border: C.danger },
      ghost:   { bg: "#fff", color: C.text, border: C.border },
      sage:    { bg: C.sage, color: "#fff", border: C.sageDark },
      purple:  { bg: C.purple, color: "#fff", border: "#5733a6" },
    };
    const v = map[variant] || map.primary;
    return {
      background: v.bg,
      color: v.color,
      border: `1.5px solid ${v.border}`,
      borderRadius: 10,
      padding: "10px 18px",
      fontWeight: 700,
      fontSize: 13.5,
      cursor: "pointer",
      boxShadow: "0 1px 2px rgba(45,27,0,0.12)",
      transition: "transform .05s ease, box-shadow .1s ease",
      whiteSpace: "nowrap",
    };
  },
  formRow: { marginBottom: 14 },
  empty: { textAlign: "center", padding: "40px 20px", color: C.textSoft, fontSize: 14 },
};

// ── Section grouping helpers ────────────────────────────────────────────────
// Group product-like rows (which carry a sectionId) under their section,
// in the admin's chosen order, with anything unassigned in "Uncategorized" last.
function groupRowsBySection(rows, sortedSections, getSectionId) {
  const nameById = Object.fromEntries(sortedSections.map(s => [String(s.id), s.name]));
  const buckets = new Map();
  for (const r of rows) {
    const sid = getSectionId(r);
    const key = (sid && nameById[String(sid)]) ? String(sid) : "__none__";
    if (!buckets.has(key)) buckets.set(key, []);
    buckets.get(key).push(r);
  }
  const groups = [];
  for (const s of sortedSections) if (buckets.has(String(s.id))) groups.push({ key: String(s.id), name: s.name, rows: buckets.get(String(s.id)) });
  if (buckets.has("__none__")) groups.push({ key: "__none__", name: "Uncategorized", rows: buckets.get("__none__") });
  return groups;
}

// Group sellable rows (which carry a plain `section` string) for checkout.
// `sectionOrder` is the admin-ordered list of section names.
function groupSourceBySection(source, sectionOrder = []) {
  const buckets = new Map();
  for (const s of source) {
    const key = (s.section && String(s.section).trim()) ? String(s.section).trim() : "Uncategorized";
    if (!buckets.has(key)) buckets.set(key, []);
    buckets.get(key).push(s);
  }
  const ordered = [];
  for (const name of sectionOrder) if (buckets.has(name)) { ordered.push({ name, rows: buckets.get(name) }); buckets.delete(name); }
  const rest = [...buckets.keys()].filter(k => k !== "Uncategorized").sort((a, b) => a.localeCompare(b));
  for (const name of rest) ordered.push({ name, rows: buckets.get(name) });
  if (buckets.has("Uncategorized")) ordered.push({ name: "Uncategorized", rows: buckets.get("Uncategorized") });
  return ordered;
}

// Sub-group product-like rows by name; multi-variant names become collapsible
// groups (used on Products and Inventory). `openNames` marks which are expanded.
function nameVariantGroups(rows, prefix, openNames = {}) {
  const byName = new Map();
  for (const p of rows) { const k = (p.name || "").trim().toLowerCase(); if (!byName.has(k)) byName.set(k, []); byName.get(k).push(p); }
  return [...byName.entries()]
    .sort((a, b) => (a[1][0].name || "").localeCompare(b[1][0].name || ""))
    .map(([k, rs]) => {
      const multi = rs.length > 1;
      const gkey = `${prefix}::${k}`;
      const sizes = rs.map(r => r.size).filter(Boolean);
      const stock = rs.reduce((s, r) => s + Number(r.qty || 0), 0);
      const summary = multi ? `${rs.length} sizes${sizes.length ? ": " + sizes.join(", ") : ""} · ${stock} in stock` : "";
      return { key: gkey, title: rs[0].name, summary, rows: rs, collapsible: multi, collapsed: !openNames[gkey] };
    });
}
function multiNameKeys(rows, prefix) {
  const counts = new Map();
  rows.forEach(p => { const k = (p.name || "").trim().toLowerCase(); counts.set(k, (counts.get(k) || 0) + 1); });
  return [...counts.entries()].filter(([, c]) => c > 1).map(([k]) => `${prefix}::${k}`);
}

// ── Shared UI ──────────────────────────────────────────────────────────────
// ── Syncrostore CSV export (matches the Collective's inventory import template) ──
const SYNCRO_HEADERS = ["Group Key","SKU","Description *","Long Description","Price","Cost","Quantity","UPC","Brand","Condition","Category","Subcategory","Vendor Name","Vendor Alias","Vendor ID","Date Purchased","Tags","Tax Exempt","Weight","Length","Width","Height","Variant SKU","Variant Price","Variant Cost","Variant Quantity","Variant Weight","Option1 Name","Option1 Value","Option2 Name","Option2 Value","Option3 Name","Option3 Value"];

// Make a SKU from name + size, e.g. "Wildflower Honey" 8oz -> WILDFLOWER-HONEY-8OZ
function makeSku(name, size) {
  const clean = (s) => String(s || "").toUpperCase().replace(/[^A-Z0-9]+/g, "-").replace(/^-+|-+$/g, "");
  return [clean(name), clean(size)].filter(Boolean).join("-");
}

// Structured SKU: VENDOR-CATEGORY-NAME(-SIZE). The NAME segment is a short
// fixed-width code (4 chars) derived from the product name; size is compacted.
const SKU_NAME_LEN = 4;
function skuNameCode(name, len = SKU_NAME_LEN) {
  const n = Math.max(1, Number(len) || SKU_NAME_LEN);
  const c = String(name || "").toUpperCase().replace(/[^A-Z0-9]/g, "");
  if (!c) return "PROD".slice(0, n).padEnd(n, "X");
  // long enough → first N; shorter → pad with X to a consistent width.
  return c.length >= n ? c.slice(0, n) : c.padEnd(n, "X");
}
function buildSku({ vendorPrefix, categoryCode, name, size, nameLen, maxLen = 0, noDashes = false }) {
  const clean = (s) => String(s || "").toUpperCase().replace(/[^A-Z0-9]+/g, "-").replace(/^-+|-+$/g, "");
  const sizeCode = String(size || "").toUpperCase().replace(/[^A-Z0-9]/g, ""); // "8 oz" → "8OZ"
  let sku = [clean(vendorPrefix), clean(categoryCode), skuNameCode(name, nameLen || SKU_NAME_LEN), sizeCode].filter(Boolean).join("-");
  if (noDashes) sku = sku.replace(/-/g, "");       // auto-SKUs only — manual overrides keep their dashes
  if (maxLen && maxLen > 0) sku = sku.slice(0, maxLen); // hard cap: truncate automatically
  return sku;
}

// Ensure a SKU is unique across products; append -2, -3… on collision.
function uniqueSku(base, takenSet) {
  if (!takenSet.has(base)) return base;
  let n = 2;
  while (takenSet.has(`${base}-${n}`)) n++;
  return `${base}-${n}`;
}

// Like uniqueSku, but respects a max length (trims the base so the numeric suffix
// still fits) and honors the no-dashes setting for the suffix separator.
function uniqueSkuBounded(base, takenSet, maxLen = 0, noDashes = false) {
  if (!takenSet.has(base)) return base;
  const sep = noDashes ? "" : "-";
  let n = 2;
  for (;;) {
    const suffix = `${sep}${n}`;
    let stem = base;
    if (maxLen && maxLen > 0 && base.length + suffix.length > maxLen) {
      stem = base.slice(0, Math.max(1, maxLen - suffix.length));
    }
    const candidate = stem + suffix;
    if (!takenSet.has(candidate)) return candidate;
    n++;
  }
}

// Effective per-unit material cost INCLUDING tax when the material is taxable.
// `m.cost` is the base unit cost (or lot-derived). When taxable, the material's own
// rate (seeded from the global default at add time) is applied so product margins
// reflect what you actually pay for the material.
function matEffectiveCost(m) {
  if (!m) return 0;
  const base = Number(m.cost) || 0;
  const rate = m.taxable ? (Number(m.taxRate) || 0) : 0;
  return base * (1 + rate / 100);
}

// ── Deal + tax pricing engine ───────────────────────────────────────────────
// Pure functions (no React) so the money math can be unit-tested.
// Tax rates are percents (e.g. 9.25). Deals: { type:'qty'|'cart', scope, productSku,
// sectionName, tiers:[{minQty|minSubtotal, rewardType:'percent'|'amount', rewardValue}],
// priority, active }. qty 'amount' = $ off per unit; cart 'amount' = $ off the cart.

function dealMatchesLine(deal, li) {
  if (deal.scope === "product") return !!deal.productSku && String(deal.productSku).toUpperCase() === String(li.sku || "").toUpperCase();
  if (deal.scope === "section") return !!deal.sectionName && String(deal.sectionName).toLowerCase() === String(li.section || "").toLowerCase();
  return true; // 'all'
}
function bestTier(tiers, value, key) {
  // highest qualifying tier (tier[key] <= value)
  let best = null;
  (tiers || []).forEach(t => {
    const thr = Number(t[key]) || 0;
    if (value >= thr && (best === null || thr > (Number(best[key]) || 0))) best = t;
  });
  return best;
}
function qtyTierDiscount(tier, unitPrice, qty) {
  const gross = unitPrice * qty;
  if (tier.rewardType === "percent") return gross * Math.min(Number(tier.rewardValue) || 0, 100) / 100;
  return Math.min((Number(tier.rewardValue) || 0) * qty, gross); // amount = $ off per unit
}

// Bundle deal: the first `minQty` units cost a flat `bundlePrice`; each unit beyond
// that is `extraUnit`. Below minQty, regular price applies (no discount). Returns the
// dollar discount off the line's gross so it plugs into the same per-line engine.
// e.g. minQty 2, bundlePrice 20, extraUnit 10, reg 12 → 1@$12, 2@$20, 3@$30…
function bundleDiscount(deal, unitPrice, qty) {
  const m = Math.max(1, Number(deal.minQty) || 0);
  if (!m || qty < m) return 0;
  const dealTotal = (Number(deal.bundlePrice) || 0) + (qty - m) * (Number(deal.extraUnit) || 0);
  const gross = unitPrice * qty;
  return Math.max(0, gross - dealTotal);
}

function computePricing({ lineItems, deals = [], excluded = new Set(), taxRate = 0, manualType = "none", manualValue = 0 }) {
  const subtotal = lineItems.reduce((s, li) => s + li.price * li.qty, 0);

  // 1) Best single quantity-break OR bundle deal per line
  const qtyDeals = deals.filter(d => d.active && (d.type === "qty" || d.type === "bundle") && !excluded.has(d.id));
  const perLine = {};
  const appliedById = {};
  lineItems.forEach(li => {
    let best = 0, bestDeal = null;
    qtyDeals.forEach(d => {
      if (!dealMatchesLine(d, li)) return;
      let disc = 0;
      if (d.type === "bundle") {
        disc = bundleDiscount(d, li.price, li.qty);
      } else {
        const tier = bestTier(d.tiers, li.qty, "minQty");
        if (!tier) return;
        disc = qtyTierDiscount(tier, li.price, li.qty);
      }
      if (disc > best || (disc === best && bestDeal && (Number(d.priority) || 0) > (Number(bestDeal.priority) || 0))) { best = disc; bestDeal = d; }
    });
    perLine[li.key] = best;
    if (bestDeal && best > 0) {
      if (!appliedById[bestDeal.id]) appliedById[bestDeal.id] = { id: bestDeal.id, name: bestDeal.name, type: bestDeal.type, amount: 0 };
      appliedById[bestDeal.id].amount += best;
    }
  });
  const itemDiscountTotal = Object.values(perLine).reduce((s, v) => s + v, 0);
  const discountedSubtotal = subtotal - itemDiscountTotal;

  // 2) Best single cart-threshold deal on the discounted subtotal
  const cartDeals = deals.filter(d => d.active && d.type === "cart" && !excluded.has(d.id));
  let cartAmt = 0, cartDeal = null;
  cartDeals.forEach(d => {
    const tier = bestTier(d.tiers, discountedSubtotal, "minSubtotal");
    if (!tier) return;
    const disc = tier.rewardType === "percent" ? discountedSubtotal * Math.min(Number(tier.rewardValue) || 0, 100) / 100 : Math.min(Number(tier.rewardValue) || 0, discountedSubtotal);
    if (disc > cartAmt || (disc === cartAmt && cartDeal && (Number(d.priority) || 0) > (Number(cartDeal.priority) || 0))) { cartAmt = disc; cartDeal = d; }
  });
  cartAmt = Math.min(cartAmt, discountedSubtotal);
  const afterCart = discountedSubtotal - cartAmt;

  // 3) Manual seller discount on top
  let manual = 0;
  if (manualType === "percent") manual = afterCart * Math.min(Number(manualValue) || 0, 100) / 100;
  else if (manualType === "dollar") manual = Math.min(Number(manualValue) || 0, afterCart);
  const afterAll = afterCart - manual;

  // 4) Tax: spread cart+manual discounts proportionally, tax only taxable lines
  const cartLevelDiscount = cartAmt + manual;
  const factor = discountedSubtotal > 0 ? (discountedSubtotal - cartLevelDiscount) / discountedSubtotal : 0;
  let taxableAmount = 0;
  lineItems.forEach(li => {
    const itemNet = li.price * li.qty - (perLine[li.key] || 0);
    if (li.taxable) taxableAmount += itemNet * factor;
  });
  const rate = Number(taxRate) || 0;
  const tax = taxableAmount * rate / 100;
  const total = afterAll + tax;

  const appliedDeals = Object.values(appliedById);
  if (cartDeal && cartAmt > 0) appliedDeals.push({ id: cartDeal.id, name: cartDeal.name, type: "cart", amount: cartAmt });

  return {
    subtotal, itemDiscountTotal, cartDiscount: cartAmt, manualDiscount: manual,
    totalDiscount: itemDiscountTotal + cartAmt + manual,
    discountedSubtotal, afterAll, taxableAmount, taxRate: rate, tax, total, perLine, appliedDeals,
  };
}

// Wrap a value for CSV (quote if it contains comma, quote, or newline)
function csvCell(v) {
  const s = v == null ? "" : String(v);
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

// Build the CSV text. `rows` are inventory-style objects; `costOf` optionally
// returns a unit material cost for a row.
function buildSyncrostoreCsv(rows, costOf) {
  const today = new Date().toISOString().slice(0, 10);
  const lines = [SYNCRO_HEADERS.map(csvCell).join(",")];
  rows.forEach(r => {
    const price = Number(r.price || 0);
    const cost = costOf ? costOf(r) : "";
    const cells = {
      "SKU": r.sku || makeSku(r.name, r.size),
      "Description *": r.flavor ? `${r.name} (${r.flavor})` : r.name,
      "Long Description": [r.flavor, r.size].filter(Boolean).join(" · "),
      "Price": `$${price.toFixed(2)}`,
      "Cost": (cost === "" || cost == null) ? "" : `$${Number(cost).toFixed(2)}`,
      "Quantity": Number(r.qty || 0),
      "Brand": "Nashville Bee Company",
      "Condition": "New",
      "Category": r.category || "",
      "Vendor Name": "Nashville Bee Company",
      "Date Purchased": today,
      "Tax Exempt": "FALSE",
    };
    lines.push(SYNCRO_HEADERS.map(h => csvCell(cells[h] ?? "")).join(","));
  });
  return lines.join("\n");
}

// Trigger a browser download of a CSV file.
function downloadCsv(filename, text) {
  const blob = new Blob([text], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = filename;
  document.body.appendChild(a); a.click();
  document.body.removeChild(a); URL.revokeObjectURL(url);
}

// Parse CSV text into an array of row objects keyed by header.
function parseCsv(text) {
  const rows = [];
  let field = "", row = [], inQuotes = false;
  const pushField = () => { row.push(field); field = ""; };
  const pushRow = () => { pushField(); rows.push(row); row = []; };
  const s = String(text).replace(/\r\n/g, "\n").replace(/\r/g, "\n");
  for (let i = 0; i < s.length; i++) {
    const ch = s[i];
    if (inQuotes) {
      if (ch === '"') { if (s[i + 1] === '"') { field += '"'; i++; } else inQuotes = false; }
      else field += ch;
    } else {
      if (ch === '"') inQuotes = true;
      else if (ch === ",") pushField();
      else if (ch === "\n") pushRow();
      else field += ch;
    }
  }
  if (field.length > 0 || row.length > 0) pushRow();
  if (rows.length === 0) return [];
  const headers = rows[0].map(h => h.trim());
  return rows.slice(1)
    .filter(r => r.some(c => String(c).trim() !== ""))
    .map(r => { const obj = {}; headers.forEach((h, idx) => { obj[h] = r[idx] != null ? r[idx] : ""; }); return obj; });
}

// Strip $ and commas from a number cell.
function parseNum(v) {
  if (v == null) return 0;
  const n = parseFloat(String(v).replace(/[$,\s]/g, ""));
  return isNaN(n) ? 0 : n;
}

function StockBadge({ qty, low }) {
  const type = qty === 0 ? "low" : qty <= low ? "warn" : "ok";
  const label = qty === 0 ? "Out of stock" : qty <= low ? "Low stock" : "In stock";
  return <span style={styles.badge(type)}>{label}</span>;
}

function Field({ label, children }) {
  return <div style={styles.formRow}><label style={styles.label}>{label}</label>{children}</div>;
}

function Modal({ title, onClose, children, wide }) {
  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", zIndex: 100, display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div className="app-modal" style={{ background: C.surface, borderRadius: 14, padding: 28, minWidth: 360, maxWidth: wide ? 760 : 500, width: "90%", boxShadow: "0 20px 60px rgba(0,0,0,0.2)", maxHeight: "90vh", overflowY: "auto" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
          <span style={{ fontSize: 17, fontWeight: 700, color: C.amber }}>{title}</span>
          <button onClick={onClose} style={{ ...styles.btn("ghost"), padding: "4px 10px", fontSize: 18 }}>×</button>
        </div>
        {children}
      </div>
    </div>
  );
}

// ── ResponsiveTable: a normal table on desktop, stacked cards on phones ─────
// columns: [{ key, header, render?, primary?, strong? }]
//   primary: shown as the card's bold title; render: custom cell content
// rows: array of data objects (must have a stable `id`)
// actions: optional (row) => JSX, shown in a footer row on cards / last column on table
// emptyText: shown when no rows
function ResponsiveTable({ columns, rows, actions, emptyText, getRowKey, groups, onToggleGroup }) {
  const key = getRowKey || ((r) => r.id);
  const cell = (col, row) => (col.render ? col.render(row) : row[col.key]);
  const totalCols = columns.length + (actions ? 1 : 0);

  const desktopRow = (row) => (
    <tr key={key(row)}>
      {columns.map(c => (
        <td key={c.key} style={{ ...styles.td, ...(c.strong ? { fontWeight: 700 } : {}), ...(c.primary ? { fontWeight: 600 } : {}), ...(c.tdStyle ? c.tdStyle(row) : {}) }}>{cell(c, row)}</td>
      ))}
      {actions && <td style={styles.td}>{actions(row)}</td>}
    </tr>
  );
  const mobileCard = (row) => {
    const primaryCol = columns.find(c => c.primary);
    const rest = columns.filter(c => !c.primary && !c.hideOnCard);
    return (
      <div key={key(row)} style={{ border: `1px solid ${C.border}`, borderRadius: 10, padding: 14, marginBottom: 12, background: C.bg }}>
        {primaryCol && <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 8, color: C.amber }}>{cell(primaryCol, row)}</div>}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px 14px" }}>
          {rest.map(c => (
            <div key={c.key} style={{ display: "flex", flexDirection: "column" }}>
              <span style={{ fontSize: 11, fontWeight: 600, color: C.muted, textTransform: "uppercase", letterSpacing: "0.3px" }}>{c.header}</span>
              <span style={{ fontSize: 15, ...(c.tdStyle ? c.tdStyle(row) : {}) }}>{cell(c, row)}</span>
            </div>
          ))}
        </div>
        {actions && <div style={{ display: "flex", gap: 8, marginTop: 12, flexWrap: "wrap" }}>{actions(row)}</div>}
      </div>
    );
  };

  // Grouped mode: collapsible sub-groups (e.g. size variants under one product name).
  if (groups) {
    const headerLabel = (g) => (
      <>{g.title}{g.summary ? <span style={{ fontWeight: 600, color: C.textSoft, fontSize: 12 }}> · {g.summary}</span> : null}</>
    );
    return (
      <>
        <table className="rt-table" style={styles.table}>
          <thead><tr>
            {columns.map(c => <th key={c.key} style={styles.th}>{c.header}</th>)}
            {actions && <th style={styles.th}></th>}
          </tr></thead>
          <tbody>
            {groups.length === 0 && <tr><td colSpan={totalCols} style={styles.empty}>{emptyText}</td></tr>}
            {groups.map(g => g.collapsible ? (
              <Fragment key={g.key}>
                <tr onClick={() => onToggleGroup && onToggleGroup(g.key)} style={{ cursor: "pointer", background: C.goldLight }}>
                  <td colSpan={totalCols} style={{ ...styles.td, fontWeight: 700, color: C.goldDark }}>
                    <span style={{ color: C.muted, marginRight: 6 }}>{g.collapsed ? "▸" : "▾"}</span>{headerLabel(g)}
                  </td>
                </tr>
                {!g.collapsed && g.rows.map(desktopRow)}
              </Fragment>
            ) : <Fragment key={g.key}>{g.rows.map(desktopRow)}</Fragment>)}
          </tbody>
        </table>

        <div className="rt-cards">
          {groups.length === 0 && <div style={styles.empty}>{emptyText}</div>}
          {groups.map(g => g.collapsible ? (
            <div key={g.key} style={{ marginBottom: 10 }}>
              <div onClick={() => onToggleGroup && onToggleGroup(g.key)} style={{ display: "flex", alignItems: "center", gap: 6, padding: "10px 12px", fontWeight: 700, color: C.goldDark, cursor: "pointer", background: C.goldLight, borderRadius: 8 }}>
                <span style={{ color: C.muted }}>{g.collapsed ? "▸" : "▾"}</span>{headerLabel(g)}
              </div>
              {!g.collapsed && <div style={{ marginTop: 10 }}>{g.rows.map(mobileCard)}</div>}
            </div>
          ) : <Fragment key={g.key}>{g.rows.map(mobileCard)}</Fragment>)}
        </div>
      </>
    );
  }

  return (
    <>
      {/* Desktop / wide: table */}
      <table className="rt-table" style={styles.table}>
        <thead><tr>
          {columns.map(c => <th key={c.key} style={styles.th}>{c.header}</th>)}
          {actions && <th style={styles.th}></th>}
        </tr></thead>
        <tbody>
          {rows.length === 0 && <tr><td colSpan={totalCols} style={styles.empty}>{emptyText}</td></tr>}
          {rows.map(desktopRow)}
        </tbody>
      </table>

      {/* Mobile: stacked cards */}
      <div className="rt-cards">
        {rows.length === 0 && <div style={styles.empty}>{emptyText}</div>}
        {rows.map(mobileCard)}
      </div>
    </>
  );
}

// ── Order Table (shared between General, Store, Event) ────────────────────
function OrderTable({ orders, dispatch, showEvent = false, onFulfill, historyTitle = "Order History" }) {
  const pending = orders.filter(o => o.status === "Pending");
  const fulfilled = orders.filter(o => o.status === "Fulfilled");
  const [edit, setEdit] = useState(null); // order being edited
  const [form, setForm] = useState({});

  const openEdit = (o) => { setForm({ date: o.date || "", customer: o.customer || "", items: o.items || "", total: o.total ?? "" }); setEdit(o); };
  const closeEdit = () => setEdit(null);
  const saveEdit = () => {
    dispatch({ type: "UPDATE", id: edit.id, changes: { date: form.date, customer: form.customer, items: form.items, total: Number(form.total) || 0 } });
    closeEdit();
  };

  const orderColumns = [
    { key: "date", header: "Date" },
    ...(showEvent ? [{ key: "event", header: "Event", primary: true }] : []),
    { key: "customer", header: "Customer", primary: !showEvent },
    { key: "items", header: "Items", render: o => <span style={{ color: C.muted }}>{o.items}</span> },
    { key: "total", header: "Total", render: o => `$${Number(o.total).toFixed(2)}`, strong: true },
  ];

  return (
    <div>
      {pending.length > 0 && (
        <div className="app-card" style={styles.card}>
          <div style={styles.sectionTitle}>Pending Orders</div>
          <ResponsiveTable
            rows={pending}
            emptyText="No pending orders."
            columns={orderColumns}
            actions={o => (
              <>
                <button style={{ ...styles.btn("sage"), fontSize: 12, padding: "5px 12px" }} onClick={() => onFulfill(o.id)}>Mark Fulfilled</button>
                <button style={{ ...styles.btn("ghost"), fontSize: 12, padding: "5px 10px", marginLeft: 6 }} onClick={() => openEdit(o)}>Edit</button>
                <button style={{ ...styles.btn("danger"), fontSize: 12, padding: "5px 10px", marginLeft: 6 }} onClick={() => dispatch({ type: "DELETE", id: o.id })}>Remove</button>
              </>
            )}
          />
        </div>
      )}

      <div className="app-card" style={styles.card}>
        <div style={styles.sectionTitle}>{historyTitle}</div>
        <ResponsiveTable
          rows={[...fulfilled].reverse()}
          emptyText="No fulfilled orders yet."
          columns={[...orderColumns, { key: "status", header: "Status", render: () => <span style={styles.badge("ok")}>Fulfilled</span> }]}
          actions={o => (
            <>
              <button style={{ ...styles.btn("ghost"), fontSize: 12, padding: "5px 10px" }} onClick={() => openEdit(o)}>Edit</button>
              <button style={{ ...styles.btn("danger"), fontSize: 12, padding: "5px 10px", marginLeft: 6 }} onClick={() => dispatch({ type: "DELETE", id: o.id })}>Remove</button>
            </>
          )}
        />
      </div>

      {edit && (
        <Modal title="Edit Sale" onClose={closeEdit}>
          <Field label="Date"><input style={styles.input} type="date" value={form.date} onChange={e => setForm({ ...form, date: e.target.value })} /></Field>
          <Field label="Customer"><input style={styles.input} value={form.customer} onChange={e => setForm({ ...form, customer: e.target.value })} placeholder="Customer" /></Field>
          <Field label="Items"><input style={styles.input} value={form.items} onChange={e => setForm({ ...form, items: e.target.value })} placeholder="e.g. Wildflower 8oz x2" /></Field>
          <Field label="Total ($)"><input style={styles.input} type="number" step="any" value={form.total} onChange={e => setForm({ ...form, total: e.target.value })} /></Field>
          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 8 }}>
            <button style={styles.btn("ghost")} onClick={closeEdit}>Cancel</button>
            <button style={styles.btn("primary")} onClick={saveEdit}>Save Changes</button>
          </div>
        </Modal>
      )}
    </div>
  );
}

// ── Orders (General) ───────────────────────────────────────────────────────
function Orders({ orders, dispatch }) {
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({});
  const openAdd = () => { setForm({ date: new Date().toISOString().slice(0, 10), customer: "", items: "", total: "", status: "Pending" }); setModal(true); };
  const close = () => setModal(false);
  const save = () => {
    if (!form.customer) return;
    dispatch({ type: "ADD", item: { ...form, total: Number(form.total) || 0 } });
    close();
  };
  const pending = orders.filter(o => o.status === "Pending");
  const fulfilled = orders.filter(o => o.status === "Fulfilled");

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
        <div style={{ display: "flex", gap: 12 }}>
          <div style={styles.statCard(C.goldLight)}><div style={{ ...styles.statNum, fontSize: 22 }}>{pending.length}</div><div style={styles.statLabel}>Pending</div></div>
          <div style={styles.statCard(C.sageLight)}><div style={{ ...styles.statNum, fontSize: 22, color: C.sageDark }}>{fulfilled.length}</div><div style={styles.statLabel}>Fulfilled</div></div>
        </div>
        <button style={styles.btn("primary")} onClick={openAdd}>+ New Order</button>
      </div>
      <OrderTable orders={orders} dispatch={dispatch} onFulfill={id => dispatch({ type: "UPDATE", id, changes: { status: "Fulfilled" } })} />
      {modal && (
        <Modal title="New Order" onClose={close}>
          <div className="grid-2" style={styles.grid2}>
            <Field label="Date"><input style={styles.input} type="date" value={form.date || ""} onChange={e => setForm({ ...form, date: e.target.value })} /></Field>
            <Field label="Customer Name"><input style={styles.input} value={form.customer || ""} onChange={e => setForm({ ...form, customer: e.target.value })} placeholder="e.g. Jane Smith" /></Field>
          </div>
          <Field label="Items"><input style={styles.input} value={form.items || ""} onChange={e => setForm({ ...form, items: e.target.value })} placeholder="e.g. Wildflower 8oz x4" /></Field>
          <div className="grid-2" style={styles.grid2}>
            <Field label="Total ($)"><input style={styles.input} type="number" value={form.total ?? ""} onChange={e => setForm({ ...form, total: e.target.value })} /></Field>
            <Field label="Status">
              <select style={styles.input} value={form.status || "Pending"} onChange={e => setForm({ ...form, status: e.target.value })}>
                <option>Pending</option><option>Fulfilled</option>
              </select>
            </Field>
          </div>
          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 8 }}>
            <button style={styles.btn("ghost")} onClick={close}>Cancel</button>
            <button style={styles.btn("primary")} onClick={save}>Save Order</button>
          </div>
        </Modal>
      )}
    </div>
  );
}

// ── Receipt generation (opens a printable/savable receipt in a new window) ──
// Builds the receipt's inner HTML (used by both the popup and the shared-link viewer).
function buildReceiptInnerHtml(businessName, venueLabel, sale) {
  const lines = (sale.lineItems || []).map(li =>
    `<tr><td style="padding:6px 0;">${li.name} ${li.size || ""}</td><td style="text-align:center;">${li.qty}</td><td style="text-align:right;">$${Number(li.price).toFixed(2)}</td><td style="text-align:right;">$${(Number(li.price) * Number(li.qty)).toFixed(2)}</td></tr>`
  ).join("");
  const cust = [];
  if (sale.customerName) cust.push(`<div>${sale.customerName}</div>`);
  if (sale.customerEmail) cust.push(`<div>${sale.customerEmail}</div>`);
  if (sale.customerPhone) cust.push(`<div>${sale.customerPhone}</div>`);
  const custBlock = cust.length ? `<div style="margin:16px 0;color:#444;font-size:14px;">${cust.join("")}</div>` : "";
  return `
  <h1>🍯 ${businessName}</h1>
  <div class="sub">${venueLabel} sale · ${sale.date}</div>
  ${custBlock}
  <table>
    <thead><tr><th>Item</th><th>Qty</th><th>Price</th><th>Total</th></tr></thead>
    <tbody>${lines}</tbody>
  </table>
  ${(sale.discountAmount > 0 || sale.tax > 0) ? `<div style="display:flex;justify-content:space-between;color:#7a6a55;font-size:13px;margin-top:10px;"><span>Subtotal</span><span>$${Number(sale.subtotal).toFixed(2)}</span></div>` : ""}
  ${sale.discountAmount > 0 ? `<div style="display:flex;justify-content:space-between;color:#b00020;font-size:13px;"><span>Discount${sale.discountLabel ? ` (${sale.discountLabel})` : ""}</span><span>−$${Number(sale.discountAmount).toFixed(2)}</span></div>` : ""}
  ${sale.tax > 0 ? `<div style="display:flex;justify-content:space-between;color:#7a6a55;font-size:13px;"><span>Tax (${Number(sale.taxRate || 0)}%)</span><span>$${Number(sale.tax).toFixed(2)}</span></div>` : ""}
  <div class="total"><span>Total</span><span>$${Number(sale.total).toFixed(2)}</span></div>
  ${sale.payment ? `<div style="text-align:right;color:#7a6a55;font-size:13px;margin-top:6px;">Paid by ${sale.payment}</div>` : ""}
  <div class="thanks">Thank you for your purchase!</div>`;
}

const RECEIPT_CSS = `
  body{font-family:'Helvetica Neue',Arial,sans-serif;max-width:420px;margin:30px auto;padding:0 24px;color:#1a0f00;}
  h1{font-size:22px;margin:0 0 2px;}
  .sub{color:#7a6a55;font-size:13px;margin-bottom:20px;}
  table{width:100%;border-collapse:collapse;font-size:14px;}
  thead th{text-align:left;border-bottom:2px solid #e8a020;padding-bottom:6px;font-size:12px;text-transform:uppercase;letter-spacing:.4px;color:#b87a10;}
  thead th:nth-child(2){text-align:center;}
  thead th:nth-child(3),thead th:nth-child(4){text-align:right;}
  .total{border-top:2px solid #e8a020;margin-top:12px;padding-top:12px;display:flex;justify-content:space-between;font-size:18px;font-weight:800;}
  .thanks{margin-top:24px;color:#7a6a55;font-size:13px;text-align:center;}
  .btns{margin-top:24px;text-align:center;}
  button,.btns a{background:#e8a020;color:#2d1b00;border:none;border-radius:8px;padding:10px 18px;font-weight:700;font-size:14px;cursor:pointer;margin:4px;text-decoration:none;display:inline-block;}
  @media print{.btns{display:none;}}`;

// Encode a sale into a shareable receipt link (data lives in the URL, no storage needed).
function buildReceiptLink(businessName, venueLabel, sale) {
  const payload = { b: businessName, v: venueLabel, s: sale };
  // base64-encode UTF-8 JSON safely
  const json = JSON.stringify(payload);
  const b64 = btoa(unescape(encodeURIComponent(json)));
  const base = window.location.origin + window.location.pathname;
  return `${base}#receipt=${b64}`;
}

function openReceipt({ businessName, venueLabel, sale, authToken, functionUrl }) {
  const link = buildReceiptLink(businessName, venueLabel, sale);
  const inner = buildReceiptInnerHtml(businessName, venueLabel, sale);

  // Text still hands off to the phone's Messages app with a link to the receipt.
  const msgText = `Here's your receipt from ${businessName}: ${link}`;
  const smsHref = `sms:${sale.customerPhone || ""}?&body=${encodeURIComponent(msgText)}`;

  const canEmail = !!(sale.customerEmail && authToken && functionUrl);
  // Data the in-window script needs to auto-send the email.
  const emailPayload = JSON.stringify({ to: sale.customerEmail || "", businessName, venueLabel, sale });

  const html = `<!DOCTYPE html><html><head><meta charset="utf-8"><meta name="viewport" content="width=device-width, initial-scale=1"><title>Receipt</title>
<style>${RECEIPT_CSS}</style></head><body>
  ${inner}
  <div class="btns">
    <button onclick="window.print()">🖨 Print / Save PDF</button>
    <a href="${smsHref}">💬 Text</a>
    ${canEmail ? `<button id="emailBtn" onclick="sendEmail()">✉️ Email</button>` : ""}
  </div>
  <div id="emailStatus" style="text-align:center;color:#9a8a75;font-size:12px;margin-top:14px;">${canEmail ? "Text opens your Messages app. Email sends automatically to the customer." : "Text opens your Messages app with the receipt link."}</div>
  <script>
    function sendEmail() {
      var btn = document.getElementById('emailBtn');
      var status = document.getElementById('emailStatus');
      btn.disabled = true; btn.textContent = 'Sending…';
      fetch(${JSON.stringify(functionUrl || "")}, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + ${JSON.stringify(authToken || "")} },
        body: ${JSON.stringify(emailPayload)}
      }).then(function(r){
        if (r.ok) { status.textContent = '✅ Receipt emailed to the customer.'; btn.textContent = '✉️ Emailed'; }
        else { status.textContent = '⚠️ Email failed to send. You can use Text or Print instead.'; btn.disabled = false; btn.textContent = '✉️ Email'; }
      }).catch(function(){
        status.textContent = '⚠️ Email failed to send. You can use Text or Print instead.'; btn.disabled = false; btn.textContent = '✉️ Email';
      });
    }
  </script>
</body></html>`;

  const w = window.open("", "_blank");
  if (w) { w.document.write(html); w.document.close(); }
  else { alert("Please allow pop-ups to view the receipt."); }
}

// Opens the receipt window, attaching the current session token + function URL so
// the in-window Email button can auto-send via the edge function.
async function openReceiptWithAuth({ businessName, venueLabel, sale }) {
  let authToken = "";
  try {
    const { data } = await supabase.auth.getSession();
    authToken = data?.session?.access_token || "";
  } catch { /* no session token available */ }
  const functionUrl = `${SUPABASE_URL}/functions/v1/send-receipt`;
  openReceipt({ businessName, venueLabel, sale, authToken, functionUrl });
}

// If the page is opened with a #receipt=... link, render just the receipt.
// Returns true if it handled (rendered) a receipt, so the app can skip mounting.
export function renderReceiptFromHashIfPresent() {
  const hash = window.location.hash || "";
  const m = hash.match(/receipt=(.+)$/);
  if (!m) return false;
  try {
    const json = decodeURIComponent(escape(atob(m[1])));
    const { b, v, s } = JSON.parse(json);
    document.title = `Receipt — ${b}`;
    const style = document.createElement("style");
    style.textContent = RECEIPT_CSS;
    document.head.appendChild(style);
    document.body.innerHTML = buildReceiptInnerHtml(b, v, s) +
      `<div class="btns"><button onclick="window.print()">🖨 Print / Save PDF</button></div>`;
    return true;
  } catch {
    return false;
  }
}

// ── Multi-item Sale modal (used by Event and Single Sale) ──────────────────
// `source` is the list of sellable rows (each needs id, name, size, price, qty available).
function MultiSaleModal({ title, source, onClose, onConfirm, sectionOrder = [], deals = [], taxRate = 0 }) {
  // cart: { [sourceId]: qty }
  const [cart, setCart] = useState({});
  const [customerName, setCustomerName] = useState("");
  const [customerEmail, setCustomerEmail] = useState("");
  const [customerPhone, setCustomerPhone] = useState("");
  const [payment, setPayment] = useState("");
  const [discountType, setDiscountType] = useState("none"); // "none" | "percent" | "dollar"
  const [discountValue, setDiscountValue] = useState("");
  const [excludedDeals, setExcludedDeals] = useState({}); // { dealId: true }
  const [addToList, setAddToList] = useState(true);

  const find = (id) => source.find(s => String(s.id) === String(id));
  const available = (id) => Number(find(id)?.qty || 0);

  const addOne = (s) => {
    const cur = cart[s.id] || 0;
    if (cur >= Number(s.qty)) return; // don't exceed available
    setCart({ ...cart, [s.id]: cur + 1 });
  };
  const removeOne = (id) => {
    const cur = cart[id] || 0;
    if (cur <= 1) { const c = { ...cart }; delete c[id]; setCart(c); }
    else setCart({ ...cart, [id]: cur - 1 });
  };

  const lineItems = Object.entries(cart).map(([id, qty]) => {
    const s = find(id);
    if (!s) return null;
    return { key: String(s.id), sourceId: s.id, name: s.name, size: s.size, price: Number(s.price || 0), qty: Number(qty), lineTotal: Number(s.price || 0) * Number(qty), taxable: s.taxable !== false, sku: s.sku || "", section: s.section || "" };
  }).filter(Boolean);

  const excludedSet = new Set(Object.keys(excludedDeals).filter(k => excludedDeals[k]));
  const pricing = computePricing({
    lineItems, deals, excluded: excludedSet, taxRate,
    manualType: discountType, manualValue: Number(discountValue) || 0,
  });
  const subtotal = pricing.subtotal;
  const total = pricing.total;
  const itemCount = lineItems.reduce((sum, li) => sum + li.qty, 0);
  const valid = lineItems.length > 0;
  const dealDiscount = pricing.itemDiscountTotal + pricing.cartDiscount;
  // Deals that WOULD apply with nothing excluded — the stable confirmation list.
  const detectedDeals = computePricing({ lineItems, deals, excluded: new Set(), taxRate }).appliedDeals;

  // A readable label that summarizes deals + manual discount for the order history.
  const dealNames = pricing.appliedDeals.map(d => d.name);
  if (pricing.manualDiscount > 0) dealNames.push(discountType === "percent" ? `${Number(discountValue) || 0}% off` : `$${(Number(discountValue) || 0).toFixed(2)} off`);
  const discountLabel = dealNames.join(" + ");

  const confirm = (receiptMode) => {
    if (!valid) return;
    onConfirm({
      lineItems,
      subtotal,
      discountAmount: pricing.totalDiscount,
      discountLabel: pricing.totalDiscount > 0 ? discountLabel : "",
      appliedDeals: pricing.appliedDeals,
      netSubtotal: pricing.afterAll,   // pre-tax, after all discounts
      taxRate: pricing.taxRate,
      tax: pricing.tax,
      total,
      payment,
      customerName: customerName.trim(),
      customerEmail: customerEmail.trim(),
      customerPhone: customerPhone.trim(),
      addToList,
      date: new Date().toISOString().slice(0, 10),
    }, receiptMode);
  };
  const hasEmail = customerEmail.trim().length > 0;

  const payOptions = ["Cash", "Square", "Venmo"];

  return (
    <Modal title={title} onClose={onClose}>
      {/* Tap-to-add product grid */}
      <label style={styles.label}>Tap items to add</label>
      <div className="sale-grid" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginBottom: 14, maxHeight: 260, overflowY: "auto" }}>
        {(() => {
          const groups = groupSourceBySection(source, sectionOrder);
          const showHeaders = groups.length > 1 || (groups[0] && groups[0].name !== "Uncategorized");
          const renderBtn = (s) => {
            const inCart = cart[s.id] || 0;
            const soldOut = Number(s.qty) <= 0;
            const maxed = inCart >= Number(s.qty);
            return (
              <button key={s.id} disabled={soldOut || maxed} onClick={() => addOne(s)}
                style={{
                  textAlign: "left", padding: "10px 12px", borderRadius: 10, cursor: soldOut || maxed ? "not-allowed" : "pointer",
                  border: `1.5px solid ${inCart > 0 ? C.gold : C.border}`, background: inCart > 0 ? C.goldLight : C.surface,
                  opacity: soldOut ? 0.4 : 1,
                }}>
                <div style={{ fontWeight: 600, fontSize: 14 }}>{s.name}</div>
                <div style={{ fontSize: 12, color: C.muted }}>{s.size} · ${Number(s.price || 0).toFixed(2)} · {s.qty} left</div>
                {inCart > 0 && <div style={{ fontSize: 12, fontWeight: 700, color: C.goldDark, marginTop: 2 }}>In cart: {inCart}</div>}
              </button>
            );
          };
          const els = [];
          if (source.length === 0) els.push(<div key="empty" style={{ ...styles.empty, gridColumn: "1 / -1" }}>No inventory available to sell.</div>);
          groups.forEach(g => {
            if (showHeaders) els.push(<div key={`h-${g.name}`} style={{ gridColumn: "1 / -1", fontSize: 11, fontWeight: 800, color: C.goldDark, textTransform: "uppercase", letterSpacing: "0.5px", padding: "6px 2px 2px", position: "sticky", top: 0, background: C.surface, zIndex: 1 }}>{g.name}</div>);
            g.rows.forEach(s => els.push(renderBtn(s)));
          });
          return els;
        })()}
      </div>

      {/* Cart with steppers */}
      {lineItems.length > 0 && (
        <div style={{ padding: 12, background: C.bg, borderRadius: 8, border: `1px solid ${C.border}`, marginBottom: 14 }}>
          {lineItems.map(li => (
            <div key={li.sourceId} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "6px 0", borderBottom: `1px solid ${C.border}` }}>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 14, fontWeight: 600 }}>{li.name} <span style={{ color: C.muted, fontWeight: 400 }}>{li.size}</span></div>
                <div style={{ fontSize: 12, color: C.muted }}>${li.price.toFixed(2)} each</div>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <button style={{ ...styles.btn("ghost"), padding: "2px 10px", fontSize: 18, lineHeight: 1 }} onClick={() => removeOne(li.sourceId)}>−</button>
                <span style={{ minWidth: 20, textAlign: "center", fontWeight: 700 }}>{li.qty}</span>
                <button style={{ ...styles.btn("ghost"), padding: "2px 10px", fontSize: 18, lineHeight: 1, opacity: li.qty >= available(li.sourceId) ? 0.4 : 1, cursor: li.qty >= available(li.sourceId) ? "not-allowed" : "pointer" }} disabled={li.qty >= available(li.sourceId)} onClick={() => addOne(find(li.sourceId))}>+</button>
                <span style={{ minWidth: 56, textAlign: "right", fontWeight: 700 }}>${li.lineTotal.toFixed(2)}</span>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Payment type */}
      <label style={styles.label}>Payment</label>
      <div style={{ display: "flex", gap: 8, marginBottom: 14 }}>
        {payOptions.map(opt => (
          <button key={opt} onClick={() => setPayment(payment === opt ? "" : opt)} style={styles.subNavBtn(payment === opt)}>{opt}</button>
        ))}
      </div>

      {detectedDeals.length > 0 && (
        <div style={{ marginBottom: 14, padding: "10px 14px", background: C.goldLight, border: `1px solid ${C.gold}`, borderRadius: 8 }}>
          <div style={{ fontSize: 12, fontWeight: 800, color: C.goldDark, textTransform: "uppercase", letterSpacing: "0.4px", marginBottom: 8 }}>Deals detected — confirm to apply</div>
          {detectedDeals.map(d => (
            <label key={d.id} style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, padding: "4px 0", cursor: "pointer" }}>
              <input type="checkbox" checked={!excludedDeals[d.id]} onChange={e => setExcludedDeals({ ...excludedDeals, [d.id]: !e.target.checked })} style={{ width: 16, height: 16 }} />
              <span style={{ flex: 1 }}>{d.name}</span>
              <span style={{ fontWeight: 700, color: excludedDeals[d.id] ? C.textSoft : C.sageDark, textDecoration: excludedDeals[d.id] ? "line-through" : "none" }}>−${d.amount.toFixed(2)}</span>
            </label>
          ))}
        </div>
      )}

      {/* Discount */}
      <label style={styles.label}>Manual discount (optional)</label>
      <div style={{ display: "flex", gap: 8, marginBottom: discountType === "none" ? 14 : 8 }}>
        <button style={styles.subNavBtn(discountType === "none")} onClick={() => { setDiscountType("none"); setDiscountValue(""); }}>None</button>
        <button style={styles.subNavBtn(discountType === "percent")} onClick={() => setDiscountType("percent")}>% Off</button>
        <button style={styles.subNavBtn(discountType === "dollar")} onClick={() => setDiscountType("dollar")}>$ Off</button>
      </div>
      {discountType !== "none" && (
        <input style={{ ...styles.input, marginBottom: 14 }} type="number" min="0" value={discountValue} onChange={e => setDiscountValue(e.target.value)} placeholder={discountType === "percent" ? "Percent off (e.g. 10)" : "Dollars off (e.g. 2.00)"} autoFocus />
      )}

      {/* Optional customer */}
      <div style={{ padding: 14, background: C.bg, borderRadius: 8, border: `1px solid ${C.border}`, marginBottom: 14 }}>
        <label style={{ ...styles.label, marginBottom: 8 }}>Customer (all optional)</label>
        <input style={{ ...styles.input, marginBottom: 8 }} value={customerName} onChange={e => setCustomerName(e.target.value)} placeholder="Name" />
        <div className="grid-2" style={styles.grid2}>
          <input style={styles.input} value={customerEmail} onChange={e => setCustomerEmail(e.target.value)} placeholder="Email" />
          <input style={styles.input} value={customerPhone} onChange={e => setCustomerPhone(e.target.value)} placeholder="Phone" />
        </div>
        {(customerName.trim() || customerEmail.trim() || customerPhone.trim()) && (
          <label style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 10, fontSize: 13, color: C.muted, cursor: "pointer" }}>
            <input type="checkbox" checked={addToList} onChange={e => setAddToList(e.target.checked)} style={{ width: 16, height: 16 }} />
            Add this customer to the customer list
          </label>
        )}
      </div>

      {/* Running total */}
      <div style={{ padding: "12px 14px", background: C.sageLight, borderRadius: 8, marginBottom: 16 }}>
        {(pricing.totalDiscount > 0 || pricing.tax > 0) && (
          <div style={{ display: "flex", justifyContent: "space-between", fontSize: 13, color: C.sageDark, marginBottom: 4 }}>
            <span>Subtotal</span><span>${subtotal.toFixed(2)}</span>
          </div>
        )}
        {pricing.itemDiscountTotal > 0 && (
          <div style={{ display: "flex", justifyContent: "space-between", fontSize: 13, color: C.danger, marginBottom: 4 }}>
            <span>Quantity deals</span><span>−${pricing.itemDiscountTotal.toFixed(2)}</span>
          </div>
        )}
        {pricing.cartDiscount > 0 && (
          <div style={{ display: "flex", justifyContent: "space-between", fontSize: 13, color: C.danger, marginBottom: 4 }}>
            <span>Cart deal</span><span>−${pricing.cartDiscount.toFixed(2)}</span>
          </div>
        )}
        {pricing.manualDiscount > 0 && (
          <div style={{ display: "flex", justifyContent: "space-between", fontSize: 13, color: C.danger, marginBottom: 4 }}>
            <span>Manual discount</span><span>−${pricing.manualDiscount.toFixed(2)}</span>
          </div>
        )}
        {pricing.tax > 0 && (
          <div style={{ display: "flex", justifyContent: "space-between", fontSize: 13, color: C.sageDark, marginBottom: 6 }}>
            <span>Tax ({pricing.taxRate}%{pricing.taxableAmount < pricing.afterAll ? " · taxable items only" : ""})</span><span>+${pricing.tax.toFixed(2)}</span>
          </div>
        )}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <span style={{ fontWeight: 600, color: C.sageDark }}>{itemCount} item{itemCount === 1 ? "" : "s"}</span>
          <span style={{ fontSize: 22, fontWeight: 800, color: C.sageDark }}>${total.toFixed(2)}</span>
        </div>
      </div>

      <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", flexWrap: "wrap" }}>
        <button style={styles.btn("ghost")} onClick={onClose}>Cancel</button>
        <button style={{ ...styles.btn("sage"), opacity: valid ? 1 : 0.5, cursor: valid ? "pointer" : "not-allowed" }} disabled={!valid} onClick={() => confirm("none")}>Record Sale</button>
        <button style={{ ...styles.btn("ghost"), opacity: valid ? 1 : 0.5, cursor: valid ? "pointer" : "not-allowed" }} disabled={!valid} onClick={() => confirm("print")}>Record + Print</button>
        {hasEmail && <button style={{ ...styles.btn("primary"), opacity: valid ? 1 : 0.5, cursor: valid ? "pointer" : "not-allowed" }} disabled={!valid} onClick={() => confirm("email")}>Record + Email</button>}
      </div>
    </Modal>
  );
}

// ── Collective sales import (upload their CSV → deduct sold units) ──────────
function CollectiveImportModal({ inv, onClose, onApply, cutPct = 0 }) {
  const [parsed, setParsed] = useState(null); // array of file rows
  const [fileName, setFileName] = useState("");
  const [error, setError] = useState("");
  const [manualMap, setManualMap] = useState({}); // fileRowIndex -> inv.id

  // Two match indexes: the canonical stored SKU (exact round-trip), and a
  // normalized name+size fallback for older stock that predates stored SKUs.
  const bySku = {};
  const byNameSize = {};
  inv.forEach(i => {
    if (i.sku) bySku[String(i.sku).toUpperCase()] = i;
    byNameSize[makeSku(i.name, i.size)] = i;
  });

  const onFile = async (e) => {
    setError(""); setManualMap({});
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    setFileName(file.name);
    try {
      const text = await file.text();
      const rows = parseCsv(text);
      if (rows.length === 0) { setError("That file looks empty or unreadable."); setParsed(null); return; }
      setParsed(rows);
    } catch (err) {
      setError("Could not read that file. Make sure it's a CSV.");
      setParsed(null);
    }
  };

  // Resolve each file row to an inventory line. Quantity = units SOLD.
  const rawRows = (parsed || []).map((r, idx) => {
    const skuCell = String(r["SKU"] || "").trim().toUpperCase();
    const desc = r["Description *"] || r["Description"] || skuCell || "(no description)";
    const soldQty = parseNum(r["Quantity"]);
    let match = (skuCell && bySku[skuCell]) || (skuCell && byNameSize[skuCell]) || null;
    let how = match ? (bySku[skuCell] ? "sku" : "namesize") : null;
    const manualId = manualMap[idx];
    if (manualId) { const m = inv.find(i => i.id === manualId); if (m) { match = m; how = "manual"; } }
    return { idx, skuCell, desc, soldQty, match, how };
  });

  // Aggregate by inventory line (two file rows can hit the same item).
  const agg = {};
  rawRows.forEach(row => {
    if (row.match && row.soldQty > 0) {
      const k = row.match.id;
      if (!agg[k]) agg[k] = { id: k, name: row.match.name, size: row.match.size, sku: row.match.sku || "", price: Number(row.match.price || 0), before: Number(row.match.qty), soldQty: 0 };
      agg[k].soldQty += row.soldQty;
    }
  });
  const matched = Object.values(agg).map(m => ({ ...m, desc: `${m.name} ${m.size}`.trim(), after: Math.max(0, m.before - m.soldQty) }));
  const unmatched = rawRows.filter(r => !r.match && r.soldQty > 0);
  const overSold = matched.filter(p => p.soldQty > p.before);
  const totalUnits = matched.reduce((s, p) => s + p.soldQty, 0);
  const totalRevenue = matched.reduce((s, p) => s + p.soldQty * p.price, 0);
  const manualCount = rawRows.filter(r => r.how === "manual").length;

  const apply = () => { onApply(matched); };

  return (
    <Modal title="Import Collective Sales" onClose={onClose}>
      <p style={{ fontSize: 13, color: C.muted, marginBottom: 14 }}>
        Upload the Collective's sales CSV. Each row's Quantity is read as units sold. Items match by SKU first, then by name + size; anything left over you can map by hand below. Nothing is saved until you confirm.
      </p>

      <Field label="Collective sales CSV file">
        <input type="file" accept=".csv,text/csv" onChange={onFile} style={{ fontSize: 14 }} />
      </Field>
      {fileName && <div style={{ fontSize: 12, color: C.muted, marginBottom: 10 }}>Loaded: {fileName}</div>}
      {error && <div style={{ fontSize: 13, color: C.danger, marginBottom: 10 }}>{error}</div>}

      {parsed && (
        <div style={{ marginTop: 6 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 14px", background: C.sageLight, borderRadius: 8, marginBottom: 12 }}>
            <span style={{ fontWeight: 600, color: C.sageDark }}>{totalUnits} units · {matched.length} items{manualCount > 0 ? ` · ${manualCount} mapped by hand` : ""}</span>
            <span style={{ fontSize: 18, fontWeight: 800, color: C.sageDark }}>${totalRevenue.toFixed(2)}</span>
          </div>
          {Number(cutPct) > 0 && (
            <div style={{ marginTop: 8, paddingTop: 8, borderTop: `1px solid ${C.border}`, fontSize: 13, color: C.muted }}>
              <div style={{ display: "flex", justifyContent: "space-between" }}><span>Collective fee ({Number(cutPct)}%)</span><span style={{ color: C.danger, fontWeight: 600 }}>−${(totalRevenue * Number(cutPct) / 100).toFixed(2)}</span></div>
              <div style={{ display: "flex", justifyContent: "space-between", fontWeight: 700, color: C.text }}><span>Net to you</span><span>${(totalRevenue * (1 - Number(cutPct) / 100)).toFixed(2)}</span></div>
              <div style={{ fontSize: 11, color: C.textSoft, marginTop: 4 }}>The full ${totalRevenue.toFixed(2)} is recorded as sales; the fee is logged as a "Collective Fee" expense.</div>
            </div>
          )}

          {matched.length > 0 && (
            <div style={{ maxHeight: 200, overflowY: "auto", border: `1px solid ${C.border}`, borderRadius: 8, marginBottom: 12 }}>
              {matched.map((p, i) => (
                <div key={i} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 12px", borderBottom: `1px solid ${C.border}`, fontSize: 13 }}>
                  <div><strong>{p.desc}</strong>{p.sku ? <span style={{ color: C.textSoft, fontSize: 11, marginLeft: 6 }}>{p.sku}</span> : null}</div>
                  <div style={{ color: p.soldQty > p.before ? C.danger : C.muted }}>{p.soldQty} sold · {p.before}→{p.after} left</div>
                </div>
              ))}
            </div>
          )}

          {overSold.length > 0 && (
            <div style={{ padding: "10px 14px", background: C.dangerLight, borderRadius: 8, fontSize: 12, color: C.danger, marginBottom: 12 }}>
              Note: {overSold.length} item(s) show more sold than the app had in stock. They'll be set to 0 (not negative). Worth a quick check that counts line up.
            </div>
          )}

          {unmatched.length > 0 && (
            <div style={{ padding: "10px 14px", background: C.dangerLight, borderRadius: 8, marginBottom: 12 }}>
              <div style={{ fontSize: 13, color: C.danger, fontWeight: 700, marginBottom: 8 }}>{unmatched.length} row(s) didn't match — map them to a product or leave unmapped to skip:</div>
              {unmatched.map(u => (
                <div key={u.idx} style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 6 }}>
                  <div style={{ flex: 1, fontSize: 12, color: C.text, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{u.desc} <span style={{ color: C.textSoft }}>({u.soldQty} sold)</span></div>
                  <select style={{ ...styles.input, flex: 1, fontSize: 13, padding: "6px 8px" }} value={manualMap[u.idx] || ""} onChange={e => setManualMap({ ...manualMap, [u.idx]: e.target.value })}>
                    <option value="">— skip —</option>
                    {inv.map(i => <option key={i.id} value={i.id}>{i.name} {i.size}</option>)}
                  </select>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 8 }}>
        <button style={styles.btn("ghost")} onClick={onClose}>Cancel</button>
        <button style={{ ...styles.btn("primary"), opacity: matched.length > 0 ? 1 : 0.5, cursor: matched.length > 0 ? "pointer" : "not-allowed" }} disabled={matched.length === 0} onClick={apply}>Apply {totalUnits} Sales</button>
      </div>
    </Modal>
  );
}

// ── Store View (inventory + newly received + orders) ──────────────────────
function VenueView({ venueLabel, venueIcon, inv, invDispatch, received, receivedDispatch, orders, ordersDispatch, soldTitle, ordersTitle, saleCustomer, allowMultiSale, headerExtra, onReturn, onCloseAll, closeAllLabel, eventId, onUndoReceived, onCaptureCustomer, onLogLoss, onExportCsv, onImportSales, sectionOrder = [], deals = [], taxRate = 0, collectiveCut = 0, setCollectiveCut, onLogFee, defaultSort = "category" }) {
  const totalUnits = inv.reduce((s, i) => s + Number(i.qty), 0);
  const newLabels = received.reduce((s, i) => s + Number(i.qty), 0);
  const [sellItem, setSellItem] = useState(null);
  const [sellQty, setSellQty] = useState("");
  const [multiSale, setMultiSale] = useState(false);
  const [returnItem, setReturnItem] = useState(null);
  const [returnQty, setReturnQty] = useState("");
  const [removeItem, setRemoveItem] = useState(null);
  const [removeQty, setRemoveQty] = useState("");
  const [removeReason, setRemoveReason] = useState("Broken");
  const [showImport, setShowImport] = useState(false);
  const [pendingLabel, setPendingLabel] = useState(null); // {kind:'one'|'all', row?}
  const [invSort, setInvSort] = useState(defaultSort); // name | qty | value | category
  const [sortDir, setSortDir] = useState("asc"); // asc | desc
  const [expandedCats, setExpandedCats] = useState({}); // category groups start collapsed
  const [cutDraft, setCutDraft] = useState(String(collectiveCut || 0));
  useEffect(() => { setCutDraft(String(collectiveCut || 0)); }, [collectiveCut]);

  const openReturn = (item) => { setReturnQty(""); setReturnItem(item); };
  const closeReturn = () => setReturnItem(null);
  const confirmReturn = () => {
    const n = Number(returnQty);
    if (!n || n <= 0) return;
    onReturn(returnItem, n);
    closeReturn();
  };

  const openRemove = (item) => { setRemoveQty(""); setRemoveReason("Broken"); setRemoveItem(item); };
  const closeRemove = () => setRemoveItem(null);
  const confirmRemove = () => {
    const n = Number(removeQty);
    if (!n || n <= 0) return;
    // Log the loss at retail value so it shows in Financials as an inventory loss.
    if (onLogLoss) onLogLoss({ item: removeItem, qty: n, reason: removeReason, venueLabel });
    // Removing the full quantity deletes the line; a partial amount just reduces it.
    if (n >= Number(removeItem.qty)) invDispatch({ type: "DELETE", id: removeItem.id });
    else invDispatch({ type: "SELL", id: removeItem.id, qty: n });
    closeRemove();
  };

  // Marking labeled moves the received batch into Current Inventory (scoped to event if applicable)
  const doMark = (r) => {
    invDispatch({ type: "RECEIVE", product: { name: r.name, size: r.size, flavor: r.flavor, price: r.price, section: r.section || "", sku: r.sku || "", taxable: r.taxable !== false }, qty: r.qty, eventId });
    receivedDispatch({ type: "DELETE", id: r.id });
  };
  // For the Collective (export flow present), confirm the export happened first.
  const markLabeled = (r) => { if (onExportCsv) setPendingLabel({ kind: "one", row: r }); else doMark(r); };
  const clearAllLabeled = () => { if (onExportCsv) setPendingLabel({ kind: "all" }); else received.forEach(doMark); };
  const confirmPendingLabel = () => {
    if (!pendingLabel) return;
    if (pendingLabel.kind === "one") doMark(pendingLabel.row);
    else [...received].forEach(doMark);
    setPendingLabel(null);
  };

  // Record a sale: deduct from venue inventory + add a fulfilled Sold entry
  const recordSale = (item, qty) => {
    const n = Math.min(Number(qty), Number(item.qty));
    if (!n || n <= 0) return;
    invDispatch({ type: "SELL", id: item.id, qty: n });
    ordersDispatch({ type: "ADD", item: {
      date: new Date().toISOString().slice(0, 10),
      customer: saleCustomer,
      items: `${item.name} ${item.size} x${n}`,
      total: Number(item.price || 0) * n,
      status: "Fulfilled",
    } });
  };

  const openSell = (item) => { setSellQty(""); setSellItem(item); };
  const closeSell = () => setSellItem(null);
  const confirmSell = () => {
    const n = Number(sellQty);
    if (!n || n <= 0) return;
    recordSale(sellItem, n);
    closeSell();
  };

  // Multi-item sale: deduct each line from inventory, record one combined order
  const confirmMultiSale = (sale, receiptMode) => {
    sale.lineItems.forEach(li => invDispatch({ type: "SELL", id: li.sourceId, qty: li.qty }));
    const itemsText = sale.lineItems.map(li => `${li.name} ${li.size} x${li.qty}`).join(", ");
    const taxNote = sale.tax > 0 ? `tax $${Number(sale.tax).toFixed(2)}` : "";
    const extras = [sale.payment, sale.discountLabel, taxNote].filter(Boolean).join(" · ");
    const custLabel = sale.customerName || saleCustomer;
    ordersDispatch({ type: "ADD", item: {
      date: sale.date,
      customer: custLabel,
      items: extras ? `${itemsText} · ${extras}` : itemsText,
      subtotal: sale.netSubtotal,
      tax: sale.tax || 0,
      total: sale.total,
      status: "Fulfilled",
      payment: sale.payment || "",
      discount: sale.discountLabel || "",
      customerEmail: sale.customerEmail || "",
      customerPhone: sale.customerPhone || "",
    } });
    if (receiptMode === "print" || receiptMode === "email") openReceiptWithAuth({ businessName: "Nashville Bee Company", venueLabel, sale });
    if (onCaptureCustomer) onCaptureCustomer(sale);
    setMultiSale(false);
  };

  // Apply an imported batch of sold items: deduct each from inventory and record one combined sale.
  const applyImport = (matched) => {
    matched.forEach(m => invDispatch({ type: "SELL", id: m.id, qty: m.soldQty }));
    const itemsText = matched.map(m => `${m.name} ${m.size} x${m.soldQty}`).join(", ");
    const total = matched.reduce((s, m) => s + m.soldQty * m.price, 0);
    ordersDispatch({ type: "ADD", item: {
      date: new Date().toISOString().slice(0, 10),
      customer: "Collective (imported)",
      items: itemsText,
      total,
      status: "Fulfilled",
      payment: "",
      discount: "",
      customerEmail: "",
      customerPhone: "",
    } });
    // Record the Collective's commission as an expense so the gross sale stays on the
    // books and the channel cost shows in Financials.
    const fee = total * (Number(collectiveCut) || 0) / 100;
    if (fee > 0 && onLogFee) onLogFee({ amount: fee, salesTotal: total });
    setShowImport(false);
  };

  return (
    <div>
      {headerExtra}
      <div className="stat-grid" style={{ display: "flex", gap: 12, marginBottom: 16, flexWrap: "wrap" }}>
        <div style={styles.statCard(C.goldLight)}><div style={{ ...styles.statNum, fontSize: 22 }}>{totalUnits}</div><div style={styles.statLabel}>Units at {venueLabel}</div></div>
        <div style={styles.statCard(C.sageLight)}><div style={{ ...styles.statNum, fontSize: 22, color: C.sageDark }}>${inv.reduce((s, i) => s + Number(i.price || 0) * Number(i.qty || 0), 0).toFixed(2)}</div><div style={styles.statLabel}>Inventory Value</div></div>
        <div style={styles.statCard(C.purpleLight)}><div style={{ ...styles.statNum, fontSize: 22, color: C.purple }}>{newLabels}</div><div style={styles.statLabel}>Awaiting Labels</div></div>
      </div>

      {setCollectiveCut && (
        <div className="app-card" style={{ ...styles.card, display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
          <span style={{ fontSize: 13, fontWeight: 700, color: C.text }}>🏪 Collective commission</span>
          <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
            <input style={{ ...styles.input, width: 90 }} type="number" step="any" value={cutDraft} onChange={e => setCutDraft(e.target.value)} onBlur={() => setCollectiveCut(Number(cutDraft) || 0)} placeholder="0" />
            <span style={{ fontSize: 13, color: C.muted }}>%</span>
          </span>
          <span style={{ fontSize: 12, color: C.textSoft }}>Taken from each imported sale and logged as a "Collective Fee" expense — your gross sales stay intact.</span>
        </div>
      )}

      {/* Newly received — must be labeled before counting as inventory */}
      <div style={{ ...styles.card, borderColor: received.length > 0 ? C.purple : C.border }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6, flexWrap: "wrap", gap: 8 }}>
          <div style={{ ...styles.sectionTitle, marginBottom: 0, color: C.purple }}>🏷️ Newly Received — Print Labels</div>
          <div style={{ display: "flex", gap: 8 }}>
            {onExportCsv && received.length > 0 && <button style={styles.btn("sage")} onClick={() => onExportCsv(received)}>⬇ Export for Collective</button>}
            {received.length > 0 && <button style={styles.btn("ghost")} onClick={clearAllLabeled}>Mark All Labeled</button>}
          </div>
        </div>
        <div style={{ fontSize: 13, color: C.muted, marginBottom: 14 }}>
          {onExportCsv
            ? <>These aren't counted as {venueLabel} inventory yet. <strong>Export them to the Collective</strong> and upload that file first, then <strong>Mark Labeled</strong> to move them into Current {venueLabel} Inventory.</>
            : <>Items here aren't counted as {venueLabel.toLowerCase()} inventory yet. Hit <strong>Mark Labeled</strong> once labels are printed to move them into Current {venueLabel} Inventory.</>}
        </div>
        <ResponsiveTable
          rows={[...received].reverse()}
          emptyText={`Nothing waiting on labels. Send products from the Inventory tab to ${venueLabel.toLowerCase()} to see them here.`}
          columns={[
            { key: "date", header: "Received" },
            { key: "name", header: "Product", primary: true },
            { key: "size", header: "Size" },
            { key: "flavor", header: "Flavor" },
            { key: "qty", header: "Qty", strong: true },
            { key: "labels", header: "Labels Needed", render: r => <span style={styles.badge("event")}>{r.qty} labels</span> },
          ]}
          actions={r => (
            <>
              <button style={{ ...styles.btn("sage"), fontSize: 12, padding: "5px 12px" }} onClick={() => markLabeled(r)}>Mark Labeled</button>
              {onUndoReceived && <button style={{ ...styles.btn("ghost"), fontSize: 12, padding: "5px 10px", marginLeft: 6 }} onClick={() => onUndoReceived(r)}>↩ Undo Send</button>}
            </>
          )}
        />
      </div>

      {/* Current venue inventory */}
      <div className="app-card" style={styles.card}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16, flexWrap: "wrap", gap: 8 }}>
          <div style={{ ...styles.sectionTitle, marginBottom: 0 }}>{venueIcon} Current {venueLabel} Inventory</div>
          <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
            <span style={{ fontSize: 12, color: C.muted }}>Sort</span>
            <select style={{ ...styles.input, width: 130 }} value={invSort} onChange={e => setInvSort(e.target.value)}>
              <option value="category">Category</option>
              <option value="name">Name</option>
              <option value="qty">Quantity</option>
              <option value="value">Value</option>
            </select>
            <button style={{ ...styles.btn("ghost"), whiteSpace: "nowrap" }} onClick={() => setSortDir(d => d === "asc" ? "desc" : "asc")}>
              {(invSort === "qty" || invSort === "value")
                ? (sortDir === "asc" ? "Low → High" : "High → Low")
                : (sortDir === "asc" ? "A → Z" : "Z → A")}
            </button>
            {onImportSales && <button style={styles.btn("purple")} onClick={() => setShowImport(true)}>⬆ Import Sales</button>}
            {onCloseAll && inv.length > 0 && <button style={styles.btn("danger")} onClick={onCloseAll}>{closeAllLabel || "Return All to Inventory"}</button>}
            {allowMultiSale && <button style={{ ...styles.btn("primary"), opacity: inv.length > 0 ? 1 : 0.4, cursor: inv.length > 0 ? "pointer" : "not-allowed" }} disabled={inv.length === 0} onClick={() => setMultiSale(true)}>+ New Sale</button>}
          </div>
        </div>
        {(() => {
          const invColumns = [
            { key: "name", header: "Product", primary: true },
            { key: "size", header: "Size" },
            { key: "flavor", header: "Flavor" },
            { key: "qty", header: `At ${venueLabel}`, strong: true },
            { key: "price", header: "Price", render: i => `$${Number(i.price || 0).toFixed(2)}` },
          ];
          const invActions = i => (
            <>
              <button style={{ ...styles.btn("sage"), fontSize: 12, padding: "5px 12px", opacity: i.qty <= 0 ? 0.4 : 1, cursor: i.qty <= 0 ? "not-allowed" : "pointer" }} disabled={i.qty <= 0} onClick={() => recordSale(i, 1)}>Sell 1</button>
              <button style={{ ...styles.btn("primary"), fontSize: 12, padding: "5px 10px", marginLeft: 6, opacity: i.qty <= 0 ? 0.4 : 1, cursor: i.qty <= 0 ? "not-allowed" : "pointer" }} disabled={i.qty <= 0} onClick={() => openSell(i)}>Sell…</button>
              {onReturn && <button style={{ ...styles.btn("ghost"), fontSize: 12, padding: "5px 10px", marginLeft: 6, opacity: i.qty <= 0 ? 0.4 : 1, cursor: i.qty <= 0 ? "not-allowed" : "pointer" }} disabled={i.qty <= 0} onClick={() => openReturn(i)}>↩ Return</button>}
              <button style={{ ...styles.btn("danger"), fontSize: 12, padding: "5px 10px", marginLeft: 6 }} onClick={() => openRemove(i)}>Remove</button>
            </>
          );
          const sortRows = (rows) => {
            const r = [...rows];
            const dir = sortDir === "asc" ? 1 : -1;
            if (invSort === "qty") r.sort((a, b) => dir * (Number(a.qty || 0) - Number(b.qty || 0)));
            else if (invSort === "value") r.sort((a, b) => dir * ((Number(a.qty || 0) * Number(a.price || 0)) - (Number(b.qty || 0) * Number(b.price || 0))));
            else r.sort((a, b) => dir * String(a.name || "").localeCompare(String(b.name || "")));
            return r;
          };
          if (invSort !== "category") {
            return <ResponsiveTable rows={sortRows(inv)} columns={invColumns} actions={invActions} emptyText={`No inventory at the ${venueLabel.toLowerCase()} yet.`} />;
          }
          const groups = groupSourceBySection(inv, sectionOrder);
          if (groups.length === 0) return <ResponsiveTable rows={[]} columns={invColumns} actions={invActions} emptyText={`No inventory at the ${venueLabel.toLowerCase()} yet.`} />;
          return groups.map((g, i) => {
            const isCollapsed = !expandedCats[g.name];
            const catVal = g.rows.reduce((s, r) => s + Number(r.qty || 0) * Number(r.price || 0), 0);
            return (
              <div key={g.name} style={{ marginTop: i === 0 ? 0 : 18 }}>
                <div onClick={() => setExpandedCats(e => ({ ...e, [g.name]: !e[g.name] }))} style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8, cursor: "pointer", userSelect: "none" }}>
                  <span style={{ fontSize: 12, color: C.muted, width: 12, display: "inline-block" }}>{isCollapsed ? "▸" : "▾"}</span>
                  <span style={{ fontSize: 13, fontWeight: 800, color: C.goldDark, textTransform: "uppercase", letterSpacing: "0.5px" }}>📂 {g.name} <span style={{ color: C.textSoft, fontWeight: 600 }}>· {g.rows.length}</span></span>
                  <span style={{ marginLeft: "auto", fontSize: 14, fontWeight: 700, color: C.sageDark }}>${catVal.toFixed(2)}</span>
                </div>
                {!isCollapsed && <ResponsiveTable rows={sortRows(g.rows)} columns={invColumns} actions={invActions} emptyText="—" />}
              </div>
            );
          });
        })()}
      </div>

      {/* Venue orders */}
      <VenueOrders orders={orders} dispatch={ordersDispatch} title={ordersTitle} soldTitle={soldTitle} showEvent={false} />

      {sellItem && (
        <Modal title={`Sell — ${sellItem.name} ${sellItem.size}`} onClose={closeSell}>
          <p style={{ fontSize: 14, color: C.muted, marginBottom: 14 }}>
            {sellItem.qty} at the {venueLabel.toLowerCase()}, priced at ${Number(sellItem.price || 0).toFixed(2)} each. How many sold?
          </p>
          <Field label="Quantity Sold">
            <input style={styles.input} type="number" min="1" max={sellItem.qty} value={sellQty} onChange={e => setSellQty(e.target.value)} placeholder={`1–${sellItem.qty}`} autoFocus />
          </Field>
          {sellQty && Number(sellQty) > 0 && (
            <div style={{ padding: "10px 14px", background: C.sageLight, borderRadius: 8, fontSize: 14, color: C.sageDark, marginBottom: 14 }}>
              Sale total: <strong>${(Number(sellItem.price || 0) * Number(sellQty)).toFixed(2)}</strong>
            </div>
          )}
          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 8 }}>
            <button style={styles.btn("ghost")} onClick={closeSell}>Cancel</button>
            <button style={styles.btn("primary")} onClick={confirmSell}>Record Sale</button>
          </div>
        </Modal>
      )}

      {multiSale && (
        <MultiSaleModal
          title={`New ${venueLabel} Sale`}
          source={inv}
          onClose={() => setMultiSale(false)}
          onConfirm={confirmMultiSale}
          sectionOrder={sectionOrder}
          deals={deals}
          taxRate={taxRate}
        />
      )}

      {returnItem && (
        <Modal title={`Return to Inventory — ${returnItem.name} ${returnItem.size}`} onClose={closeReturn}>
          <p style={{ fontSize: 14, color: C.muted, marginBottom: 14 }}>
            {returnItem.qty} at the {venueLabel.toLowerCase()}. How many go back to main inventory?
          </p>
          <Field label="Quantity to Return">
            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
              <input style={{ ...styles.input, flex: 1 }} type="number" min="1" max={returnItem.qty} value={returnQty} onChange={e => setReturnQty(e.target.value)} placeholder={`1–${returnItem.qty}`} autoFocus />
              <button style={styles.btn("ghost")} onClick={() => setReturnQty(String(returnItem.qty))}>All ({returnItem.qty})</button>
            </div>
          </Field>
          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 8 }}>
            <button style={styles.btn("ghost")} onClick={closeReturn}>Cancel</button>
            <button style={styles.btn("primary")} onClick={confirmReturn}>Return to Inventory</button>
          </div>
        </Modal>
      )}

      {showImport && (
        <CollectiveImportModal inv={inv} cutPct={collectiveCut} onClose={() => setShowImport(false)} onApply={applyImport} />
      )}

      {pendingLabel && (
        <Modal title="Move into Collective inventory?" onClose={() => setPendingLabel(null)}>
          <div style={{ padding: "12px 14px", background: C.goldLight, border: `1px solid ${C.gold}`, borderRadius: 8, marginBottom: 16 }}>
            <div style={{ fontSize: 14, fontWeight: 700, color: C.goldDark, marginBottom: 4 }}>Did the export to the Collective go through?</div>
            <div style={{ fontSize: 13, color: C.muted }}>
              {pendingLabel.kind === "all"
                ? `This moves all ${received.length} newly-received item(s) into Current ${venueLabel} Inventory.`
                : `This moves ${pendingLabel.row?.name} ${pendingLabel.row?.size || ""} into Current ${venueLabel} Inventory.`}
              {" "}Only confirm once you've exported these and uploaded the file to the Collective.
            </div>
          </div>
          <div style={{ display: "flex", gap: 10, justifyContent: "space-between", flexWrap: "wrap" }}>
            {onExportCsv && received.length > 0 && <button style={styles.btn("sage")} onClick={() => onExportCsv(received)}>⬇ Export again</button>}
            <div style={{ display: "flex", gap: 10, marginLeft: "auto" }}>
              <button style={styles.btn("ghost")} onClick={() => setPendingLabel(null)}>Cancel</button>
              <button style={styles.btn("primary")} onClick={confirmPendingLabel}>Yes — mark labeled</button>
            </div>
          </div>
        </Modal>
      )}

      {removeItem && (
        <Modal title={`Remove — ${removeItem.name} ${removeItem.size}`} onClose={closeRemove}>
          <p style={{ fontSize: 14, color: C.muted, marginBottom: 14 }}>
            {removeItem.qty} at the {venueLabel.toLowerCase()}. Removing takes them out of stock and logs the loss to your financials (use Return to send them back to main inventory instead).
          </p>
          <Field label="Reason">
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
              {["Broken", "Lost/Missing", "Spoiled", "Sample/Giveaway", "Other"].map(r => (
                <button key={r} onClick={() => setRemoveReason(r)} style={styles.subNavBtn(removeReason === r)}>{r}</button>
              ))}
            </div>
          </Field>
          <Field label="Quantity to Remove">
            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
              <input style={{ ...styles.input, flex: 1 }} type="number" min="1" max={removeItem.qty} value={removeQty} onChange={e => setRemoveQty(e.target.value)} placeholder={`1–${removeItem.qty}`} autoFocus />
              <button style={styles.btn("ghost")} onClick={() => setRemoveQty(String(removeItem.qty))}>All ({removeItem.qty})</button>
            </div>
          </Field>
          {removeQty && Number(removeQty) > 0 && (
            <div style={{ padding: "10px 14px", background: C.dangerLight, borderRadius: 8, fontSize: 13, color: C.danger, marginBottom: 14 }}>
              Logs an inventory loss of <strong>${(Number(removeItem.price || 0) * Number(removeQty)).toFixed(2)}</strong> ({removeReason}).
            </div>
          )}
          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 8 }}>
            <button style={styles.btn("ghost")} onClick={closeRemove}>Cancel</button>
            <button style={styles.btn("danger")} onClick={confirmRemove}>Remove</button>
          </div>
        </Modal>
      )}
    </div>
  );
}

function StoreView(props) {
  return <VenueView venueLabel="Collective" venueIcon="🏪" soldTitle="Collective Sold" ordersTitle="🧾 Collective Orders" saleCustomer="Collective sale"
    inv={props.storeInv} invDispatch={props.storeInvDispatch} received={props.received} receivedDispatch={props.receivedDispatch}
    orders={props.orders} ordersDispatch={props.ordersDispatch} onReturn={props.onReturn} onUndoReceived={props.onUndoReceived} onLogLoss={props.onLogLoss} onExportCsv={props.onExportCsv} onImportSales={true} sectionOrder={props.sectionOrder} deals={props.deals} taxRate={props.taxRate} collectiveCut={props.collectiveCut} setCollectiveCut={props.setCollectiveCut} onLogFee={props.onLogFee} />;
}

// Sum the "xN" quantities out of an order's items text (e.g. "Wildflower 8oz x2, Clover x1" → 3)
function countUnits(itemsText) {
  if (!itemsText) return 0;
  const matches = String(itemsText).match(/x\s*(\d+)/gi) || [];
  return matches.reduce((sum, m) => sum + (parseInt(m.replace(/[^0-9]/g, ""), 10) || 0), 0);
}

function EventView({ events, eventsDispatch, eventInv, eventInvDispatch, received, receivedDispatch, orders, ordersDispatch, onReturnToInventory, onUndoReceived, onCaptureCustomer, isStaff, onLogLoss, onLogEventCost, expenses, sectionOrder = [], deals = [], homeTaxRate = 0 }) {
  const [selectedId, setSelectedId] = useState(events.length > 0 ? events[0].id : null);
  const [showCreate, setShowCreate] = useState(false);
  const [form, setForm] = useState({ name: "", date: "", location: "" });

  // Keep selection valid as events change
  const selected = events.find(e => e.id === selectedId) || events[0] || null;
  const activeId = selected ? selected.id : null;

  // Scope data to the selected event
  const scopedInv = eventInv.filter(i => (i.eventId || null) === activeId);
  const scopedReceived = received.filter(r => (r.eventId || null) === activeId);
  const scopedOrders = orders.filter(o => (o.eventId || null) === activeId);

  const createEvent = async () => {
    if (!form.name.trim()) return;
    const taxRate = form.taxRate === "" || form.taxRate == null ? null : Number(form.taxRate);
    const created = await eventsDispatch({ type: "ADD", item: { name: form.name.trim(), date: form.date, location: form.location.trim(), taxRate } });
    if (created && created.id) setSelectedId(created.id);
    // Log the participation cost (booth/table fee) as an expense tied to this event.
    const cost = Number(form.cost) || 0;
    if (cost > 0 && onLogEventCost) onLogEventCost({ eventName: form.name.trim(), date: form.date, amount: cost });
    setForm({ name: "", date: "", location: "", cost: "", taxRate: "" });
    setShowCreate(false);
  };

  // Close event: return all remaining stock to main inventory, then delete the event + its records
  const closeEvent = () => {
    if (!selected) return;
    scopedInv.forEach(i => onReturnToInventory(i, i.qty));
    scopedReceived.forEach(r => receivedDispatch({ type: "DELETE", id: r.id }));
    // Leave fulfilled sales history intact, but detach by keeping them; remove the event from the list
    eventsDispatch({ type: "DELETE", id: selected.id });
    const remaining = events.filter(e => e.id !== selected.id);
    setSelectedId(remaining.length > 0 ? remaining[0].id : null);
  };

  // Wrap order dispatch so new venue orders get tagged with the event id
  const scopedOrdersDispatch = (action) => {
    if (action.type === "ADD") ordersDispatch({ type: "ADD", item: { ...action.item, eventId: activeId, event: selected ? selected.name : "" } });
    else ordersDispatch(action);
  };

  // Return handler scoped: also tag with event so the right line is reduced
  const handleReturn = (item, qty) => onReturnToInventory(item, qty);

  const eventHeader = (
    <div className="app-card" style={styles.card}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 14, flexWrap: "wrap", gap: 8 }}>
        <div style={{ ...styles.sectionTitle, marginBottom: 0 }}>🎪 Events</div>
        {!isStaff && <button style={styles.btn("primary")} onClick={() => setShowCreate(true)}>+ New Event</button>}
      </div>
      {events.length === 0 ? (
        <div style={{ fontSize: 14, color: C.muted }}>No events yet. Create one to start sending product to it.</div>
      ) : (
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          {events.map(e => (
            <button key={e.id} onClick={() => setSelectedId(e.id)} style={styles.subNavBtn(e.id === activeId, C.purple)}>
              {e.name}{e.date ? ` · ${e.date}` : ""}
            </button>
          ))}
        </div>
      )}
      {selected && (
        <div style={{ fontSize: 13, color: C.muted, marginTop: 12 }}>
          {selected.location ? `📍 ${selected.location}` : ""}{selected.location && selected.date ? " · " : ""}{selected.date ? `📅 ${selected.date}` : ""}
        </div>
      )}
      {selected && (() => {
        const sold = scopedOrders.filter(o => o.status === "Fulfilled");
        const unitsSold = sold.reduce((sum, o) => sum + countUnits(o.items), 0);
        const grossSales = sold.reduce((sum, o) => sum + Number(o.total || 0), 0);
        const taxCollected = sold.reduce((sum, o) => sum + Number(o.tax || 0), 0);
        return (
          <div className="stat-grid" style={{ display: "flex", gap: 12, marginTop: 14, flexWrap: "wrap" }}>
            <div style={styles.statCard(C.purpleLight)}><div style={{ ...styles.statNum, fontSize: 20, color: C.purple }}>{sold.length}</div><div style={styles.statLabel}>Sales</div></div>
            <div style={styles.statCard(C.goldLight)}><div style={{ ...styles.statNum, fontSize: 20 }}>{unitsSold}</div><div style={styles.statLabel}>Units Sold</div></div>
            <div style={styles.statCard(C.sageLight)}><div style={{ ...styles.statNum, fontSize: 20, color: C.sageDark }}>${grossSales.toFixed(2)}</div><div style={styles.statLabel}>Gross Sales</div></div>
            <div style={styles.statCard(C.goldLight)}><div style={{ ...styles.statNum, fontSize: 20, color: C.amber }}>${taxCollected.toFixed(2)}</div><div style={styles.statLabel}>Tax Collected</div></div>
          </div>
        );
      })()}
    </div>
  );

  // Comparison list across all events
  const eventsComparison = events.length > 0 && !isStaff ? (
    <div className="app-card" style={styles.card}>
      <div style={styles.sectionTitle}>📊 Event Performance</div>
      <ResponsiveTable
        rows={events.map(e => {
          const sold = orders.filter(o => (o.eventId || null) === e.id && o.status === "Fulfilled");
          const gross = sold.reduce((s, o) => s + Number(o.total || 0), 0);
          // Match this event's participation fees from expenses (by name in the description)
          const cost = (expenses || []).filter(x => x.category === "Event Cost" && (x.description || "").includes(e.name)).reduce((s, x) => s + Number(x.amount || 0), 0);
          return { id: e.id, name: e.name, date: e.date || "—", units: sold.reduce((s, o) => s + countUnits(o.items), 0), gross, cost, net: gross - cost };
        })}
        emptyText="No events yet."
        columns={[
          { key: "name", header: "Event", primary: true },
          { key: "date", header: "Date" },
          { key: "units", header: "Units Sold", strong: true },
          { key: "gross", header: "Gross Sales", render: r => `$${r.gross.toFixed(2)}`, tdStyle: () => ({ color: C.sageDark, fontWeight: 600 }) },
          { key: "cost", header: "Event Cost", render: r => `$${r.cost.toFixed(2)}`, tdStyle: () => ({ color: C.danger }) },
          { key: "net", header: "Net", render: r => `$${r.net.toFixed(2)}`, tdStyle: r => ({ fontWeight: 700, color: r.net >= 0 ? C.goldDark : C.danger }) },
        ]}
      />
    </div>
  ) : null;

  if (!selected) {
    return (
      <div>
        {eventHeader}
        {showCreate && (
          <Modal title="New Event" onClose={() => setShowCreate(false)}>
            <Field label="Event Name"><input style={styles.input} value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="e.g. Nashville Farmers Market" autoFocus /></Field>
            <div className="grid-2" style={styles.grid2}>
              <Field label="Date"><input style={styles.input} type="date" value={form.date} onChange={e => setForm({ ...form, date: e.target.value })} /></Field>
              <Field label="Location"><input style={styles.input} value={form.location} onChange={e => setForm({ ...form, location: e.target.value })} placeholder="e.g. Downtown" /></Field>
            </div>
            <Field label="Participation Cost ($)"><input style={styles.input} type="number" step="any" value={form.cost || ""} onChange={e => setForm({ ...form, cost: e.target.value })} placeholder="Booth/table fee — optional" /></Field>
            <Field label="Sales Tax Rate (%)"><input style={styles.input} type="number" step="any" value={form.taxRate ?? ""} onChange={e => setForm({ ...form, taxRate: e.target.value })} placeholder="Blank = use home rate" /></Field>
            <div style={{ fontSize: 12, color: C.textSoft, marginTop: -6, marginBottom: 12 }}>Logged as an expense and counted against this event's net.</div>
            <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 8 }}>
              <button style={styles.btn("ghost")} onClick={() => setShowCreate(false)}>Cancel</button>
              <button style={styles.btn("primary")} onClick={createEvent}>Create Event</button>
            </div>
          </Modal>
        )}
      </div>
    );
  }

  return (
    <>
      <VenueView
        venueLabel="Event" venueIcon="🎪" soldTitle="Event Sold" ordersTitle={`🧾 ${selected.name} Orders`} saleCustomer="Event sale" allowMultiSale
        eventId={activeId}
        inv={scopedInv} invDispatch={eventInvDispatch}
        received={scopedReceived} receivedDispatch={receivedDispatch}
        orders={scopedOrders} ordersDispatch={scopedOrdersDispatch}
        onReturn={isStaff ? undefined : handleReturn}
        onUndoReceived={isStaff ? undefined : onUndoReceived}
        onCaptureCustomer={onCaptureCustomer}
        onLogLoss={onLogLoss}
        onCloseAll={isStaff ? undefined : closeEvent}
        closeAllLabel="Close Event — Return All"
        headerExtra={eventHeader}
        sectionOrder={sectionOrder}
        deals={deals}
        taxRate={(selected && selected.taxRate != null && selected.taxRate !== "") ? Number(selected.taxRate) : homeTaxRate}
      />
      {eventsComparison}
      {showCreate && (
        <Modal title="New Event" onClose={() => setShowCreate(false)}>
          <Field label="Event Name"><input style={styles.input} value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="e.g. Nashville Farmers Market" autoFocus /></Field>
          <div className="grid-2" style={styles.grid2}>
            <Field label="Date"><input style={styles.input} type="date" value={form.date} onChange={e => setForm({ ...form, date: e.target.value })} /></Field>
            <Field label="Location"><input style={styles.input} value={form.location} onChange={e => setForm({ ...form, location: e.target.value })} placeholder="e.g. Downtown" /></Field>
          </div>
          <Field label="Participation Cost ($)"><input style={styles.input} type="number" step="any" value={form.cost || ""} onChange={e => setForm({ ...form, cost: e.target.value })} placeholder="Booth/table fee — optional" /></Field>
            <Field label="Sales Tax Rate (%)"><input style={styles.input} type="number" step="any" value={form.taxRate ?? ""} onChange={e => setForm({ ...form, taxRate: e.target.value })} placeholder="Blank = use home rate" /></Field>
          <div style={{ fontSize: 12, color: C.textSoft, marginTop: -6, marginBottom: 12 }}>Logged as an expense and counted against this event's net.</div>
          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 8 }}>
            <button style={styles.btn("ghost")} onClick={() => setShowCreate(false)}>Cancel</button>
            <button style={styles.btn("primary")} onClick={createEvent}>Create Event</button>
          </div>
        </Modal>
      )}
    </>
  );
}

// ── Venue Orders (shared by Store and Event) ───────────────────────────────
function VenueOrders({ orders, dispatch, title, soldTitle, showEvent }) {
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({});
  const openAdd = () => { setForm({ date: new Date().toISOString().slice(0, 10), event: "", customer: "", items: "", total: "", status: "Pending" }); setModal(true); };
  const close = () => setModal(false);
  const save = () => {
    if (showEvent ? !form.event : !form.customer) return;
    dispatch({ type: "ADD", item: { ...form, total: Number(form.total) || 0 } });
    close();
  };
  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
        <div style={styles.sectionTitle}>{title}</div>
        <button style={styles.btn("primary")} onClick={openAdd}>+ New Order</button>
      </div>
      <OrderTable orders={orders} dispatch={dispatch} historyTitle={soldTitle} showEvent={showEvent} onFulfill={id => dispatch({ type: "UPDATE", id, changes: { status: "Fulfilled" } })} />
      {modal && (
        <Modal title="New Order" onClose={close}>
          {showEvent && <Field label="Event Name"><input style={styles.input} value={form.event || ""} onChange={e => setForm({ ...form, event: e.target.value })} placeholder="e.g. Nashville Farmers Market" /></Field>}
          <div className="grid-2" style={styles.grid2}>
            <Field label="Date"><input style={styles.input} type="date" value={form.date || ""} onChange={e => setForm({ ...form, date: e.target.value })} /></Field>
            <Field label={showEvent ? "Customer / Notes" : "Customer Name"}><input style={styles.input} value={form.customer || ""} onChange={e => setForm({ ...form, customer: e.target.value })} placeholder="e.g. Jane Smith" /></Field>
          </div>
          <Field label="Items"><input style={styles.input} value={form.items || ""} onChange={e => setForm({ ...form, items: e.target.value })} placeholder="e.g. Clover 16oz x2" /></Field>
          <div className="grid-2" style={styles.grid2}>
            <Field label="Total ($)"><input style={styles.input} type="number" value={form.total ?? ""} onChange={e => setForm({ ...form, total: e.target.value })} /></Field>
            <Field label="Status">
              <select style={styles.input} value={form.status || "Pending"} onChange={e => setForm({ ...form, status: e.target.value })}>
                <option>Pending</option><option>Fulfilled</option>
              </select>
            </Field>
          </div>
          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 8 }}>
            <button style={styles.btn("ghost")} onClick={close}>Cancel</button>
            <button style={styles.btn("primary")} onClick={save}>Save Order</button>
          </div>
        </Modal>
      )}
    </div>
  );
}

// ── Products ───────────────────────────────────────────────────────────────
// ── Product CSV import ──────────────────────────────────────────────────────
const IMPORT_FIELDS = [
  { key: "name", label: "Name", required: true, guess: /name|product|item|title/i },
  { key: "size", label: "Size", guess: /size|weight|volume|^oz/i },
  { key: "flavor", label: "Flavor", guess: /flavou?r|variant/i },
  { key: "price", label: "Price ($)", guess: /price|retail|msrp/i },
  { key: "storePrice", label: "Collective price ($)", guess: /store|collective|wholesale|consign/i },
  { key: "sku", label: "SKU", guess: /sku|code|upc/i },
  { key: "section", label: "Category", guess: /section|categ|dept/i },
  { key: "taxable", label: "Taxable", guess: /tax/i },
  { key: "lowAlert", label: "Low stock alert", guess: /low|alert|reorder|min/i },
];
function parseBoolCell(v, def) {
  const t = String(v).trim().toLowerCase();
  if (["y", "yes", "true", "1", "t", "taxable"].includes(t)) return true;
  if (["n", "no", "false", "0", "f", "exempt", "nontaxable", "non-taxable"].includes(t)) return false;
  return def;
}

function ProductImportModal({ products, dispatch, sections, vendorPrefix, skuNameLen = 4, skuMaxLen = 0, skuNoDashes = false, onClose }) {
  const [step, setStep] = useState("upload"); // upload | map | preview
  const [fileName, setFileName] = useState("");
  const [rows, setRows] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [mapping, setMapping] = useState({});
  const [dupMode, setDupMode] = useState("skip"); // skip | update
  const [error, setError] = useState("");
  const [result, setResult] = useState(null);
  const [busy, setBusy] = useState(false);

  const downloadTemplate = () => {
    const cols = ["Name", "Size", "Flavor", "Price", "Collective Price", "SKU", "Category", "Taxable", "Low Stock Alert"];
    const sample = ["Wildflower Honey", "8 oz", "", "12.00", "11.00", "", "Raw", "yes", "5"];
    downloadCsv("product-import-template.csv", [cols.join(","), sample.join(",")].join("\n"));
  };

  const onFile = async (e) => {
    setError("");
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    setFileName(file.name);
    try {
      const parsed = parseCsv(await file.text());
      if (parsed.length === 0) { setError("No data rows found in that file."); return; }
      const hdrs = Object.keys(parsed[0]);
      // auto-guess mapping (don't reuse a header twice)
      const used = new Set();
      const guess = {};
      IMPORT_FIELDS.forEach(f => {
        const hit = hdrs.find(h => !used.has(h) && f.guess.test(h));
        if (hit) { guess[f.key] = hit; used.add(hit); } else guess[f.key] = "";
      });
      setRows(parsed); setHeaders(hdrs); setMapping(guess); setStep("map");
    } catch (err) { setError("Could not read that file. Make sure it's a CSV."); }
  };

  const resolved = rows.map((r, idx) => {
    const get = (fk) => mapping[fk] ? String(r[mapping[fk]] ?? "").trim() : "";
    const name = get("name"), size = get("size"), flavor = get("flavor");
    const priceRaw = get("price");
    const price = parseNum(priceRaw);
    const storePrice = parseNum(get("storePrice"));
    const skuRaw = get("sku").toUpperCase();
    const sectionRaw = get("section");
    const lowAlert = get("lowAlert") ? parseNum(get("lowAlert")) : 5;
    const taxable = parseBoolCell(get("taxable"), true);
    const section = sectionRaw ? sections.find(s => s.name.toLowerCase() === sectionRaw.toLowerCase()) : null;
    const dupBySku = skuRaw ? products.find(p => String(p.sku || "").toUpperCase() === skuRaw) : null;
    const dupByNameSize = !dupBySku ? products.find(p => p.name.toLowerCase() === name.toLowerCase() && String(p.size || "").toLowerCase() === size.toLowerCase()) : null;
    const dup = dupBySku || dupByNameSize || null;
    const errors = [];
    if (!name) errors.push("missing name");
    if (priceRaw && isNaN(parseFloat(priceRaw.replace(/[$,\s]/g, "")))) errors.push("bad price");
    if (sectionRaw && !section) errors.push("unknown category → uncategorized");
    return { idx, name, size, flavor, price, storePrice, skuRaw, sectionRaw, section, taxable, lowAlert, dup, errors };
  });

  const hardErrors = resolved.filter(r => r.errors.some(e => e === "missing name" || e === "bad price"));
  const importable = resolved.filter(r => !r.errors.some(e => e === "missing name" || e === "bad price"));
  const newRows = importable.filter(r => !r.dup);
  const dupRows = importable.filter(r => r.dup);
  const willUpdate = dupMode === "update" ? dupRows.length : 0;
  const willSkip = dupMode === "skip" ? dupRows.length : 0;

  const commit = async () => {
    setBusy(true);
    const taken = new Set(products.map(p => String(p.sku || "").toUpperCase()).filter(Boolean));
    let added = 0, updated = 0;
    for (const r of importable) {
      const code = r.section ? (r.section.code || "") : "";
      let sku = r.skuRaw || buildSku({ vendorPrefix, categoryCode: code, name: r.name, size: r.size, nameLen: skuNameLen, maxLen: skuMaxLen, noDashes: skuNoDashes });
      const isUpdate = r.dup && dupMode === "update";
      const selfSku = r.dup ? String(r.dup.sku || "").toUpperCase() : "";
      const takenForRow = new Set([...taken].filter(s => s !== selfSku));
      sku = uniqueSku(sku, takenForRow);
      taken.add(sku);
      const common = { name: r.name, size: r.size, flavor: r.flavor, price: r.price, storePrice: r.storePrice, lowAlert: r.lowAlert, sectionId: r.section ? r.section.id : null, sku, taxable: r.taxable };
      if (r.dup) {
        if (dupMode === "update") { await dispatch({ type: "UPDATE", id: r.dup.id, changes: common }); updated++; }
        // skip mode: do nothing
      } else {
        await dispatch({ type: "ADD", item: { ...common, qty: 0, recipe: [] } });
        added++;
      }
    }
    setBusy(false);
    setResult({ added, updated, skipped: willSkip, errors: hardErrors.length });
  };

  const Th = ({ children }) => <th style={{ ...styles.th, fontSize: 11 }}>{children}</th>;
  const Td = ({ children, color }) => <td style={{ padding: "6px 8px", fontSize: 12, borderBottom: `1px solid ${C.border}`, color: color || C.text, whiteSpace: "nowrap" }}>{children}</td>;

  return (
    <Modal title="Import Products from CSV" onClose={onClose} wide>
      {result ? (
        <div>
          <div style={{ padding: "16px", background: C.sageLight, borderRadius: 10, marginBottom: 16 }}>
            <div style={{ fontSize: 16, fontWeight: 800, color: C.sageDark, marginBottom: 6 }}>Import complete</div>
            <div style={{ fontSize: 14, color: C.sageDark }}>{result.added} added · {result.updated} updated · {result.skipped} skipped{result.errors > 0 ? ` · ${result.errors} skipped for errors` : ""}.</div>
          </div>
          <div style={{ display: "flex", justifyContent: "flex-end" }}><button style={styles.btn("primary")} onClick={onClose}>Done</button></div>
        </div>
      ) : step === "upload" ? (
        <div>
          <p style={{ fontSize: 13, color: C.muted, marginBottom: 14 }}>Upload a CSV of products. You'll map columns and preview everything before anything is saved. Products import as templates (0 stock) — create stock later with Make Batch.</p>
          <Field label="Product CSV file"><input type="file" accept=".csv,text/csv" onChange={onFile} style={{ fontSize: 14 }} /></Field>
          {fileName && <div style={{ fontSize: 12, color: C.muted, marginBottom: 10 }}>Loaded: {fileName}</div>}
          {error && <div style={{ fontSize: 13, color: C.danger, marginBottom: 10 }}>{error}</div>}
          <button style={{ ...styles.btn("ghost"), fontSize: 13 }} onClick={downloadTemplate}>⬇ Download a template CSV</button>
        </div>
      ) : step === "map" ? (
        <div>
          <p style={{ fontSize: 13, color: C.muted, marginBottom: 14 }}>Match your CSV columns to product fields. We guessed where we could — adjust anything that's off. Only <strong>Name</strong> is required.</p>
          {IMPORT_FIELDS.map(f => (
            <div key={f.key} style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
              <div style={{ width: 140, fontSize: 13, fontWeight: 600 }}>{f.label}{f.required && <span style={{ color: C.danger }}> *</span>}</div>
              <select style={{ ...styles.input, flex: 1 }} value={mapping[f.key] || ""} onChange={e => setMapping({ ...mapping, [f.key]: e.target.value })}>
                <option value="">— not mapped —</option>
                {headers.map(h => <option key={h} value={h}>{h}</option>)}
              </select>
            </div>
          ))}
          <div style={{ display: "flex", gap: 10, justifyContent: "space-between", marginTop: 16 }}>
            <button style={styles.btn("ghost")} onClick={() => setStep("upload")}>← Back</button>
            <button style={{ ...styles.btn("primary"), opacity: mapping.name ? 1 : 0.5, cursor: mapping.name ? "pointer" : "not-allowed" }} disabled={!mapping.name} onClick={() => setStep("preview")}>Preview {rows.length} rows →</button>
          </div>
        </div>
      ) : (
        <div>
          <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginBottom: 12 }}>
            <span style={styles.badge("ok")}>{newRows.length} new</span>
            <span style={styles.badge("warn")}>{dupRows.length} duplicate{dupRows.length === 1 ? "" : "s"}</span>
            {hardErrors.length > 0 && <span style={styles.badge("low")}>{hardErrors.length} with errors (skipped)</span>}
          </div>
          {dupRows.length > 0 && (
            <div style={{ marginBottom: 12 }}>
              <label style={styles.label}>Duplicates (match by SKU, else name + size)</label>
              <div style={{ display: "flex", gap: 8 }}>
                <button style={styles.subNavBtn(dupMode === "skip")} onClick={() => setDupMode("skip")}>Skip them</button>
                <button style={styles.subNavBtn(dupMode === "update")} onClick={() => setDupMode("update")}>Update existing</button>
              </div>
            </div>
          )}
          <div style={{ maxHeight: 300, overflow: "auto", border: `1px solid ${C.border}`, borderRadius: 8, marginBottom: 14 }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead><tr style={{ background: C.bg, position: "sticky", top: 0 }}><Th>Status</Th><Th>Name</Th><Th>Size</Th><Th>Price</Th><Th>Category</Th><Th>SKU</Th><Th>Tax</Th></tr></thead>
              <tbody>
                {resolved.map(r => {
                  const hard = r.errors.some(e => e === "missing name" || e === "bad price");
                  const status = hard ? { t: "error", c: C.danger } : r.dup ? (dupMode === "update" ? { t: "update", c: C.amber } : { t: "skip", c: C.textSoft }) : { t: "new", c: C.sageDark };
                  return (
                    <tr key={r.idx}>
                      <Td color={status.c}>{status.t}{r.errors.length > 0 ? ` · ${r.errors.join(", ")}` : ""}</Td>
                      <Td>{r.name || <em style={{ color: C.danger }}>—</em>}</Td>
                      <Td>{r.size}</Td>
                      <Td>${r.price.toFixed(2)}</Td>
                      <Td>{r.section ? r.section.name : (r.sectionRaw ? <span style={{ color: C.amber }}>{r.sectionRaw}?</span> : "—")}</Td>
                      <Td>{r.skuRaw || <span style={{ color: C.textSoft }}>auto</span>}</Td>
                      <Td>{r.taxable ? "yes" : "no"}</Td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div style={{ display: "flex", gap: 10, justifyContent: "space-between" }}>
            <button style={styles.btn("ghost")} onClick={() => setStep("map")} disabled={busy}>← Back</button>
            <button style={{ ...styles.btn("primary"), opacity: (newRows.length + willUpdate) > 0 && !busy ? 1 : 0.5, cursor: (newRows.length + willUpdate) > 0 && !busy ? "pointer" : "not-allowed" }} disabled={(newRows.length + willUpdate) === 0 || busy} onClick={commit}>
              {busy ? "Importing…" : `Import ${newRows.length} new${willUpdate ? ` + update ${willUpdate}` : ""}`}
            </button>
          </div>
        </div>
      )}
    </Modal>
  );
}

function Products({ products, dispatch, materials, sections = [], sectionsDispatch, vendorPrefix = "NBC", setVendorPrefix, skuNameLen = 4, setSkuNameLen, skuMaxLen = 0, setSkuMaxLen, skuNoDashes = false, setSkuNoDashes }) {
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({});
  const [search, setSearch] = useState("");
  const [manageSections, setManageSections] = useState(false);
  const [newSectionName, setNewSectionName] = useState("");
  const [newSectionCode, setNewSectionCode] = useState("");
  const [draftNames, setDraftNames] = useState({});
  const [draftCodes, setDraftCodes] = useState({});
  const [skuTouched, setSkuTouched] = useState(false);
  const [vendorDraft, setVendorDraft] = useState("");
  const [importOpen, setImportOpen] = useState(false);
  const [sectionError, setSectionError] = useState("");
  const [expanded, setExpanded] = useState({}); // category groups start collapsed; key present = expanded (Products)
  const [openNames, setOpenNames] = useState({}); // {nameKey: true} → a multi-size product expanded to show its variants

  const [dupPrompt, setDupPrompt] = useState(null); // { sku, suggestion, conflictName } when a save hits a duplicate SKU
  const catCodeOf = (sectionId) => sections.find(s => String(s.id) === String(sectionId))?.code || "";
  const genSku = (f) => buildSku({ vendorPrefix, categoryCode: catCodeOf(f.sectionId), name: f.name, size: f.size, nameLen: skuNameLen, maxLen: skuMaxLen, noDashes: skuNoDashes });

  // Auto-fill the SKU from vendor + category + name + size until the user
  // edits it by hand (or while it's still blank).
  useEffect(() => {
    if (!modal) return;
    if (skuTouched) return;
    const next = genSku(form);
    if (next !== (form.sku || "")) setForm(f => ({ ...f, sku: next }));
  }, [form.name, form.size, form.sectionId, modal, skuTouched, vendorPrefix]);

  const openAdd = () => { setSkuTouched(false); setForm({ name: "", size: "", flavor: "", qty: "", price: "", lowAlert: "", sectionId: "", sku: "", taxable: true, recipe: [] }); setModal("add"); };
  const openEdit = (p) => { setSkuTouched(!!p.sku); setForm({ ...p, recipe: p.recipe || [] }); setModal(p); };
  // Copy: open the Add form pre-filled from an existing product (fresh SKU, 0 stock) so you can tweak one thing and save a new variant.
  const copyProduct = (p) => {
    setSkuTouched(false);
    setForm({ name: p.name, size: p.size, flavor: p.flavor, price: p.price, storePrice: p.storePrice, lowAlert: p.lowAlert, sectionId: p.sectionId || "", taxable: p.taxable !== false, recipe: (p.recipe || []).map(r => ({ ...r })), sku: "", qty: "" });
    setModal("add");
  };
  const close = () => { setDupPrompt(null); setModal(null); };
  // Commit the product with a resolved, unique SKU (called once uniqueness is settled).
  const persist = (sku) => {
    const recipe = (form.recipe || []).filter(r => r.materialId && Number(r.qtyPer) > 0).map(r => ({ materialId: String(r.materialId), qtyPer: Number(r.qtyPer) }));
    if (modal === "add") {
      // New products are templates — they start with 0 stock. Stock is created via Make Batch.
      const item = { name: form.name, size: form.size, flavor: form.flavor, qty: 0, price: Number(form.price) || 0, storePrice: Number(form.storePrice) || 0, lowAlert: Number(form.lowAlert) || 5, sectionId: form.sectionId || null, sku, taxable: form.taxable !== false, recipe };
      dispatch({ type: "ADD", item });
    } else {
      // Editing keeps the existing stock count untouched.
      const changes = { name: form.name, size: form.size, flavor: form.flavor, price: Number(form.price) || 0, storePrice: Number(form.storePrice) || 0, lowAlert: Number(form.lowAlert) || 5, sectionId: form.sectionId || null, sku, taxable: form.taxable !== false, recipe };
      dispatch({ type: "UPDATE", id: modal.id, changes });
    }
    close();
  };
  const save = () => {
    if (!form.name) return;
    const editingId = modal === "add" ? null : modal.id;
    const taken = new Set(products.filter(p => p.id !== editingId).map(p => String(p.sku || "").toUpperCase()).filter(Boolean));
    // Resolve the SKU: use what's in the form, else generate. Apply the max-length cap.
    let sku = String(form.sku || genSku(form)).toUpperCase();
    if (skuMaxLen && skuMaxLen > 0) sku = sku.slice(0, skuMaxLen);
    // Hard-block a duplicate: surface the conflict + a numbered suggestion for approval.
    if (sku && taken.has(sku)) {
      const conflict = products.find(p => p.id !== editingId && String(p.sku || "").toUpperCase() === sku);
      const suggestion = uniqueSkuBounded(sku, taken, skuMaxLen, skuNoDashes);
      setDupPrompt({ sku, suggestion, conflictName: conflict ? `${conflict.name}${conflict.size ? " " + conflict.size : ""}` : "another product" });
      return;
    }
    persist(sku);
  };

  const addRecipeLine = () => setForm({ ...form, recipe: [...(form.recipe || []), { materialId: "", qtyPer: "" }] });
  const updateRecipeLine = (idx, key, val) => {
    const recipe = [...(form.recipe || [])];
    recipe[idx] = { ...recipe[idx], [key]: val };
    setForm({ ...form, recipe });
  };
  const removeRecipeLine = (idx) => setForm({ ...form, recipe: (form.recipe || []).filter((_, i) => i !== idx) });

  // ── Section management ──
  const addSection = async () => {
    const name = newSectionName.trim();
    if (!name) return;
    if (sections.some(s => s.name.toLowerCase() === name.toLowerCase())) { setNewSectionName(""); setNewSectionCode(""); return; }
    const code = newSectionCode.trim().toUpperCase().replace(/[^A-Z0-9]/g, "");
    const res = await sectionsDispatch({ type: "ADD", item: { name, code, position: sections.length } });
    if (!res) { setSectionError("Couldn't save this category — the database rejected it. This usually means the latest migration (migration-sections-and-sku.sql) hasn't been run in Supabase. Check the browser console for the exact error."); return; }
    setSectionError(""); setNewSectionName(""); setNewSectionCode("");
  };
  const renameSection = (id, name) => sectionsDispatch({ type: "UPDATE", id, changes: { name } });
  const setSectionCode = (id, code) => sectionsDispatch({ type: "UPDATE", id, changes: { code: String(code || "").toUpperCase().replace(/[^A-Z0-9]/g, "") } });
  const deleteSection = (id) => sectionsDispatch({ type: "DELETE", id });
  const moveSection = (idx, dir) => {
    const j = idx + dir;
    if (j < 0 || j >= sections.length) return;
    const a = sections[idx], b = sections[j];
    // sections arrive pre-sorted by position; swap their positions to reorder
    sectionsDispatch({ type: "UPDATE", id: a.id, changes: { position: j } });
    sectionsDispatch({ type: "UPDATE", id: b.id, changes: { position: idx } });
  };

  const filtered = products.filter(p => [p.name, p.size, p.flavor].some(v => v?.toLowerCase().includes(search.toLowerCase())));
  const productGroups = groupRowsBySection(filtered, sections, p => p.sectionId);
  const toggleGroup = (k) => setExpanded(e => ({ ...e, [k]: !e[k] }));
  const allExpanded = productGroups.length > 0 && productGroups.every(g => expanded[g.key]);
  const toggleAllGroups = () => setExpanded(allExpanded ? {} : Object.fromEntries(productGroups.map(g => [g.key, true])));
  const toggleName = (k) => setOpenNames(o => ({ ...o, [k]: !o[k] }));
  const usingCategories = !(sections.length === 0 || productGroups.length === 0);
  const allMultiKeys = usingCategories ? productGroups.flatMap(g => multiNameKeys(g.rows, g.key)) : multiNameKeys(filtered, "all");
  const anySizesOpen = allMultiKeys.some(k => openNames[k]);
  const toggleAllSizes = () => setOpenNames(anySizesOpen ? {} : Object.fromEntries(allMultiKeys.map(k => [k, true])));
  const matName = (id) => materials.find(m => String(m.id) === String(id))?.name || "—";
  const matCost = (id) => matEffectiveCost(materials.find(m => String(m.id) === String(id)));
  // Live material cost per unit from the recipe currently in the form
  const formMaterialCost = (form.recipe || []).reduce((sum, line) => {
    if (!line.materialId || !line.qtyPer) return sum;
    return sum + matCost(line.materialId) * Number(line.qtyPer);
  }, 0);
  const formPrice = Number(form.price) || 0;
  const formProfit = formPrice - formMaterialCost;
  const formMargin = formPrice > 0 ? (formProfit / formPrice) * 100 : 0;
  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16, gap: 8, flexWrap: "wrap" }}>
        <input style={{ ...styles.input, maxWidth: 280 }} placeholder="Search products…" value={search} onChange={e => setSearch(e.target.value)} />
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          {allMultiKeys.length > 0 && <button style={styles.btn("ghost")} onClick={toggleAllSizes}>{anySizesOpen ? "Collapse sizes" : "Expand sizes"}</button>}
          {productGroups.length > 1 && <button style={styles.btn("ghost")} onClick={toggleAllGroups}>{allExpanded ? "Collapse all" : "Expand all"}</button>}
          <button style={styles.btn("ghost")} onClick={() => setImportOpen(true)}>⬆ Import CSV</button>
          <button style={styles.btn("ghost")} onClick={() => { setVendorDraft(vendorPrefix); setManageSections(true); }}>📂 Categories & SKUs</button>
          <button style={styles.btn("primary")} onClick={openAdd}>+ Add Product</button>
        </div>
      </div>
      {(() => {
        const prodColumns = [
          { key: "name", header: "Product", primary: true },
          { key: "sku", header: "SKU", render: p => p.sku ? <span style={{ fontFamily: "ui-monospace, monospace", fontSize: 11, color: C.muted }}>{p.sku}</span> : <span style={{ color: C.textSoft, fontSize: 12 }}>—</span> },
          { key: "size", header: "Size" },
          { key: "flavor", header: "Flavor" },
          { key: "qty", header: "In Stock", strong: true },
          { key: "cost", header: "Cost", render: p => `$${((p.recipe || []).reduce((s, line) => s + matCost(line.materialId) * Number(line.qtyPer || 0), 0)).toFixed(2)}` },
          { key: "price", header: "Price", render: p => `$${Number(p.price).toFixed(2)}` },
          { key: "profit", header: "Profit",
            render: p => { const cost = (p.recipe || []).reduce((s, line) => s + matCost(line.materialId) * Number(line.qtyPer || 0), 0); return `$${(Number(p.price || 0) - cost).toFixed(2)}`; },
            tdStyle: p => { const cost = (p.recipe || []).reduce((s, line) => s + matCost(line.materialId) * Number(line.qtyPer || 0), 0); return { fontWeight: 700, color: (Number(p.price || 0) - cost) >= 0 ? C.sageDark : C.danger }; } },
          { key: "recipe", header: "Recipe", render: p => (p.recipe && p.recipe.length > 0) ? <span style={styles.badge("ok")}>{p.recipe.length} items</span> : <span style={{ color: C.textSoft, fontSize: 12 }}>none set</span> },
          { key: "status", header: "Status", render: p => <StockBadge qty={p.qty} low={p.lowAlert} /> },
        ];
        const prodActions = p => (
          <>
            <button style={{ ...styles.btn("ghost"), fontSize: 12, padding: "5px 10px" }} onClick={() => openEdit(p)}>Edit</button>
            <button style={{ ...styles.btn("ghost"), fontSize: 12, padding: "5px 10px", marginLeft: 6 }} onClick={() => copyProduct(p)}>Copy</button>
            <button style={{ ...styles.btn("danger"), fontSize: 12, padding: "5px 10px", marginLeft: 6 }} onClick={() => dispatch({ type: "DELETE", id: p.id })}>Remove</button>
          </>
        );
        if (sections.length === 0 || productGroups.length === 0) {
          return (
            <div className="app-card" style={styles.card}>
              <ResponsiveTable groups={nameVariantGroups(filtered, "all", openNames)} onToggleGroup={toggleName} columns={prodColumns} actions={prodActions} emptyText="No products found." />
            </div>
          );
        }
        return productGroups.map(g => {
          const isCollapsed = !expanded[g.key];
          return (
            <div key={g.key} className="app-card" style={styles.card}>
              <div onClick={() => toggleGroup(g.key)} style={{ ...styles.sectionTitle, marginBottom: isCollapsed ? 0 : 12, fontSize: 16, cursor: "pointer", userSelect: "none" }}>
                <span style={{ fontSize: 13, color: C.muted, width: 14, display: "inline-block" }}>{isCollapsed ? "▸" : "▾"}</span>
                📂 {g.name} <span style={{ fontSize: 12, fontWeight: 600, color: C.textSoft }}>· {g.rows.length}</span>
              </div>
              {!isCollapsed && <ResponsiveTable groups={nameVariantGroups(g.rows, g.key, openNames)} onToggleGroup={toggleName} columns={prodColumns} actions={prodActions} emptyText="No products in this category." />}
            </div>
          );
        });
      })()}
      {modal && (
        <Modal title={modal === "add" ? "Add Product" : "Edit Product"} onClose={close}>
          <Field label="Product Name"><input style={styles.input} value={form.name || ""} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="e.g. Wildflower Honey" /></Field>
          <div className="grid-2" style={styles.grid2}>
            <Field label="Size"><input style={styles.input} value={form.size || ""} onChange={e => setForm({ ...form, size: e.target.value })} placeholder="e.g. 8 oz" /></Field>
            <Field label="Flavor"><input style={styles.input} value={form.flavor || ""} onChange={e => setForm({ ...form, flavor: e.target.value })} placeholder="e.g. Clover" /></Field>
          </div>
          <div className="grid-2" style={styles.grid2}>
            <Field label="Sale Price ($)"><input style={styles.input} type="number" value={form.price ?? ""} onChange={e => setForm({ ...form, price: e.target.value })} /></Field>
            <Field label="Collective Price ($)"><input style={styles.input} type="number" value={form.storePrice ?? ""} onChange={e => setForm({ ...form, storePrice: e.target.value })} placeholder="optional" /></Field>
          </div>
          <div style={{ fontSize: 12, color: C.textSoft, marginTop: -6, marginBottom: 12 }}>Collective Price is used automatically when this product is sent to the Collective (for wholesale or location-specific pricing). Leave blank to use the regular sale price.</div>
          <Field label="Low Stock Alert (qty)"><input style={styles.input} type="number" value={form.lowAlert ?? ""} onChange={e => setForm({ ...form, lowAlert: e.target.value })} placeholder="e.g. 10" /></Field>
          <Field label="Category">
            <select style={styles.input} value={form.sectionId || ""} onChange={e => setForm({ ...form, sectionId: e.target.value })}>
              <option value="">— No category (Uncategorized) —</option>
              {sections.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
            </select>
          </Field>
          {sections.length === 0 && <div style={{ fontSize: 12, color: C.textSoft, marginTop: -6, marginBottom: 12 }}>Tip: create categories with <strong>📂 Categories & SKUs</strong> to group products on the Products page and at event checkout.</div>}
          <Field label="SKU">
            <div style={{ display: "flex", gap: 8 }}>
              <input style={{ ...styles.input, flex: 1, fontFamily: "ui-monospace, monospace" }} value={form.sku || ""} onChange={e => { setSkuTouched(true); setForm({ ...form, sku: e.target.value.toUpperCase() }); }} placeholder={`${vendorPrefix}-CAT-NAME`} />
              <button type="button" style={styles.btn("ghost")} onClick={() => { setSkuTouched(false); setForm({ ...form, sku: genSku(form) }); }}>↻ Regenerate</button>
            </div>
          </Field>
          <div style={{ fontSize: 12, color: C.textSoft, marginTop: -6, marginBottom: 14 }}>
            Auto-built as <strong>VENDOR-CATEGORY-NAME-SIZE</strong> — e.g. <strong>{vendorPrefix}-{catCodeOf(form.sectionId) || "RAW"}-{skuNameCode(form.name || "WILDFLOWER", skuNameLen)}{form.size ? "-" + String(form.size).toUpperCase().replace(/[^A-Z0-9]/g, "") : ""}</strong>. The name becomes a {skuNameLen}-letter code. Edit freely — it stays as you set it. Set codes, vendor &amp; length under <strong>📂 Categories & SKUs</strong>.
          </div>
          {modal === "add" && <div style={{ fontSize: 12, color: C.textSoft, marginBottom: 14, marginTop: 10 }}>New products start with 0 stock. Create stock by running <strong>Make Batch</strong> on the Inventory tab.</div>}
          <label style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 12px", background: C.bg, borderRadius: 8, border: `1px solid ${C.border}`, cursor: "pointer", marginBottom: 14 }}>
            <input type="checkbox" checked={form.taxable !== false} onChange={e => setForm({ ...form, taxable: e.target.checked })} style={{ width: 18, height: 18 }} />
            <span style={{ fontSize: 14, fontWeight: 600 }}>Taxable</span>
            <span style={{ fontSize: 12, color: C.textSoft }}>— sales tax is charged on this item at events &amp; single sales (never at the Collective).</span>
          </label>

          <div style={{ marginTop: 8, marginBottom: 14, padding: 14, background: C.bg, borderRadius: 8, border: `1px solid ${C.border}` }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
              <label style={{ ...styles.label, marginBottom: 0 }}>Recipe — materials used per unit</label>
              <button style={{ ...styles.btn("sage"), fontSize: 12, padding: "5px 10px" }} onClick={addRecipeLine}>+ Add Material</button>
            </div>
            {(!form.recipe || form.recipe.length === 0) && <div style={{ fontSize: 12, color: C.textSoft }}>No materials yet. Add the jar, lid, label, wax, etc. that one unit uses.</div>}
            {(form.recipe || []).map((line, idx) => {
              const lineCost = (line.materialId && line.qtyPer) ? matCost(line.materialId) * Number(line.qtyPer) : 0;
              return (
                <div key={idx} style={{ display: "flex", gap: 8, marginBottom: 8, alignItems: "center" }}>
                  <select style={{ ...styles.input, flex: 2 }} value={line.materialId} onChange={e => updateRecipeLine(idx, "materialId", e.target.value)}>
                    <option value="">Select material…</option>
                    {materials.map(m => <option key={m.id} value={m.id}>{m.name} ({m.unit}) — ${matEffectiveCost(m).toFixed(2)}{m.taxable ? " (incl. tax)" : ""}</option>)}
                  </select>
                  <input style={{ ...styles.input, flex: 1 }} type="number" step="any" value={line.qtyPer} onChange={e => updateRecipeLine(idx, "qtyPer", e.target.value)} placeholder="qty/unit" />
                  <span style={{ fontSize: 12, color: C.muted, minWidth: 52, textAlign: "right" }}>${lineCost.toFixed(2)}</span>
                  <button style={{ ...styles.btn("danger"), fontSize: 12, padding: "8px 10px" }} onClick={() => removeRecipeLine(idx)}>×</button>
                </div>
              );
            })}
          </div>

          {/* Live margin summary */}
          <div style={{ marginBottom: 14, padding: 14, background: formProfit >= 0 ? C.sageLight : C.dangerLight, borderRadius: 8, border: `1px solid ${formProfit >= 0 ? C.sage : C.danger}` }}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
              <span style={{ fontSize: 13, color: C.muted }}>Material cost / unit</span>
              <span style={{ fontSize: 14, fontWeight: 700 }}>${formMaterialCost.toFixed(2)}</span>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
              <span style={{ fontSize: 13, color: C.muted }}>Sale price</span>
              <span style={{ fontSize: 14, fontWeight: 700 }}>${formPrice.toFixed(2)}</span>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", paddingTop: 6, borderTop: `1px solid ${formProfit >= 0 ? C.sage : C.danger}` }}>
              <span style={{ fontSize: 13, fontWeight: 700, color: formProfit >= 0 ? C.sageDark : C.danger }}>Profit / unit (materials only)</span>
              <span style={{ fontSize: 16, fontWeight: 800, color: formProfit >= 0 ? C.sageDark : C.danger }}>${formProfit.toFixed(2)}{formPrice > 0 ? ` · ${formMargin.toFixed(0)}%` : ""}</span>
            </div>
            <div style={{ fontSize: 11, color: C.textSoft, marginTop: 8 }}>Materials only — does not include labor or overhead.</div>
          </div>

          {dupPrompt && (
            <div style={{ marginTop: 12, padding: 14, background: C.dangerLight, border: `1px solid ${C.danger}`, borderRadius: 8 }}>
              <div style={{ fontSize: 13, fontWeight: 700, color: C.danger, marginBottom: 6 }}>Duplicate SKU</div>
              <div style={{ fontSize: 13, color: C.text, marginBottom: 10 }}>
                <span style={{ fontFamily: "ui-monospace, monospace", fontWeight: 700 }}>{dupPrompt.sku}</span> is already used by <strong>{dupPrompt.conflictName}</strong>. Use <span style={{ fontFamily: "ui-monospace, monospace", fontWeight: 700 }}>{dupPrompt.suggestion}</span> instead?
              </div>
              <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                <button style={styles.btn("primary")} onClick={() => persist(dupPrompt.suggestion)}>Use {dupPrompt.suggestion}</button>
                <button style={styles.btn("ghost")} onClick={() => { setSkuTouched(true); setForm(f => ({ ...f, sku: dupPrompt.sku })); setDupPrompt(null); }}>Let me edit it</button>
              </div>
            </div>
          )}
          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 8 }}>
            <button style={styles.btn("ghost")} onClick={close}>Cancel</button>
            <button style={styles.btn("primary")} onClick={save}>Save Product</button>
          </div>
        </Modal>
      )}
      {importOpen && <ProductImportModal products={products} dispatch={dispatch} sections={sections} vendorPrefix={vendorPrefix} skuNameLen={skuNameLen} skuMaxLen={skuMaxLen} skuNoDashes={skuNoDashes} onClose={() => setImportOpen(false)} />}
      {manageSections && (
        <Modal title="Categories & SKU Settings" onClose={() => setManageSections(false)}>
          <div style={{ background: C.goldLight, border: `1px solid ${C.gold}`, borderRadius: 8, padding: "12px 14px", marginBottom: 16 }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: C.goldDark, textTransform: "uppercase", letterSpacing: "0.4px", marginBottom: 6 }}>Vendor prefix</div>
            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
              <input style={{ ...styles.input, flex: 1, fontFamily: "ui-monospace, monospace" }} value={vendorDraft}
                onChange={e => setVendorDraft(e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, ""))}
                onBlur={() => { const v = vendorDraft.trim() || "NBC"; if (v !== vendorPrefix) setVendorPrefix(v); }} placeholder="NBC" />
            </div>
            <div style={{ fontSize: 12, color: C.muted, marginTop: 6 }}>The first part of every SKU, e.g. <strong>{vendorDraft || "NBC"}</strong>-RAW-WILD-8OZ.</div>
            <div style={{ display: "flex", gap: 8, alignItems: "center", marginTop: 12 }}>
              <span style={{ fontSize: 13, fontWeight: 600 }}>Name code length</span>
              <select style={{ ...styles.input, width: 80 }} value={skuNameLen} onChange={e => setSkuNameLen && setSkuNameLen(e.target.value)}>
                {[2, 3, 4, 5, 6].map(n => <option key={n} value={n}>{n}</option>)}
              </select>
              <span style={{ fontSize: 12, color: C.muted }}>letters from the product name (e.g. {skuNameCode("WILDFLOWER", skuNameLen)})</span>
            </div>
            <div style={{ display: "flex", gap: 8, alignItems: "center", marginTop: 12, flexWrap: "wrap" }}>
              <span style={{ fontSize: 13, fontWeight: 600 }}>Max SKU length</span>
              <input type="number" min="4" style={{ ...styles.input, width: 90 }} value={skuMaxLen || ""} onChange={e => setSkuMaxLen && setSkuMaxLen(e.target.value)} placeholder="none" />
              <span style={{ fontSize: 12, color: C.muted }}>auto-SKUs longer than this are truncated. Blank = no limit.</span>
            </div>
            <label style={{ display: "flex", gap: 8, alignItems: "center", marginTop: 12, cursor: "pointer" }}>
              <input type="checkbox" checked={!!skuNoDashes} onChange={e => setSkuNoDashes && setSkuNoDashes(e.target.checked)} style={{ width: 16, height: 16 }} />
              <span style={{ fontSize: 13, fontWeight: 600 }}>Remove dashes from auto-SKUs</span>
              <span style={{ fontSize: 12, color: C.muted, fontFamily: "ui-monospace, monospace" }}>{vendorDraft || "NBC"}{skuNoDashes ? "" : "-"}RAW{skuNoDashes ? "" : "-"}WILD…</span>
            </label>
          </div>
          <div style={{ fontSize: 13, color: C.muted, marginBottom: 14 }}>
            Categories group products on the Products/Inventory pages and at checkout, and their <strong>code</strong> is the CATEGORY part of the SKU. Reorder to control the order shown during a sale.
          </div>
          <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
            <input style={{ ...styles.input, flex: 2 }} value={newSectionName} onChange={e => setNewSectionName(e.target.value)} onKeyDown={e => { if (e.key === "Enter") addSection(); }} placeholder="New category (e.g. Infused)" />
            <input style={{ ...styles.input, flex: 1, fontFamily: "ui-monospace, monospace" }} value={newSectionCode} onChange={e => setNewSectionCode(e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, ""))} onKeyDown={e => { if (e.key === "Enter") addSection(); }} placeholder="CODE" />
            <button style={styles.btn("primary")} onClick={addSection}>+ Add</button>
          </div>
          {sectionError && <div style={{ padding: "10px 14px", background: C.dangerLight, color: C.danger, borderRadius: 8, marginBottom: 14, fontSize: 13 }}>{sectionError}</div>}
          {sections.length === 0 ? (
            <div style={{ ...styles.empty, padding: "24px 12px" }}>No categories yet. Add one above.</div>
          ) : (
            <div>
              <div style={{ display: "flex", gap: 8, fontSize: 11, fontWeight: 700, color: C.textSoft, textTransform: "uppercase", letterSpacing: "0.4px", padding: "0 0 4px 56px" }}>
                <div style={{ flex: 2 }}>Category name</div>
                <div style={{ flex: 1 }}>SKU code</div>
                <div style={{ width: 70 }} />
              </div>
              {sections.map((s, idx) => (
                <div key={s.id} style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 0", borderBottom: `1px solid ${C.border}` }}>
                  <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
                    <button style={{ ...styles.btn("ghost"), padding: "1px 8px", fontSize: 12, opacity: idx === 0 ? 0.3 : 1, cursor: idx === 0 ? "not-allowed" : "pointer" }} disabled={idx === 0} onClick={() => moveSection(idx, -1)}>▲</button>
                    <button style={{ ...styles.btn("ghost"), padding: "1px 8px", fontSize: 12, opacity: idx === sections.length - 1 ? 0.3 : 1, cursor: idx === sections.length - 1 ? "not-allowed" : "pointer" }} disabled={idx === sections.length - 1} onClick={() => moveSection(idx, 1)}>▼</button>
                  </div>
                  <input style={{ ...styles.input, flex: 2 }} value={draftNames[s.id] ?? s.name}
                    onChange={e => setDraftNames({ ...draftNames, [s.id]: e.target.value })}
                    onBlur={e => { const v = e.target.value.trim(); if (v && v !== s.name) renameSection(s.id, v); const d = { ...draftNames }; delete d[s.id]; setDraftNames(d); }} />
                  <input style={{ ...styles.input, flex: 1, fontFamily: "ui-monospace, monospace" }} value={draftCodes[s.id] ?? (s.code || "")}
                    onChange={e => setDraftCodes({ ...draftCodes, [s.id]: e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "") })}
                    onBlur={e => { const v = e.target.value.trim().toUpperCase().replace(/[^A-Z0-9]/g, ""); if (v !== (s.code || "")) setSectionCode(s.id, v); const d = { ...draftCodes }; delete d[s.id]; setDraftCodes(d); }} placeholder="CODE" />
                  <button style={{ ...styles.btn("danger"), fontSize: 12, padding: "6px 10px", width: 70 }} onClick={() => deleteSection(s.id)}>Remove</button>
                </div>
              ))}
              <div style={{ fontSize: 12, color: C.textSoft, marginTop: 12 }}>Removing a category doesn't delete its products — they just become Uncategorized. Changing a code only affects SKUs you generate afterward.</div>
            </div>
          )}
          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
            <button style={styles.btn("primary")} onClick={() => setManageSections(false)}>Done</button>
          </div>
        </Modal>
      )}
    </div>
  );
}

// ── Materials ──────────────────────────────────────────────────────────────
function Materials({ materials, dispatch, categories = [], categoriesDispatch, globalTaxOn = false, setGlobalTaxOn, globalTaxRate = 0, setGlobalTaxRate, onLogPurchase }) {
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({});
  const [purchasePrompt, setPurchasePrompt] = useState(null); // { name, amount } after adding a material — ask whether to log as an expense
  const [search, setSearch] = useState("");
  const [expanded, setExpanded] = useState({}); // category groups start collapsed; key present = expanded
  const [manageCats, setManageCats] = useState(false);
  const [newCatName, setNewCatName] = useState("");
  const [catDraftNames, setCatDraftNames] = useState({});
  const openAdd = () => { setForm({ name: "", unit: "", qty: "", cost: "", lowAlert: "", costMode: "unit", lotPrice: "", lotUnits: "", taxable: !!globalTaxOn, taxRate: globalTaxRate, link: "", categoryId: "" }); setModal("add"); };
  const openEdit = (m) => { setForm({ ...m, costMode: Number(m.lotUnits) > 0 ? "lot" : "unit", lotPrice: m.lotPrice ?? "", lotUnits: m.lotUnits ?? "", taxable: m.taxable !== undefined ? m.taxable : !!globalTaxOn, taxRate: m.taxRate ?? globalTaxRate, link: m.link || "", categoryId: m.categoryId || "" }); setModal(m); };
  const close = () => setModal(null);

  const lotPrice = Number(form.lotPrice) || 0;
  const lotUnits = Number(form.lotUnits) || 0;
  const lotUnitCost = lotUnits > 0 ? lotPrice / lotUnits : 0;
  const effCost = (m) => matEffectiveCost(m);

  // ── Category management ──
  const addCat = () => {
    const name = newCatName.trim();
    if (!name) return;
    if (categories.some(c => c.name.toLowerCase() === name.toLowerCase())) { setNewCatName(""); return; }
    categoriesDispatch && categoriesDispatch({ type: "ADD", item: { name, position: categories.length } });
    setNewCatName("");
  };
  const renameCat = (id, name) => categoriesDispatch && categoriesDispatch({ type: "UPDATE", id, changes: { name } });
  const deleteCat = (id) => categoriesDispatch && categoriesDispatch({ type: "DELETE", id });
  const moveCat = (idx, dir) => {
    const j = idx + dir;
    if (j < 0 || j >= categories.length) return;
    const a = categories[idx], b = categories[j];
    categoriesDispatch && categoriesDispatch({ type: "UPDATE", id: a.id, changes: { position: j } });
    categoriesDispatch && categoriesDispatch({ type: "UPDATE", id: b.id, changes: { position: idx } });
  };

  const q = search.trim().toLowerCase();
  const filtered = q ? materials.filter(m => [m.name, m.unit].filter(Boolean).some(v => String(v).toLowerCase().includes(q))) : materials;
  const matGroups = groupRowsBySection(filtered, categories, m => m.categoryId);
  const usingCategories = !(categories.length === 0 || matGroups.length === 0);
  const toggleGroup = (k) => setExpanded(e => ({ ...e, [k]: !e[k] }));
  const allExpanded = matGroups.length > 0 && matGroups.every(g => expanded[g.key]);
  const toggleAllGroups = () => setExpanded(allExpanded ? {} : Object.fromEntries(matGroups.map(g => [g.key, true])));

  const save = () => {
    if (!form.name) return;
    const lotMode = form.costMode === "lot";
    const cost = lotMode && lotUnits > 0 ? lotPrice / lotUnits : Number(form.cost) || 0;
    const taxable = !!form.taxable;
    const taxRate = taxable ? (Number(form.taxRate) || 0) : 0;
    const qty = Number(form.qty) || 0;
    const item = {
      name: form.name, unit: form.unit || "",
      qty,
      cost,
      lotPrice: lotMode ? lotPrice : null,
      lotUnits: lotMode ? lotUnits : null,
      lowAlert: Number(form.lowAlert) || 10,
      taxable, taxRate,
      link: (form.link || "").trim(),
      categoryId: form.categoryId || null,
    };
    const isAdd = modal === "add";
    if (isAdd) dispatch({ type: "ADD", item }); else dispatch({ type: "UPDATE", id: modal.id, changes: item });
    // On a brand-new material with real stock + cost, ask whether this was a purchase
    // to log as an expense (it might be donated or carried over, so never assume).
    const purchaseValue = cost * (1 + (taxable ? taxRate : 0) / 100) * qty;
    if (isAdd && qty > 0 && cost > 0 && onLogPurchase) {
      setPurchasePrompt({ name: form.name, amount: purchaseValue });
    }
    close();
  };
  return (
    <div>
      <div className="app-card" style={{ ...styles.card, display: "flex", alignItems: "center", gap: 14, flexWrap: "wrap" }}>
        <span style={{ fontSize: 13, fontWeight: 700, color: C.text }}>🧾 Default material tax</span>
        <label style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer" }}>
          <input type="checkbox" checked={!!globalTaxOn} onChange={e => setGlobalTaxOn && setGlobalTaxOn(e.target.checked)} style={{ width: 16, height: 16 }} />
          <span style={{ fontSize: 13 }}>Tax new materials by default</span>
        </label>
        <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
          <span style={{ fontSize: 13, color: C.muted }}>Default rate</span>
          <input type="number" step="any" style={{ ...styles.input, width: 90 }} value={globalTaxRate || ""} onChange={e => setGlobalTaxRate && setGlobalTaxRate(e.target.value)} placeholder="0" />
          <span style={{ fontSize: 13, color: C.muted }}>%</span>
        </span>
        <span style={{ fontSize: 12, color: C.textSoft }}>Seeds each new material — you can still override tax per material.</span>
      </div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16, gap: 8, flexWrap: "wrap" }}>
        <input style={{ ...styles.input, maxWidth: 260 }} placeholder="Search materials…" value={search} onChange={e => setSearch(e.target.value)} />
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          {matGroups.length > 1 && <button style={styles.btn("ghost")} onClick={toggleAllGroups}>{allExpanded ? "Collapse all" : "Expand all"}</button>}
          <button style={styles.btn("ghost")} onClick={() => setManageCats(true)}>📂 Categories</button>
          <button style={styles.btn("primary")} onClick={openAdd}>+ Add Material</button>
        </div>
      </div>
      {(() => {
        const matColumns = [
          { key: "name", header: "Material", primary: true },
          { key: "unit", header: "Unit" },
          { key: "qty", header: "Qty on Hand", strong: true },
          { key: "cost", header: "Unit Cost", render: m => <span>${effCost(m).toFixed(2)}{m.taxable ? <span style={{ color: C.goldDark, fontSize: 11, marginLeft: 4 }}>+{Number(m.taxRate || 0)}% tax</span> : null}{Number(m.lotUnits) > 0 ? <span style={{ color: C.textSoft, fontSize: 11, marginLeft: 4 }}>(${Number(m.lotPrice).toFixed(2)} / {Number(m.lotUnits)})</span> : null}</span> },
          { key: "link", header: "Link", render: m => m.link ? <a href={m.link} target="_blank" rel="noopener noreferrer" onClick={e => e.stopPropagation()} style={{ color: C.goldDark, fontWeight: 700, fontSize: 12, textDecoration: "none" }}>Open ↗</a> : <span style={{ color: C.textSoft, fontSize: 12 }}>—</span> },
          { key: "status", header: "Status", render: m => <StockBadge qty={m.qty} low={m.lowAlert} /> },
        ];
        const matActions = m => (
          <>
            <button style={{ ...styles.btn("ghost"), fontSize: 12, padding: "5px 10px" }} onClick={() => openEdit(m)}>Edit</button>
            <button style={{ ...styles.btn("danger"), fontSize: 12, padding: "5px 10px", marginLeft: 6 }} onClick={() => dispatch({ type: "DELETE", id: m.id })}>Remove</button>
          </>
        );
        if (!usingCategories) {
          return (
            <div className="app-card" style={styles.card}>
              <ResponsiveTable rows={filtered} columns={matColumns} actions={matActions} emptyText={q ? "No materials match your search." : "No materials tracked yet."} />
            </div>
          );
        }
        return matGroups.map(g => {
          const isCollapsed = !expanded[g.key];
          const catCost = g.rows.reduce((s, m) => s + effCost(m) * Number(m.qty || 0), 0);
          return (
            <div key={g.key} className="app-card" style={styles.card}>
              <div onClick={() => toggleGroup(g.key)} style={{ ...styles.sectionTitle, marginBottom: isCollapsed ? 0 : 12, fontSize: 16, cursor: "pointer", userSelect: "none", display: "flex", alignItems: "center" }}>
                <span style={{ fontSize: 13, color: C.muted, width: 14, display: "inline-block" }}>{isCollapsed ? "▸" : "▾"}</span>
                📂 {g.name} <span style={{ fontSize: 12, fontWeight: 600, color: C.textSoft, marginLeft: 6 }}>· {g.rows.length}</span>
                <span style={{ marginLeft: "auto", fontSize: 14, fontWeight: 700, color: C.sageDark }}>${catCost.toFixed(2)}</span>
              </div>
              {!isCollapsed && <ResponsiveTable rows={g.rows} columns={matColumns} actions={matActions} emptyText="No materials in this category." />}
            </div>
          );
        });
      })()}
      {modal && (
        <Modal title={modal === "add" ? "Add Material" : "Edit Material"} onClose={close}>
          <Field label="Material Name"><input style={styles.input} value={form.name || ""} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="e.g. 8 oz Glass Jars" /></Field>
          <div className="grid-2" style={styles.grid2}>
            <Field label="Unit"><input style={styles.input} value={form.unit || ""} onChange={e => setForm({ ...form, unit: e.target.value })} placeholder="e.g. jars, lbs" /></Field>
            <Field label="Quantity"><input style={styles.input} type="number" value={form.qty ?? ""} onChange={e => setForm({ ...form, qty: e.target.value })} /></Field>
          </div>

          <Field label="Category (optional)">
            <select style={styles.input} value={form.categoryId || ""} onChange={e => setForm({ ...form, categoryId: e.target.value })}>
              <option value="">— No category (Uncategorized) —</option>
              {categories.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          </Field>

          <Field label="Cost basis">
            <div style={{ display: "flex", gap: 8 }}>
              <button style={styles.subNavBtn(form.costMode !== "lot")} onClick={() => setForm({ ...form, costMode: "unit" })}>Per unit</button>
              <button style={styles.subNavBtn(form.costMode === "lot")} onClick={() => setForm({ ...form, costMode: "lot" })}>From a lot price</button>
            </div>
          </Field>

          {form.costMode === "lot" ? (
            <>
              <div className="grid-2" style={styles.grid2}>
                <Field label="Lot / bulk price ($)"><input style={styles.input} type="number" step="any" value={form.lotPrice ?? ""} onChange={e => setForm({ ...form, lotPrice: e.target.value })} placeholder="e.g. 120" autoFocus /></Field>
                <Field label="Units in the lot"><input style={styles.input} type="number" step="any" value={form.lotUnits ?? ""} onChange={e => setForm({ ...form, lotUnits: e.target.value })} placeholder="e.g. 144" /></Field>
              </div>
              <div style={{ padding: "10px 14px", background: lotUnitCost > 0 ? C.sageLight : C.bg, borderRadius: 8, marginBottom: 14, fontSize: 14, color: lotUnitCost > 0 ? C.sageDark : C.textSoft }}>
                {lotUnitCost > 0
                  ? <>Per-unit cost: <strong>${lotUnitCost.toFixed(4)}</strong> <span style={{ color: C.muted, fontSize: 12 }}>(${lotPrice.toFixed(2)} ÷ {lotUnits})</span> — this feeds product cost &amp; margins.</>
                  : <>Enter a lot price and unit count to compute the per-unit cost.</>}
              </div>
              <Field label="Low Stock Alert"><input style={styles.input} type="number" value={form.lowAlert ?? ""} onChange={e => setForm({ ...form, lowAlert: e.target.value })} /></Field>
            </>
          ) : (
            <div className="grid-2" style={styles.grid2}>
              <Field label="Cost per Unit ($)"><input style={styles.input} type="number" step="any" value={form.cost ?? ""} onChange={e => setForm({ ...form, cost: e.target.value })} /></Field>
              <Field label="Low Stock Alert"><input style={styles.input} type="number" value={form.lowAlert ?? ""} onChange={e => setForm({ ...form, lowAlert: e.target.value })} /></Field>
            </div>
          )}

          <label style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 12px", background: C.bg, borderRadius: 8, border: `1px solid ${C.border}`, cursor: "pointer", marginBottom: form.taxable ? 8 : 14 }}>
            <input type="checkbox" checked={!!form.taxable} onChange={e => setForm({ ...form, taxable: e.target.checked })} style={{ width: 18, height: 18 }} />
            <span style={{ fontSize: 14, fontWeight: 600 }}>Cost includes sales tax</span>
            <span style={{ fontSize: 12, color: C.textSoft }}>— adds to the per-unit cost used in product margins.</span>
          </label>
          {form.taxable && (
            <Field label="Tax rate (%)">
              <input style={{ ...styles.input, maxWidth: 140 }} type="number" step="any" value={form.taxRate ?? ""} onChange={e => setForm({ ...form, taxRate: e.target.value })} placeholder={String(globalTaxRate || 0)} />
              <span style={{ fontSize: 12, color: C.muted, marginLeft: 8 }}>Effective unit cost: <strong>${(((Number(form.costMode === "lot" && lotUnits > 0 ? lotUnitCost : form.cost) || 0)) * (1 + (Number(form.taxRate) || 0) / 100)).toFixed(4)}</strong></span>
            </Field>
          )}

          <Field label="Link (optional)">
            <input style={styles.input} type="url" value={form.link || ""} onChange={e => setForm({ ...form, link: e.target.value })} placeholder="https://… where you reorder this" />
          </Field>

          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 8 }}>
            <button style={styles.btn("ghost")} onClick={close}>Cancel</button>
            <button style={styles.btn("primary")} onClick={save}>Save Material</button>
          </div>
        </Modal>
      )}
      {purchasePrompt && (
        <Modal title="Log this as a purchase?" onClose={() => setPurchasePrompt(null)}>
          <p style={{ fontSize: 14, color: C.text, marginBottom: 14 }}>
            You added <strong>{purchasePrompt.name}</strong>. Was this a new purchase you want recorded in Expenses
            {purchasePrompt.amount > 0 ? <> (<strong>${purchasePrompt.amount.toFixed(2)}</strong>)</> : null}? If it was donated or carried over, skip it.
          </p>
          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
            <button style={styles.btn("ghost")} onClick={() => setPurchasePrompt(null)}>No — donated / other</button>
            <button style={styles.btn("primary")} onClick={() => { onLogPurchase(purchasePrompt); setPurchasePrompt(null); }}>Yes, add to Expenses</button>
          </div>
        </Modal>
      )}
      {manageCats && (
        <Modal title="Material Categories" onClose={() => setManageCats(false)}>
          <div style={{ fontSize: 13, color: C.muted, marginBottom: 14 }}>
            Categories group materials on the Materials page (e.g. Amazon, Bottles, Honey). Reorder to control the display order; "Uncategorized" always shows last.
          </div>
          <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
            <input style={{ ...styles.input, flex: 1 }} value={newCatName} onChange={e => setNewCatName(e.target.value)} onKeyDown={e => { if (e.key === "Enter") addCat(); }} placeholder="New category (e.g. Bottles)" />
            <button style={styles.btn("primary")} onClick={addCat}>+ Add</button>
          </div>
          {categories.length === 0 ? (
            <div style={{ ...styles.empty, padding: "24px 12px" }}>No categories yet. Add one above.</div>
          ) : (
            <div>
              {categories.map((c, idx) => (
                <div key={c.id} style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 0", borderBottom: `1px solid ${C.border}` }}>
                  <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
                    <button style={{ ...styles.btn("ghost"), padding: "1px 8px", fontSize: 12, opacity: idx === 0 ? 0.3 : 1, cursor: idx === 0 ? "not-allowed" : "pointer" }} disabled={idx === 0} onClick={() => moveCat(idx, -1)}>▲</button>
                    <button style={{ ...styles.btn("ghost"), padding: "1px 8px", fontSize: 12, opacity: idx === categories.length - 1 ? 0.3 : 1, cursor: idx === categories.length - 1 ? "not-allowed" : "pointer" }} disabled={idx === categories.length - 1} onClick={() => moveCat(idx, 1)}>▼</button>
                  </div>
                  <input style={{ ...styles.input, flex: 1 }} value={catDraftNames[c.id] ?? c.name}
                    onChange={e => setCatDraftNames({ ...catDraftNames, [c.id]: e.target.value })}
                    onBlur={e => { const v = e.target.value.trim(); if (v && v !== c.name) renameCat(c.id, v); const d = { ...catDraftNames }; delete d[c.id]; setCatDraftNames(d); }} />
                  <button style={{ ...styles.btn("danger"), fontSize: 12, padding: "6px 10px" }} onClick={() => deleteCat(c.id)}>Remove</button>
                </div>
              ))}
            </div>
          )}
          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
            <button style={styles.btn("primary")} onClick={() => setManageCats(false)}>Done</button>
          </div>
        </Modal>
      )}
    </div>
  );
}

// ── Expenses ───────────────────────────────────────────────────────────────
function Expenses({ expenses, dispatch }) {
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({});
  const openAdd = () => { setForm({ date: new Date().toISOString().slice(0, 10), category: "", description: "", amount: "" }); setModal(true); };
  const close = () => setModal(false);
  const save = () => {
    if (!form.description) return;
    dispatch({ type: "ADD", item: { ...form, amount: Number(form.amount) || 0 } });
    close();
  };
  const total = expenses.reduce((s, e) => s + Number(e.amount), 0);
  const byCategory = expenses.reduce((acc, e) => { acc[e.category] = (acc[e.category] || 0) + Number(e.amount); return acc; }, {});
  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
        <div style={styles.statCard(C.dangerLight)}><div style={{ ...styles.statNum, color: C.danger, fontSize: 24 }}>${total.toFixed(2)}</div><div style={styles.statLabel}>Total Expenses</div></div>
        <button style={styles.btn("primary")} onClick={openAdd}>+ Add Expense</button>
      </div>
      {Object.keys(byCategory).length > 0 && (
        <div className="app-card" style={styles.card}>
          <div style={styles.sectionTitle}>By Category</div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
            {Object.entries(byCategory).map(([cat, amt]) => (
              <div key={cat} style={{ background: C.bg, border: `1px solid ${C.border}`, borderRadius: 8, padding: "10px 16px" }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: C.amber }}>${amt.toFixed(2)}</div>
                <div style={{ fontSize: 12, color: C.muted }}>{cat}</div>
              </div>
            ))}
          </div>
        </div>
      )}
      <div className="app-card" style={styles.card}>
        <ResponsiveTable
          rows={[...expenses].reverse()}
          emptyText="No expenses logged yet."
          columns={[
            { key: "date", header: "Date" },
            { key: "category", header: "Category", render: e => <span style={{ background: C.goldLight, color: C.goldDark, borderRadius: 6, padding: "3px 9px", fontSize: 12, fontWeight: 600 }}>{e.category}</span> },
            { key: "description", header: "Description", primary: true },
            { key: "amount", header: "Amount", render: e => `$${Number(e.amount).toFixed(2)}`, tdStyle: () => ({ fontWeight: 700, color: C.danger }) },
          ]}
          actions={e => (
            <button style={{ ...styles.btn("danger"), fontSize: 12, padding: "5px 10px" }} onClick={() => dispatch({ type: "DELETE", id: e.id })}>Remove</button>
          )}
        />
      </div>
      {modal && (
        <Modal title="Add Expense" onClose={close}>
          <div className="grid-2" style={styles.grid2}>
            <Field label="Date"><input style={styles.input} type="date" value={form.date || ""} onChange={e => setForm({ ...form, date: e.target.value })} /></Field>
            <Field label="Category"><input style={styles.input} value={form.category || ""} onChange={e => setForm({ ...form, category: e.target.value })} placeholder="e.g. Supplies, Market Fee" /></Field>
          </div>
          <Field label="Description"><input style={styles.input} value={form.description || ""} onChange={e => setForm({ ...form, description: e.target.value })} placeholder="e.g. Bulk jar order" /></Field>
          <Field label="Amount ($)"><input style={styles.input} type="number" value={form.amount ?? ""} onChange={e => setForm({ ...form, amount: e.target.value })} /></Field>
          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 8 }}>
            <button style={styles.btn("ghost")} onClick={close}>Cancel</button>
            <button style={styles.btn("primary")} onClick={save}>Save Expense</button>
          </div>
        </Modal>
      )}
    </div>
  );
}

// ── Customers ──────────────────────────────────────────────────────────────
function Customers({ customers, dispatch, allOrders }) {
  const [modal, setModal] = useState(null); // null | "add" | customer
  const [form, setForm] = useState({});
  const [search, setSearch] = useState("");
  const [detail, setDetail] = useState(null); // customer whose history is shown

  const openAdd = () => { setForm({ name: "", email: "", phone: "", notes: "" }); setModal("add"); };
  const openEdit = (c) => { setForm({ ...c }); setModal(c); };
  const close = () => setModal(null);
  const save = () => {
    if (!form.name && !form.email && !form.phone) return;
    const item = { name: form.name || "", email: form.email || "", phone: form.phone || "", notes: form.notes || "" };
    if (modal === "add") dispatch({ type: "ADD", item }); else dispatch({ type: "UPDATE", id: modal.id, changes: item });
    close();
  };

  // Match a customer's purchases across all sales channels (by email, else name)
  const historyFor = (c) => (allOrders || []).filter(o => {
    if (c.email && o.customerEmail) return o.customerEmail.toLowerCase() === c.email.toLowerCase();
    return c.name && o.customer && o.customer.toLowerCase() === c.name.toLowerCase();
  });
  const totalSpent = (c) => historyFor(c).reduce((s, o) => s + Number(o.total || 0), 0);

  const filtered = customers.filter(c => [c.name, c.email, c.phone].some(v => v?.toLowerCase().includes(search.toLowerCase())));

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
        <input style={{ ...styles.input, maxWidth: 280 }} placeholder="Search customers…" value={search} onChange={e => setSearch(e.target.value)} />
        <button style={styles.btn("primary")} onClick={openAdd}>+ Add Customer</button>
      </div>

      <div className="app-card" style={styles.card}>
        <ResponsiveTable
          rows={filtered}
          emptyText="No customers yet. Add one here, or capture them at checkout during a sale."
          columns={[
            { key: "name", header: "Name", primary: true, render: c => c.name || <span style={{ color: C.textSoft }}>—</span> },
            { key: "email", header: "Email", render: c => c.email || "—" },
            { key: "phone", header: "Phone", render: c => c.phone || "—" },
            { key: "spent", header: "Total Spent", render: c => `$${totalSpent(c).toFixed(2)}`, tdStyle: () => ({ fontWeight: 700, color: C.sageDark }) },
            { key: "orders", header: "Orders", render: c => historyFor(c).length },
          ]}
          actions={c => (
            <>
              <button style={{ ...styles.btn("sage"), fontSize: 12, padding: "5px 10px" }} onClick={() => setDetail(c)}>History</button>
              <button style={{ ...styles.btn("ghost"), fontSize: 12, padding: "5px 10px", marginLeft: 6 }} onClick={() => openEdit(c)}>Edit</button>
              <button style={{ ...styles.btn("danger"), fontSize: 12, padding: "5px 10px", marginLeft: 6 }} onClick={() => dispatch({ type: "DELETE", id: c.id })}>Remove</button>
            </>
          )}
        />
      </div>

      {modal && (
        <Modal title={modal === "add" ? "Add Customer" : "Edit Customer"} onClose={close}>
          <Field label="Name"><input style={styles.input} value={form.name || ""} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="Customer name" autoFocus /></Field>
          <div className="grid-2" style={styles.grid2}>
            <Field label="Email"><input style={styles.input} value={form.email || ""} onChange={e => setForm({ ...form, email: e.target.value })} placeholder="email@example.com" /></Field>
            <Field label="Phone"><input style={styles.input} value={form.phone || ""} onChange={e => setForm({ ...form, phone: e.target.value })} placeholder="Phone" /></Field>
          </div>
          <Field label="Notes"><input style={styles.input} value={form.notes || ""} onChange={e => setForm({ ...form, notes: e.target.value })} placeholder="e.g. prefers wildflower, met at farmers market" /></Field>
          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 8 }}>
            <button style={styles.btn("ghost")} onClick={close}>Cancel</button>
            <button style={styles.btn("primary")} onClick={save}>Save Customer</button>
          </div>
        </Modal>
      )}

      {detail && (
        <Modal title={`${detail.name || detail.email || "Customer"} — Purchase History`} onClose={() => setDetail(null)}>
          {detail.notes && <div style={{ fontSize: 13, color: C.muted, marginBottom: 12, fontStyle: "italic" }}>{detail.notes}</div>}
          {historyFor(detail).length === 0 ? (
            <div style={styles.empty}>No purchases recorded yet.</div>
          ) : (
            <div>
              {[...historyFor(detail)].reverse().map(o => (
                <div key={o.id} style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: `1px solid ${C.border}` }}>
                  <div>
                    <div style={{ fontSize: 14 }}>{o.items}</div>
                    <div style={{ fontSize: 12, color: C.muted }}>{o.date}</div>
                  </div>
                  <div style={{ fontWeight: 700 }}>${Number(o.total).toFixed(2)}</div>
                </div>
              ))}
              <div style={{ display: "flex", justifyContent: "space-between", paddingTop: 12, fontWeight: 800, color: C.sageDark }}>
                <span>Total</span><span>${totalSpent(detail).toFixed(2)}</span>
              </div>
            </div>
          )}
        </Modal>
      )}
    </div>
  );
}

// ── Financials ─────────────────────────────────────────────────────────────
function Financials({ allSales, expenses }) {
  const [period, setPeriod] = useState("month"); // month | quarter | ytd | all | custom
  const [customFrom, setCustomFrom] = useState("");
  const [customTo, setCustomTo] = useState("");

  const now = new Date();
  const y = now.getFullYear();
  const m = now.getMonth();

  // Determine the active [from, to] date range (inclusive) as YYYY-MM-DD strings
  const range = (() => {
    const iso = (d) => d.toISOString().slice(0, 10);
    if (period === "month") return [iso(new Date(y, m, 1)), iso(new Date(y, m + 1, 0))];
    if (period === "quarter") { const qStart = Math.floor(m / 3) * 3; return [iso(new Date(y, qStart, 1)), iso(new Date(y, qStart + 3, 0))]; }
    if (period === "ytd") return [iso(new Date(y, 0, 1)), iso(new Date(y, 11, 31))];
    if (period === "custom") return [customFrom || "0000-01-01", customTo || "9999-12-31"];
    return ["0000-01-01", "9999-12-31"]; // all
  })();

  const inRange = (dateStr) => dateStr && dateStr >= range[0] && dateStr <= range[1];

  const periodSales = allSales.filter(s => s.status === "Fulfilled" && inRange(s.date));
  const periodExpenses = expenses.filter(e => inRange(e.date));
  const revenue = periodSales.reduce((s, o) => s + Number(o.total || 0), 0);
  const expenseTotal = periodExpenses.reduce((s, e) => s + Number(e.amount || 0), 0);
  const net = revenue - expenseTotal;

  // Monthly breakdown within the active range
  const monthly = {};
  periodSales.forEach(s => { const k = s.date.slice(0, 7); monthly[k] = monthly[k] || { rev: 0, exp: 0 }; monthly[k].rev += Number(s.total || 0); });
  periodExpenses.forEach(e => { const k = (e.date || "").slice(0, 7); if (!k) return; monthly[k] = monthly[k] || { rev: 0, exp: 0 }; monthly[k].exp += Number(e.amount || 0); });
  const months = Object.keys(monthly).sort().reverse();
  const monthName = (k) => { const [yy, mm] = k.split("-"); return new Date(Number(yy), Number(mm) - 1, 1).toLocaleString("default", { month: "long", year: "numeric" }); };

  const periodLabels = { month: "This Month", quarter: "This Quarter", ytd: "Year to Date", all: "All Time", custom: "Custom Range" };

  return (
    <div>
      {/* Period selector */}
      <div className="app-card" style={styles.card}>
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: period === "custom" ? 12 : 0 }}>
          {["month", "quarter", "ytd", "all", "custom"].map(p => (
            <button key={p} onClick={() => setPeriod(p)} style={styles.subNavBtn(period === p)}>{periodLabels[p]}</button>
          ))}
        </div>
        {period === "custom" && (
          <div className="grid-2" style={styles.grid2}>
            <Field label="From"><input style={styles.input} type="date" value={customFrom} onChange={e => setCustomFrom(e.target.value)} /></Field>
            <Field label="To"><input style={styles.input} type="date" value={customTo} onChange={e => setCustomTo(e.target.value)} /></Field>
          </div>
        )}
      </div>

      {/* Summary cards */}
      <div className="stat-grid" style={styles.grid4}>
        <div style={styles.statCard(C.sageLight)}><div style={{ ...styles.statNum, color: C.sageDark }}>${revenue.toFixed(2)}</div><div style={styles.statLabel}>Revenue</div></div>
        <div style={styles.statCard(C.dangerLight)}><div style={{ ...styles.statNum, color: C.danger }}>${expenseTotal.toFixed(2)}</div><div style={styles.statLabel}>Expenses</div></div>
        <div style={styles.statCard(net >= 0 ? C.goldLight : C.dangerLight)}><div style={{ ...styles.statNum, color: net >= 0 ? C.goldDark : C.danger }}>${net.toFixed(2)}</div><div style={styles.statLabel}>Net Profit</div></div>
        <div style={styles.statCard(C.purpleLight)}><div style={{ ...styles.statNum, color: C.purple }}>{periodSales.length}</div><div style={styles.statLabel}>Sales</div></div>
      </div>

      {/* Monthly breakdown */}
      <div className="app-card" style={styles.card}>
        <div style={styles.sectionTitle}>Monthly Breakdown</div>
        <ResponsiveTable
          rows={months.map(k => ({ id: k, month: monthName(k), rev: monthly[k].rev, exp: monthly[k].exp, net: monthly[k].rev - monthly[k].exp }))}
          emptyText="No activity in this period."
          columns={[
            { key: "month", header: "Month", primary: true },
            { key: "rev", header: "Revenue", render: r => `$${r.rev.toFixed(2)}`, tdStyle: () => ({ color: C.sageDark, fontWeight: 600 }) },
            { key: "exp", header: "Expenses", render: r => `$${r.exp.toFixed(2)}`, tdStyle: () => ({ color: C.danger }) },
            { key: "net", header: "Net", render: r => `$${r.net.toFixed(2)}`, tdStyle: r => ({ fontWeight: 700, color: r.net >= 0 ? C.goldDark : C.danger }) },
          ]}
        />
      </div>

      {/* Individual sales in this period */}
      <div className="app-card" style={styles.card}>
        <div style={styles.sectionTitle}>Sales in This Period</div>
        <ResponsiveTable
          rows={[...periodSales].sort((a, b) => (b.date || "").localeCompare(a.date || ""))}
          emptyText="No sales in this period."
          columns={[
            { key: "date", header: "Date", primary: true },
            { key: "channel", header: "Source", render: o => o._channel || "—" },
            { key: "customer", header: "Customer", render: o => o.customer || "—" },
            { key: "items", header: "Items", render: o => <span style={{ color: C.muted }}>{o.items}</span> },
            { key: "total", header: "Amount", render: o => `$${Number(o.total || 0).toFixed(2)}`, tdStyle: () => ({ fontWeight: 700, color: C.sageDark }) },
          ]}
        />
      </div>
    </div>
  );
}

// ── Team (owner-only staff management) ─────────────────────────────────────
function Team() {
  const [staff, setStaff] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showInvite, setShowInvite] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");

  const callFn = async (body) => {
    const { data: sessionData } = await supabase.auth.getSession();
    const token = sessionData?.session?.access_token || "";
    const res = await fetch(`${SUPABASE_URL}/functions/v1/manage-staff`, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Authorization": `Bearer ${token}` },
      body: JSON.stringify(body),
    });
    return res.json();
  };

  const load = async () => {
    setLoading(true);
    const r = await callFn({ action: "list" });
    setStaff(r.staff || []);
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const invite = async () => {
    setMsg(""); setBusy(true);
    const r = await callFn({ action: "invite", email: email.trim(), password });
    setBusy(false);
    if (r.error) { setMsg("⚠️ " + r.error); return; }
    setShowInvite(false); setEmail(""); setPassword(""); setMsg("");
    load();
  };

  const remove = async (member) => {
    if (!window.confirm(`Remove ${member.email}? They will no longer be able to sign in.`)) return;
    const r = await callFn({ action: "remove", userId: member.id });
    if (r.error) { setMsg("⚠️ " + r.error); return; }
    load();
  };

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
        <div>
          <div style={{ fontSize: 22, fontWeight: 800, color: C.amber }}>Team</div>
          <div style={{ fontSize: 13, color: C.muted, marginTop: 4 }}>Staff accounts can only access the Events selling view.</div>
        </div>
        <button style={styles.btn("primary")} onClick={() => { setMsg(""); setShowInvite(true); }}>+ Add Staff</button>
      </div>

      {msg && <div className="app-card" style={{ ...styles.card, color: C.danger, fontSize: 14 }}>{msg}</div>}

      <div className="app-card" style={styles.card}>
        <ResponsiveTable
          rows={staff}
          emptyText={loading ? "Loading…" : "No staff accounts yet. Add one to let someone work events."}
          columns={[
            { key: "email", header: "Staff Email", primary: true },
            { key: "role", header: "Access", render: () => "Events only" },
          ]}
          actions={m => (
            <button style={{ ...styles.btn("danger"), fontSize: 12, padding: "5px 10px" }} onClick={() => remove(m)}>Remove</button>
          )}
        />
      </div>

      {showInvite && (
        <Modal title="Add Staff Account" onClose={() => setShowInvite(false)}>
          <p style={{ fontSize: 13, color: C.muted, marginBottom: 14 }}>
            Create a login for someone who works your events. They'll be able to sign in and use only the Events selling view — nothing else.
          </p>
          <Field label="Their Email"><input style={styles.input} type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="staff@example.com" autoFocus /></Field>
          <Field label="Temporary Password"><input style={styles.input} value={password} onChange={e => setPassword(e.target.value)} placeholder="They can use this to sign in" /></Field>
          <div style={{ fontSize: 12, color: C.textSoft, marginBottom: 14 }}>Share these with your staff member so they can log in. They can use it right away — no email confirmation needed.</div>
          {msg && <div style={{ fontSize: 13, color: C.danger, marginBottom: 12 }}>{msg}</div>}
          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
            <button style={styles.btn("ghost")} onClick={() => setShowInvite(false)}>Cancel</button>
            <button style={{ ...styles.btn("primary"), opacity: busy ? 0.6 : 1 }} disabled={busy} onClick={invite}>{busy ? "Creating…" : "Create Staff Login"}</button>
          </div>
        </Modal>
      )}
    </div>
  );
}

// ── Dashboard ──────────────────────────────────────────────────────────────
const DASH_WIDGETS = [
  { id: "stats", label: "Financial summary", def: true },
  { id: "threeMonth", label: "Last 3 months", def: true },
  { id: "topSellers", label: "Top 5 sellers", def: true },
  { id: "inventory", label: "Value in inventory", def: true },
  { id: "collective", label: "Value in Collective", def: true },
  { id: "attention", label: "Low-stock alerts", def: true },
  { id: "events", label: "Upcoming events", def: false },
  { id: "products", label: "Product stock list", def: false },
  { id: "orders", label: "Recent orders", def: false },
];
// Merge a saved layout with the master list: keep saved order + on/off, then append
// any widgets the saved layout doesn't mention using each widget's default on/off.
function normalizeDashLayout(layout) {
  const saved = Array.isArray(layout) ? layout : null;
  const ordered = [];
  if (saved) saved.forEach(w => { if (w && DASH_WIDGETS.some(d => d.id === w.id) && !ordered.some(o => o.id === w.id)) ordered.push({ id: w.id, on: w.on !== false }); });
  DASH_WIDGETS.forEach(d => { if (!ordered.some(o => o.id === d.id)) ordered.push({ id: d.id, on: saved ? !!d.def : d.def !== false ? true : false }); });
  // When there's no saved layout at all, honor each widget's default.
  if (!saved) return DASH_WIDGETS.map(d => ({ id: d.id, on: !!d.def }));
  return ordered;
}
// Pull { label, qty } pairs out of an order's items text ("Wildflower 8oz x2, Clover x1").
function parseSaleItems(itemsText) {
  if (!itemsText) return [];
  return String(itemsText).split(",").map(seg => {
    const main = seg.split("·")[0].trim(); // drop any trailing "· note"
    const m = main.match(/^(.+?)\s+x\s*(\d+)$/i);
    return m ? { label: m[1].trim(), qty: Number(m[2]) || 0 } : null;
  }).filter(Boolean);
}

function Dashboard({ products, materials, orders, storeOrders, eventOrders, singleSales = [], expenses, events = [], storeInv = [], layout, onSaveLayout }) {
  const [customize, setCustomize] = useState(false);
  const [draft, setDraft] = useState([]);

  const allFulfilled = [...orders, ...storeOrders, ...eventOrders, ...singleSales].filter(o => o.status === "Fulfilled");
  const allPending = [...orders, ...storeOrders, ...eventOrders].filter(o => o.status === "Pending");
  const netSales = allFulfilled.reduce((s, o) => s + Number(o.subtotal != null ? o.subtotal : o.total || 0), 0);
  const taxCollected = allFulfilled.reduce((s, o) => s + Number(o.tax || 0), 0);
  const pendingRevenue = allPending.reduce((s, o) => s + Number(o.total), 0);
  const totalExpenses = expenses.reduce((s, e) => s + Number(e.amount), 0);
  const lowProducts = products.filter(p => p.qty <= p.lowAlert);
  const lowMaterials = materials.filter(m => m.qty <= m.lowAlert);
  const invUnits = products.reduce((s, p) => s + Number(p.qty || 0), 0);
  const invValue = products.reduce((s, p) => s + Number(p.qty || 0) * Number(p.price || 0), 0);
  const collectiveUnits = storeInv.reduce((s, i) => s + Number(i.qty || 0), 0);
  const collectiveValue = storeInv.reduce((s, i) => s + Number(i.qty || 0) * Number(i.price || 0), 0);
  const today = new Date().toISOString().slice(0, 10);
  const upcoming = [...events].filter(e => e.date && e.date >= today).sort((a, b) => String(a.date).localeCompare(String(b.date))).slice(0, 5);

  // Top 5 sellers by units, parsed from item text across every fulfilled sale.
  const sellerCounts = {};
  allFulfilled.forEach(o => parseSaleItems(o.items).forEach(({ label, qty }) => { sellerCounts[label] = (sellerCounts[label] || 0) + qty; }));
  const topSellers = Object.entries(sellerCounts).sort((a, b) => b[1] - a[1]).slice(0, 5);

  // Last 3 calendar months: net sales, expenses, profit.
  const now = new Date();
  const months = [2, 1, 0].map(i => { const dt = new Date(now.getFullYear(), now.getMonth() - i, 1); return { key: `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, "0")}`, label: dt.toLocaleString("en-US", { month: "short" }) }; });
  const monthFin = months.map(mn => {
    const sales = allFulfilled.filter(o => String(o.date || "").slice(0, 7) === mn.key).reduce((s, o) => s + Number(o.subtotal != null ? o.subtotal : o.total || 0), 0);
    const exp = expenses.filter(e => String(e.date || "").slice(0, 7) === mn.key).reduce((s, e) => s + Number(e.amount || 0), 0);
    return { ...mn, sales, exp, net: sales - exp };
  });

  const widgets = normalizeDashLayout(layout);
  const openCustomize = () => { setDraft(widgets.map(w => ({ ...w }))); setCustomize(true); };
  const toggleDraft = (id) => setDraft(d => d.map(w => w.id === id ? { ...w, on: !w.on } : w));
  const moveDraft = (idx, dir) => setDraft(d => { const j = idx + dir; if (j < 0 || j >= d.length) return d; const n = [...d]; const t = n[idx]; n[idx] = n[j]; n[j] = t; return n; });
  const saveLayout = () => { onSaveLayout && onSaveLayout(draft); setCustomize(false); };
  const labelOf = (id) => (DASH_WIDGETS.find(w => w.id === id) || {}).label || id;

  const renderWidget = (id) => {
    switch (id) {
      case "stats":
        return (
          <div className="stat-grid" style={styles.grid4}>
            <div style={styles.statCard(C.goldLight)}><div style={styles.statNum}>${netSales.toLocaleString(undefined, { maximumFractionDigits: 0 })}</div><div style={styles.statLabel}>Sales (net of tax)</div></div>
            <div style={styles.statCard(C.goldLight)}><div style={{ ...styles.statNum, color: C.amber }}>${taxCollected.toLocaleString(undefined, { maximumFractionDigits: 2 })}</div><div style={styles.statLabel}>Tax Collected</div></div>
            <div style={styles.statCard(C.sageLight)}><div style={{ ...styles.statNum, color: C.sageDark }}>${pendingRevenue.toLocaleString()}</div><div style={styles.statLabel}>Pending Orders</div></div>
            <div style={styles.statCard(C.dangerLight)}><div style={{ ...styles.statNum, color: C.danger }}>${totalExpenses.toLocaleString()}</div><div style={styles.statLabel}>Total Expenses</div></div>
            <div style={styles.statCard()}><div style={styles.statNum}>${(netSales - totalExpenses).toLocaleString(undefined, { maximumFractionDigits: 0 })}</div><div style={styles.statLabel}>Net (Fulfilled)</div></div>
          </div>
        );
      case "attention":
        return (lowProducts.length > 0 || lowMaterials.length > 0) ? (
          <div style={{ ...styles.card, borderColor: C.danger, background: C.dangerLight }}>
            <div style={{ ...styles.sectionTitle, color: C.danger }}>⚠ Needs Attention</div>
            {lowProducts.map(p => <div key={p.id} style={{ fontSize: 14, marginBottom: 6, color: C.danger }}><strong>{p.name} ({p.size})</strong> — {p.qty === 0 ? "out of stock" : `only ${p.qty} left`}</div>)}
            {lowMaterials.map(m => <div key={m.id} style={{ fontSize: 14, marginBottom: 6, color: C.danger }}><strong>{m.name}</strong> — {m.qty} {m.unit} remaining</div>)}
          </div>
        ) : (
          <div className="app-card" style={styles.card}><div style={styles.sectionTitle}>✓ Stock Health</div><div style={{ fontSize: 14, color: C.muted }}>Everything's above its low-stock alert. Nothing needs attention.</div></div>
        );
      case "inventory":
        return (
          <div className="stat-grid" style={{ display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 16 }}>
            <div style={styles.statCard(C.goldLight)}><div style={styles.statNum}>{invUnits.toLocaleString()}</div><div style={styles.statLabel}>Units on Hand</div></div>
            <div style={styles.statCard(C.sageLight)}><div style={{ ...styles.statNum, color: C.sageDark }}>${invValue.toLocaleString(undefined, { maximumFractionDigits: 0 })}</div><div style={styles.statLabel}>Inventory Retail Value</div></div>
          </div>
        );
      case "collective":
        return (
          <div className="stat-grid" style={{ display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 16 }}>
            <div style={styles.statCard(C.purpleLight)}><div style={{ ...styles.statNum, color: C.purple }}>{collectiveUnits.toLocaleString()}</div><div style={styles.statLabel}>Units at Collective</div></div>
            <div style={styles.statCard(C.purpleLight)}><div style={{ ...styles.statNum, color: C.purple }}>${collectiveValue.toLocaleString(undefined, { maximumFractionDigits: 0 })}</div><div style={styles.statLabel}>Value at Collective</div></div>
          </div>
        );
      case "threeMonth":
        return (
          <div className="app-card" style={styles.card}>
            <div style={styles.sectionTitle}>📈 Last 3 Months</div>
            <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
              {monthFin.map(m => (
                <div key={m.key} style={{ flex: "1 1 110px", border: `1px solid ${C.border}`, borderRadius: 10, padding: "12px 14px", background: C.bg }}>
                  <div style={{ fontSize: 12, fontWeight: 700, color: C.muted, textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: 6 }}>{m.label}</div>
                  <div style={{ fontSize: 18, fontWeight: 800, color: C.text }}>${m.sales.toLocaleString(undefined, { maximumFractionDigits: 0 })}</div>
                  <div style={{ fontSize: 11, color: C.muted, marginBottom: 4 }}>sales</div>
                  <div style={{ fontSize: 13, fontWeight: 700, color: m.net >= 0 ? C.sageDark : C.danger }}>{m.net >= 0 ? "+" : "−"}${Math.abs(m.net).toLocaleString(undefined, { maximumFractionDigits: 0 })} net</div>
                </div>
              ))}
            </div>
          </div>
        );
      case "topSellers":
        return (
          <div className="app-card" style={styles.card}>
            <div style={styles.sectionTitle}>🏆 Top 5 Sellers</div>
            {topSellers.length === 0 ? <div style={{ fontSize: 14, color: C.muted }}>No sales recorded yet.</div> : topSellers.map(([label, qty], i) => (
              <div key={label} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 0", borderBottom: i < topSellers.length - 1 ? `1px solid ${C.border}` : "none" }}>
                <span style={{ fontSize: 14 }}><span style={{ color: C.goldDark, fontWeight: 800, marginRight: 8 }}>{i + 1}</span>{label}</span>
                <span style={{ fontSize: 14, fontWeight: 700 }}>{qty} sold</span>
              </div>
            ))}
          </div>
        );
      case "products":
        return (
          <div className="app-card" style={styles.card}>
            <div style={styles.sectionTitle}>🍯 Products</div>
            {products.length === 0 ? <div style={{ fontSize: 14, color: C.muted }}>No products yet.</div> : products.map(p => (
              <div key={p.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 0", borderBottom: `1px solid ${C.border}` }}>
                <span style={{ fontSize: 14 }}>{p.name} <span style={{ color: C.muted, fontSize: 12 }}>{p.size}</span></span>
                <StockBadge qty={p.qty} low={p.lowAlert} />
              </div>
            ))}
          </div>
        );
      case "orders":
        return (
          <div className="app-card" style={styles.card}>
            <div style={styles.sectionTitle}>📦 Recent Orders (All Channels)</div>
            {[...orders, ...storeOrders, ...eventOrders].sort((a, b) => b.id - a.id).slice(0, 5).map(o => (
              <div key={o.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 0", borderBottom: `1px solid ${C.border}` }}>
                <div><div style={{ fontSize: 14, fontWeight: 600 }}>{o.event || o.customer}</div><div style={{ fontSize: 12, color: C.muted }}>{o.date}</div></div>
                <div style={{ textAlign: "right" }}><div style={{ fontSize: 14, fontWeight: 700 }}>${o.total}</div><span style={styles.badge(o.status === "Fulfilled" ? "ok" : "warn")}>{o.status}</span></div>
              </div>
            ))}
            {[...orders, ...storeOrders, ...eventOrders].length === 0 && <div style={{ fontSize: 14, color: C.muted }}>No orders yet.</div>}
          </div>
        );
      case "events":
        return (
          <div className="app-card" style={styles.card}>
            <div style={styles.sectionTitle}>🎪 Upcoming Events</div>
            {upcoming.length === 0 ? <div style={{ fontSize: 14, color: C.muted }}>No upcoming events scheduled.</div> : upcoming.map(e => (
              <div key={e.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 0", borderBottom: `1px solid ${C.border}` }}>
                <span style={{ fontSize: 14, fontWeight: 600 }}>{e.name}</span>
                <span style={{ fontSize: 13, color: C.muted }}>{e.date}</span>
              </div>
            ))}
          </div>
        );
      default: return null;
    }
  };

  // Pair up the two list-style widgets (products + orders) into a 2-col row when adjacent + both on.
  const active = widgets.filter(w => w.on);
  const blocks = [];
  for (let i = 0; i < active.length; i++) {
    const cur = active[i], next = active[i + 1];
    const pairable = (id) => id === "products" || id === "orders" || id === "events";
    if (cur && next && pairable(cur.id) && pairable(next.id)) {
      blocks.push(<div key={cur.id + next.id} className="grid-2" style={styles.grid2}>{renderWidget(cur.id)}{renderWidget(next.id)}</div>);
      i++;
    } else {
      blocks.push(<Fragment key={cur.id}>{renderWidget(cur.id)}</Fragment>);
    }
  }

  return (
    <div>
      <div style={{ ...styles.card, background: C.amber, color: "#FFF", borderColor: C.amber, marginBottom: 20, display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 8 }}>
        <div>
          <div style={{ fontSize: 13, opacity: 0.7, marginBottom: 4, fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px" }}>Welcome back</div>
          <div style={{ fontSize: 22, fontWeight: 800 }}>Nashville Bee Company Overview</div>
        </div>
        <button style={{ ...styles.btn("ghost"), background: "rgba(255,255,255,0.18)", color: "#FFF", border: "1px solid rgba(255,255,255,0.4)" }} onClick={openCustomize}>⚙ Customize</button>
      </div>

      {active.length === 0 && <div className="app-card" style={styles.card}><div style={{ fontSize: 14, color: C.muted }}>Your dashboard is empty. Tap <strong>⚙ Customize</strong> to choose what to show.</div></div>}
      {blocks}

      {customize && (
        <Modal title="Customize Dashboard" onClose={() => setCustomize(false)}>
          <div style={{ fontSize: 13, color: C.muted, marginBottom: 14 }}>Choose which cards appear and their order. Saved to your account.</div>
          {draft.map((w, idx) => (
            <div key={w.id} style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 0", borderBottom: `1px solid ${C.border}` }}>
              <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <button style={{ ...styles.btn("ghost"), padding: "1px 8px", fontSize: 12, opacity: idx === 0 ? 0.3 : 1, cursor: idx === 0 ? "not-allowed" : "pointer" }} disabled={idx === 0} onClick={() => moveDraft(idx, -1)}>▲</button>
                <button style={{ ...styles.btn("ghost"), padding: "1px 8px", fontSize: 12, opacity: idx === draft.length - 1 ? 0.3 : 1, cursor: idx === draft.length - 1 ? "not-allowed" : "pointer" }} disabled={idx === draft.length - 1} onClick={() => moveDraft(idx, 1)}>▼</button>
              </div>
              <span style={{ flex: 1, fontSize: 14, fontWeight: 600, opacity: w.on ? 1 : 0.5 }}>{labelOf(w.id)}</span>
              <label style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer" }}>
                <input type="checkbox" checked={w.on} onChange={() => toggleDraft(w.id)} style={{ width: 18, height: 18 }} />
                <span style={{ fontSize: 13, color: C.muted }}>{w.on ? "Shown" : "Hidden"}</span>
              </label>
            </div>
          ))}
          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 16 }}>
            <button style={styles.btn("ghost")} onClick={() => setCustomize(false)}>Cancel</button>
            <button style={styles.btn("primary")} onClick={saveLayout}>Save</button>
          </div>
        </Modal>
      )}
    </div>
  );
}

// ── Inventory (current product stock + push to store/event + make batch + single sale) ─
function Inventory({ products, prodDispatch, materials, matDispatch, events, onPushToStore, onPushToEvent, onSingleSale, onExportCsv, sections = [], storeInv = [], eventInv = [] }) {
  const [modal, setModal] = useState(null); // null | product being pushed
  const [pushQty, setPushQty] = useState("");
  const [pushDest, setPushDest] = useState("store"); // "store" | "event"
  const [pushEvent, setPushEvent] = useState(""); // event id
  const [batch, setBatch] = useState(null); // null | product being made
  const [batchQty, setBatchQty] = useState("");
  const [sale, setSale] = useState(null); // null | product being sold (single sale)
  const [saleQty, setSaleQty] = useState("");
  const [search, setSearch] = useState("");
  const [openNames, setOpenNames] = useState({});
  const [expanded, setExpanded] = useState({}); // category groups start collapsed; key present = expanded (Inventory)
  const [srcOnHand, setSrcOnHand] = useState(true);  // which locations fold into the displayed stock
  const [srcColl, setSrcColl] = useState(false);
  const [srcEvt, setSrcEvt] = useState(false);

  const openPush = (p) => { setPushQty(""); setPushDest("store"); setPushEvent((events && events[0]) ? events[0].id : ""); setModal(p); };
  const close = () => setModal(null);
  const openBatch = (p) => { setBatchQty(""); setBatch(p); };
  const closeBatch = () => setBatch(null);
  const openSale = (p) => { setSaleQty(""); setSale(p); };
  const closeSale = () => setSale(null);

  const confirmPush = () => {
    const qty = Number(pushQty);
    if (!qty || qty <= 0 || qty > modal.qty) return;
    if (pushDest === "event" && !pushEvent) return;
    if (pushDest === "store") onPushToStore([{ product: modal, qty }]);
    else onPushToEvent([{ product: modal, qty }], pushEvent);
    prodDispatch({ type: "UPDATE", id: modal.id, changes: { qty: modal.qty - qty } });
    close();
  };

  const confirmSale = () => {
    const qty = Number(saleQty);
    if (!qty || qty <= 0 || qty > sale.qty) return;
    onSingleSale(sale, qty);
    prodDispatch({ type: "UPDATE", id: sale.id, changes: { qty: sale.qty - qty } });
    closeSale();
  };

  // Build the list of materials a batch will consume, with shortfall info
  const matById = (id) => materials.find(m => String(m.id) === String(id));
  const batchPlan = (product, count) => {
    const recipe = product?.recipe || [];
    return recipe.map(r => {
      const m = matById(r.materialId);
      const needed = Number(r.qtyPer) * count;
      const have = m ? Number(m.qty) : 0;
      return { material: m, materialId: r.materialId, needed, have, short: needed > have };
    }).filter(x => x.material);
  };

  const confirmBatch = () => {
    const count = Number(batchQty);
    if (!count || count <= 0) return;
    const plan = batchPlan(batch, count);
    // Deduct materials (allowed to go negative per soft-warning design)
    plan.forEach(x => matDispatch({ type: "UPDATE", id: x.material.id, changes: { qty: Number(x.material.qty) - x.needed } }));
    // Add finished units to product stock
    prodDispatch({ type: "UPDATE", id: batch.id, changes: { qty: Number(batch.qty) + count } });
    closeBatch();
  };

  // Match venue stock (Collective / events) back to a product by SKU, else name+size,
  // so distributed quantities can be folded into the on-hand view.
  const matchQty = (rows, p) => {
    const psku = String(p.sku || "").toUpperCase().trim();
    const pns = `${String(p.name || "").trim().toLowerCase()}|${String(p.size || "").trim().toLowerCase()}`;
    return rows.reduce((s, r) => {
      const rsku = String(r.sku || "").toUpperCase().trim();
      const rns = `${String(r.name || "").trim().toLowerCase()}|${String(r.size || "").trim().toLowerCase()}`;
      const match = (psku && rsku && psku === rsku) || rns === pns;
      return s + (match ? Number(r.qty || 0) : 0);
    }, 0);
  };
  // Decorate a product with its per-location quantities + the combined "shown" total
  // based on which source toggles are active. Keeps `qty` = on-hand for actions.
  const decorate = (p) => {
    const coll = matchQty(storeInv, p);
    const evt = matchQty(eventInv, p);
    const parts = [];
    let shown = 0;
    if (srcOnHand) { shown += Number(p.qty || 0); parts.push({ label: "here", qty: Number(p.qty || 0) }); }
    if (srcColl) { shown += coll; parts.push({ label: "collective", qty: coll }); }
    if (srcEvt) { shown += evt; parts.push({ label: "events", qty: evt }); }
    return { ...p, _shown: shown, _parts: parts };
  };
  const multiSource = [srcOnHand, srcColl, srcEvt].filter(Boolean).length > 1;
  const invHeader = (srcColl || srcEvt) ? "Total Stock" : "On Hand";
  // Source-aware totals for the stat cards (across all products, not just searched).
  const combinedUnits = products.reduce((s, p) => s + decorate(p)._shown, 0);
  const combinedValue = products.reduce((s, p) => s + decorate(p)._shown * Number(p.price || 0), 0);

  const currentPlan = batch && batchQty ? batchPlan(batch, Number(batchQty) || 0) : [];
  const anyShort = currentPlan.some(x => x.short);

  const q = search.trim().toLowerCase();
  const filteredRaw = q ? products.filter(p => [p.name, p.size, p.flavor, p.sku].filter(Boolean).some(v => String(v).toLowerCase().includes(q))) : products;
  const filtered = filteredRaw.map(decorate);
  const toggleName = (k) => setOpenNames(o => ({ ...o, [k]: !o[k] }));
  const invGroups = groupRowsBySection(filtered, sections, p => p.sectionId);
  const toggleGroup = (k) => setExpanded(e => ({ ...e, [k]: !e[k] }));
  const allExpanded = invGroups.length > 0 && invGroups.every(g => expanded[g.key]);
  const toggleAllGroups = () => setExpanded(allExpanded ? {} : Object.fromEntries(invGroups.map(g => [g.key, true])));
  const catValue = (rows) => rows.reduce((s, p) => s + Number(p._shown != null ? p._shown : p.qty || 0) * Number(p.price || 0), 0);
  const usingCategories = !(sections.length === 0 || invGroups.length === 0);
  const allMultiKeys = usingCategories ? invGroups.flatMap(g => multiNameKeys(g.rows, g.key)) : multiNameKeys(filtered, "all");
  const anySizesOpen = allMultiKeys.some(k => openNames[k]);
  const toggleAllSizes = () => setOpenNames(anySizesOpen ? {} : Object.fromEntries(allMultiKeys.map(k => [k, true])));

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16, flexWrap: "wrap", gap: 12 }}>
        <div style={{ display: "flex", gap: 12 }}>
          <div style={styles.statCard(C.goldLight)}><div style={{ ...styles.statNum, fontSize: 22 }}>{combinedUnits}</div><div style={styles.statLabel}>{multiSource ? "Units (shown)" : "Units on Hand"}</div></div>
          <div style={styles.statCard(C.sageLight)}><div style={{ ...styles.statNum, fontSize: 22, color: C.sageDark }}>${combinedValue.toFixed(0)}</div><div style={styles.statLabel}>{multiSource ? "Value (shown)" : "Inventory Value"}</div></div>
        </div>
        <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
          <span style={{ fontSize: 12, color: C.muted, fontWeight: 600 }}>Show:</span>
          <button style={styles.subNavBtn(srcOnHand)} onClick={() => setSrcOnHand(v => !v)}>On hand</button>
          <button style={styles.subNavBtn(srcColl)} onClick={() => setSrcColl(v => !v)}>+ Collective</button>
          <button style={styles.subNavBtn(srcEvt)} onClick={() => setSrcEvt(v => !v)}>+ Events</button>
        </div>
      </div>
      <div className="app-card" style={styles.card}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12, flexWrap: "wrap", gap: 8 }}>
          <div style={{ ...styles.sectionTitle, marginBottom: 0 }}>📋 Current Inventory</div>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
            <input style={{ ...styles.input, maxWidth: 240 }} placeholder="Search inventory…" value={search} onChange={e => setSearch(e.target.value)} />
            {allMultiKeys.length > 0 && <button style={styles.btn("ghost")} onClick={toggleAllSizes}>{anySizesOpen ? "Collapse sizes" : "Expand sizes"}</button>}
            {invGroups.length > 1 && <button style={styles.btn("ghost")} onClick={toggleAllGroups}>{allExpanded ? "Collapse all" : "Expand all"}</button>}
            {onExportCsv && products.length > 0 && <button style={styles.btn("sage")} onClick={onExportCsv}>⬇ Export for Collective</button>}
          </div>
        </div>
        {(() => {
          const invColumns = [
            { key: "name", header: "Product", primary: true },
            { key: "size", header: "Size" },
            { key: "flavor", header: "Flavor" },
            { key: "qty", header: invHeader, strong: true, render: p => (
              <span>{p._shown}{multiSource && p._parts.filter(x => x.qty > 0).length > 0 ? <span style={{ display: "block", fontSize: 11, color: C.textSoft, fontWeight: 400 }}>{p._parts.filter(x => x.qty > 0).map(x => `${x.qty} ${x.label}`).join(" · ")}</span> : null}</span>
            ) },
            { key: "status", header: "Status", render: p => <StockBadge qty={p.qty} low={p.lowAlert} /> },
          ];
          const invActions = p => (
            <>
              <button style={{ ...styles.btn("primary"), fontSize: 12, padding: "5px 12px" }} onClick={() => openBatch(p)}>+ Make Batch</button>
              <button style={{ ...styles.btn("sage"), fontSize: 12, padding: "5px 12px", marginLeft: 6, opacity: p.qty <= 0 ? 0.4 : 1, cursor: p.qty <= 0 ? "not-allowed" : "pointer" }} disabled={p.qty <= 0} onClick={() => openSale(p)}>Sell</button>
              <button style={{ ...styles.btn("ghost"), fontSize: 12, padding: "5px 12px", marginLeft: 6, opacity: p.qty <= 0 ? 0.4 : 1, cursor: p.qty <= 0 ? "not-allowed" : "pointer" }} disabled={p.qty <= 0} onClick={() => openPush(p)}>Send →</button>
            </>
          );
          const groups = invGroups;
          if (sections.length === 0 || groups.length === 0) {
            return <ResponsiveTable groups={nameVariantGroups(filtered, "all", openNames)} onToggleGroup={toggleName} emptyText={q ? "No products match your search." : "No products yet — add them in the Products tab, then Make Batch to create stock."} columns={invColumns} actions={invActions} />;
          }
          return groups.map((g, i) => {
            const isCollapsed = !expanded[g.key];
            return (
              <div key={g.key} style={{ marginTop: i === 0 ? 0 : 18 }}>
                <div onClick={() => toggleGroup(g.key)} style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8, cursor: "pointer", userSelect: "none" }}>
                  <span style={{ fontSize: 12, color: C.muted, width: 12, display: "inline-block" }}>{isCollapsed ? "▸" : "▾"}</span>
                  <span style={{ fontSize: 13, fontWeight: 800, color: C.goldDark, textTransform: "uppercase", letterSpacing: "0.5px" }}>📂 {g.name} <span style={{ color: C.textSoft, fontWeight: 600 }}>· {g.rows.length}</span></span>
                  <span style={{ marginLeft: "auto", fontSize: 14, fontWeight: 700, color: C.sageDark }}>${catValue(g.rows).toFixed(2)}</span>
                </div>
                {!isCollapsed && <ResponsiveTable groups={nameVariantGroups(g.rows, g.key, openNames)} onToggleGroup={toggleName} emptyText="—" columns={invColumns} actions={invActions} />}
              </div>
            );
          });
        })()}
      </div>

      {modal && (
        <Modal title={`Send to Venue — ${modal.name}`} onClose={close}>
          <p style={{ fontSize: 14, color: C.muted, marginBottom: 14 }}>
            {modal.qty} units on hand. This will be deducted from your main inventory and flagged as newly received (awaiting labels) at the chosen venue.
          </p>
          <Field label="Destination">
            <div style={{ display: "flex", gap: 8 }}>
              <button style={styles.subNavBtn(pushDest === "store")} onClick={() => setPushDest("store")}>🏪 Collective</button>
              <button style={styles.subNavBtn(pushDest === "event")} onClick={() => setPushDest("event")}>🎪 Event</button>
            </div>
          </Field>
          {pushDest === "event" && (
            <Field label="Select Event">
              {(!events || events.length === 0) ? (
                <div style={{ fontSize: 13, color: C.danger, padding: "8px 0" }}>No events yet. Create one in the Events tab first.</div>
              ) : (
                <select style={styles.input} value={pushEvent} onChange={e => setPushEvent(e.target.value)}>
                  {events.map(ev => <option key={ev.id} value={ev.id}>{ev.name}{ev.date ? ` · ${ev.date}` : ""}</option>)}
                </select>
              )}
            </Field>
          )}
          <Field label="Quantity to Send">
            <input style={styles.input} type="number" min="1" max={modal.qty} value={pushQty} onChange={e => setPushQty(e.target.value)} placeholder={`1–${modal.qty}`} autoFocus />
          </Field>
          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 8 }}>
            <button style={styles.btn("ghost")} onClick={close}>Cancel</button>
            <button style={{ ...styles.btn("primary"), opacity: (pushDest === "event" && (!events || events.length === 0)) ? 0.5 : 1, cursor: (pushDest === "event" && (!events || events.length === 0)) ? "not-allowed" : "pointer" }} disabled={pushDest === "event" && (!events || events.length === 0)} onClick={confirmPush}>{pushDest === "store" ? "Send to Collective" : "Send to Event"}</button>
          </div>
        </Modal>
      )}

      {sale && (
        <Modal title={`Single Sale — ${sale.name} ${sale.size}`} onClose={closeSale}>
          <p style={{ fontSize: 14, color: C.muted, marginBottom: 14 }}>
            {sale.qty} on hand, priced at ${Number(sale.price || 0).toFixed(2)} each. This sells directly from main inventory (for one-off sales outside the store or events).
          </p>
          <Field label="Quantity Sold">
            <input style={styles.input} type="number" min="1" max={sale.qty} value={saleQty} onChange={e => setSaleQty(e.target.value)} placeholder={`1–${sale.qty}`} autoFocus />
          </Field>
          {saleQty && Number(saleQty) > 0 && (
            <div style={{ padding: "10px 14px", background: C.sageLight, borderRadius: 8, fontSize: 14, color: C.sageDark, marginBottom: 14 }}>
              Sale total: <strong>${(Number(sale.price || 0) * Number(saleQty)).toFixed(2)}</strong>
            </div>
          )}
          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 8 }}>
            <button style={styles.btn("ghost")} onClick={closeSale}>Cancel</button>
            <button style={styles.btn("primary")} onClick={confirmSale}>Record Sale</button>
          </div>
        </Modal>
      )}

      {batch && (
        <Modal title={`Make Batch — ${batch.name}`} onClose={closeBatch}>
          {(!batch.recipe || batch.recipe.length === 0) ? (
            <div>
              <p style={{ fontSize: 14, color: C.muted, marginBottom: 14 }}>
                This product has no recipe set, so no materials will be deducted. You can still add finished units to stock, or set a recipe in the Products tab first.
              </p>
              <Field label="Units to Add">
                <input style={styles.input} type="number" min="1" value={batchQty} onChange={e => setBatchQty(e.target.value)} placeholder="e.g. 12" autoFocus />
              </Field>
            </div>
          ) : (
            <div>
              <Field label="How many units are you making?">
                <input style={styles.input} type="number" min="1" value={batchQty} onChange={e => setBatchQty(e.target.value)} placeholder="e.g. 12" autoFocus />
              </Field>
              {batchQty && Number(batchQty) > 0 && (
                <div style={{ marginTop: 4, marginBottom: 14, padding: 14, background: C.bg, borderRadius: 8, border: `1px solid ${C.border}` }}>
                  <div style={{ fontSize: 12, fontWeight: 600, color: C.muted, textTransform: "uppercase", letterSpacing: "0.3px", marginBottom: 10 }}>Materials this will use</div>
                  {currentPlan.map((x, i) => (
                    <div key={i} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "6px 0", borderBottom: i < currentPlan.length - 1 ? `1px solid ${C.border}` : "none" }}>
                      <span style={{ fontSize: 14 }}>{x.material.name}</span>
                      <span style={{ fontSize: 13, fontWeight: 600, color: x.short ? C.danger : C.text }}>
                        {x.needed} {x.material.unit} {x.short && <span style={{ color: C.danger }}>(only {x.have} on hand)</span>}
                      </span>
                    </div>
                  ))}
                </div>
              )}
              {anyShort && (
                <div style={{ padding: "10px 14px", background: C.dangerLight, border: `1px solid ${C.danger}`, borderRadius: 8, fontSize: 13, color: C.danger, marginBottom: 14 }}>
                  ⚠ Not enough of some materials. You can still proceed — those material counts will go negative so you know to restock.
                </div>
              )}
            </div>
          )}
          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 8 }}>
            <button style={styles.btn("ghost")} onClick={closeBatch}>Cancel</button>
            <button style={styles.btn("primary")} onClick={confirmBatch}>{anyShort ? "Make Batch Anyway" : "Make Batch"}</button>
          </div>
        </Modal>
      )}
    </div>
  );
}

// ── Single Sale (sells straight from main Inventory; no separate stock) ────
function SingleSaleView({ products, prodDispatch, sales, salesDispatch, onCaptureCustomer, sections = [], deals = [], taxRate = 0 }) {
  const [sellItem, setSellItem] = useState(null);
  const [sellQty, setSellQty] = useState("");
  const [multiSale, setMultiSale] = useState(false);

  const recordSale = (p, qty) => {
    const n = Math.min(Number(qty), Number(p.qty));
    if (!n || n <= 0) return;
    prodDispatch({ type: "UPDATE", id: p.id, changes: { qty: Number(p.qty) - n } });
    salesDispatch({ type: "ADD", item: {
      date: new Date().toISOString().slice(0, 10),
      customer: "Single sale",
      items: `${p.name} ${p.size} x${n}`,
      total: Number(p.price || 0) * n,
      status: "Fulfilled",
    } });
  };

  const openSell = (p) => { setSellQty(""); setSellItem(p); };
  const closeSell = () => setSellItem(null);
  const confirmSell = () => {
    const n = Number(sellQty);
    if (!n || n <= 0) return;
    recordSale(sellItem, n);
    closeSell();
  };

  // Multi-item sale: deduct each line from main inventory, record one combined sale
  const confirmMultiSale = (sale, receiptMode) => {
    sale.lineItems.forEach(li => {
      const p = products.find(pr => pr.id === li.sourceId);
      if (p) prodDispatch({ type: "UPDATE", id: p.id, changes: { qty: Number(p.qty) - li.qty } });
    });
    const itemsText = sale.lineItems.map(li => `${li.name} ${li.size} x${li.qty}`).join(", ");
    const taxNote = sale.tax > 0 ? `tax $${Number(sale.tax).toFixed(2)}` : "";
    const extras = [sale.payment, sale.discountLabel, taxNote].filter(Boolean).join(" · ");
    salesDispatch({ type: "ADD", item: {
      date: sale.date,
      customer: sale.customerName || "Single sale",
      items: extras ? `${itemsText} · ${extras}` : itemsText,
      subtotal: sale.netSubtotal,
      tax: sale.tax || 0,
      total: sale.total,
      status: "Fulfilled",
      payment: sale.payment || "",
      discount: sale.discountLabel || "",
      customerEmail: sale.customerEmail || "",
      customerPhone: sale.customerPhone || "",
    } });
    if (receiptMode === "print" || receiptMode === "email") openReceiptWithAuth({ businessName: "Nashville Bee Company", venueLabel: "Single", sale });
    if (onCaptureCustomer) onCaptureCustomer(sale);
    setMultiSale(false);
  };

  const revenue = sales.reduce((s, o) => s + Number(o.total), 0);
  const sectionNameById = Object.fromEntries(sections.map(s => [String(s.id), s.name]));
  const sectionOrder = sections.map(s => s.name);
  const saleSource = products.map(p => ({ ...p, section: sectionNameById[String(p.sectionId)] || "" }));

  return (
    <div>
      <div style={{ display: "flex", gap: 12, marginBottom: 16 }}>
        <div style={styles.statCard(C.goldLight)}><div style={{ ...styles.statNum, fontSize: 22 }}>{sales.length}</div><div style={styles.statLabel}>Single Sales</div></div>
        <div style={styles.statCard(C.sageLight)}><div style={{ ...styles.statNum, fontSize: 22, color: C.sageDark }}>${revenue.toFixed(0)}</div><div style={styles.statLabel}>Single Sale Revenue</div></div>
      </div>

      <div className="app-card" style={styles.card}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
          <div style={{ ...styles.sectionTitle, marginBottom: 0 }}>🧍 Sell from Main Inventory</div>
          {(() => { const hasStock = products.some(p => p.qty > 0); return <button style={{ ...styles.btn("primary"), opacity: hasStock ? 1 : 0.4, cursor: hasStock ? "pointer" : "not-allowed" }} disabled={!hasStock} onClick={() => setMultiSale(true)}>+ New Sale</button>; })()}
        </div>
        <div style={{ fontSize: 13, color: C.muted, marginBottom: 14 }}>For one-off sales outside the store or events. This sells directly from your main inventory stock. Use <strong>New Sale</strong> for a multi-item sale with a receipt.</div>
        <ResponsiveTable
          rows={products}
          emptyText="No products yet."
          columns={[
            { key: "name", header: "Product", primary: true },
            { key: "size", header: "Size" },
            { key: "flavor", header: "Flavor" },
            { key: "qty", header: "On Hand", strong: true },
            { key: "price", header: "Price", render: p => `$${Number(p.price || 0).toFixed(2)}` },
          ]}
          actions={p => (
            <>
              <button style={{ ...styles.btn("sage"), fontSize: 12, padding: "5px 12px", opacity: p.qty <= 0 ? 0.4 : 1, cursor: p.qty <= 0 ? "not-allowed" : "pointer" }} disabled={p.qty <= 0} onClick={() => recordSale(p, 1)}>Sell 1</button>
              <button style={{ ...styles.btn("primary"), fontSize: 12, padding: "5px 10px", marginLeft: 6, opacity: p.qty <= 0 ? 0.4 : 1, cursor: p.qty <= 0 ? "not-allowed" : "pointer" }} disabled={p.qty <= 0} onClick={() => openSell(p)}>Sell…</button>
            </>
          )}
        />
      </div>

      <OrderTable orders={sales} dispatch={salesDispatch} historyTitle="Single Sales History" onFulfill={() => {}} />

      {sellItem && (
        <Modal title={`Single Sale — ${sellItem.name} ${sellItem.size}`} onClose={closeSell}>
          <p style={{ fontSize: 14, color: C.muted, marginBottom: 14 }}>
            {sellItem.qty} on hand, priced at ${Number(sellItem.price || 0).toFixed(2)} each. How many sold?
          </p>
          <Field label="Quantity Sold">
            <input style={styles.input} type="number" min="1" max={sellItem.qty} value={sellQty} onChange={e => setSellQty(e.target.value)} placeholder={`1–${sellItem.qty}`} autoFocus />
          </Field>
          {sellQty && Number(sellQty) > 0 && (
            <div style={{ padding: "10px 14px", background: C.sageLight, borderRadius: 8, fontSize: 14, color: C.sageDark, marginBottom: 14 }}>
              Sale total: <strong>${(Number(sellItem.price || 0) * Number(sellQty)).toFixed(2)}</strong>
            </div>
          )}
          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 8 }}>
            <button style={styles.btn("ghost")} onClick={closeSell}>Cancel</button>
            <button style={styles.btn("primary")} onClick={confirmSell}>Record Sale</button>
          </div>
        </Modal>
      )}

      {multiSale && (
        <MultiSaleModal
          title="New Single Sale"
          source={saleSource}
          onClose={() => setMultiSale(false)}
          onConfirm={confirmMultiSale}
          sectionOrder={sectionOrder}
          deals={deals}
          taxRate={taxRate}
        />
      )}
    </div>
  );
}

// ── Deals + Tax management ─────────────────────────────────────────────────
function DealsManager({ deals, dispatch, products, sections, homeTaxRate, setHomeTaxRate }) {
  const [modal, setModal] = useState(null); // "add" | dealObject
  const [form, setForm] = useState(null);
  const [taxDraft, setTaxDraft] = useState(String(homeTaxRate || 0));

  const blankTier = (type) => type === "cart" ? { minSubtotal: "", rewardType: "percent", rewardValue: "" } : { minQty: "", rewardType: "percent", rewardValue: "" };
  const openAdd = () => { setForm({ name: "", type: "qty", scope: "all", productSku: "", sectionName: "", priority: 0, active: true, tiers: [blankTier("qty")], minQty: 2, bundlePrice: "", extraUnit: "" }); setModal("add"); };
  const openEdit = (d) => { setForm({ ...d, tiers: (d.tiers && d.tiers.length ? d.tiers : [blankTier(d.type)]) }); setModal(d); };
  const close = () => setModal(null);

  const setType = (type) => setForm(f => ({ ...f, type, scope: type === "cart" ? "all" : f.scope, tiers: (f.tiers || []).map(t => type === "cart" ? { minSubtotal: t.minSubtotal ?? t.minQty ?? "", rewardType: t.rewardType, rewardValue: t.rewardValue } : { minQty: t.minQty ?? t.minSubtotal ?? "", rewardType: t.rewardType, rewardValue: t.rewardValue }) }));
  const addTier = () => setForm(f => ({ ...f, tiers: [...(f.tiers || []), blankTier(f.type)] }));
  const setTier = (i, patch) => setForm(f => ({ ...f, tiers: f.tiers.map((t, idx) => idx === i ? { ...t, ...patch } : t) }));
  const removeTier = (i) => setForm(f => ({ ...f, tiers: f.tiers.filter((_, idx) => idx !== i) }));

  const save = () => {
    if (!form.name.trim()) return;
    if (form.type === "bundle") {
      const minQty = Math.max(1, Number(form.minQty) || 0);
      const bundlePrice = Number(form.bundlePrice) || 0;
      const extraUnit = Number(form.extraUnit) || 0;
      if (minQty < 1 || bundlePrice <= 0) return;
      const item = {
        name: form.name.trim(), type: "bundle", scope: form.scope,
        productSku: form.scope === "product" ? form.productSku : "",
        sectionName: form.scope === "section" ? form.sectionName : "",
        minQty, bundlePrice, extraUnit, tiers: [],
        priority: Number(form.priority) || 0, active: form.active !== false,
      };
      if (modal === "add") dispatch({ type: "ADD", item });
      else dispatch({ type: "UPDATE", id: modal.id, changes: item });
      close();
      return;
    }
    const tiers = (form.tiers || []).map(t => form.type === "cart"
      ? { minSubtotal: Number(t.minSubtotal) || 0, rewardType: t.rewardType, rewardValue: Number(t.rewardValue) || 0 }
      : { minQty: Number(t.minQty) || 0, rewardType: t.rewardType, rewardValue: Number(t.rewardValue) || 0 }
    ).filter(t => (form.type === "cart" ? t.minSubtotal > 0 : t.minQty > 0) && t.rewardValue > 0);
    if (tiers.length === 0) return;
    const item = {
      name: form.name.trim(), type: form.type,
      scope: form.type === "cart" ? "all" : form.scope,
      productSku: form.type !== "cart" && form.scope === "product" ? form.productSku : "",
      sectionName: form.type !== "cart" && form.scope === "section" ? form.sectionName : "",
      tiers, priority: Number(form.priority) || 0, active: form.active !== false,
      minQty: 0, bundlePrice: 0, extraUnit: 0,
    };
    if (modal === "add") dispatch({ type: "ADD", item });
    else dispatch({ type: "UPDATE", id: modal.id, changes: item });
    close();
  };

  const describe = (d) => {
    const scope = d.type === "cart" ? "Whole cart" : d.scope === "product" ? `SKU ${d.productSku}` : d.scope === "section" ? `${d.sectionName} category` : "All items";
    if (d.type === "bundle") {
      return { scope, tiers: `${d.minQty} for $${Number(d.bundlePrice).toFixed(2)}${Number(d.extraUnit) > 0 ? `, then $${Number(d.extraUnit).toFixed(2)}/ea` : ""}` };
    }
    const tiers = (d.tiers || []).map(t => d.type === "cart"
      ? `$${Number(t.minSubtotal).toFixed(0)}+ → ${t.rewardType === "percent" ? `${t.rewardValue}% off` : `$${Number(t.rewardValue).toFixed(2)} off`}`
      : `${t.minQty}+ → ${t.rewardType === "percent" ? `${t.rewardValue}% off` : `$${Number(t.rewardValue).toFixed(2)}/ea`}`
    ).join(", ");
    return { scope, tiers };
  };

  return (
    <div>
      <div className="app-card" style={{ ...styles.card, marginBottom: 16 }}>
        <div style={styles.sectionTitle}>🧾 Tax</div>
        <div style={{ fontSize: 13, color: C.muted, marginBottom: 10 }}>Your home sales-tax rate — used at events (unless an event sets its own) and at single sales. The Collective is never taxed, and each product carries its own taxable on/off flag.</div>
        <div style={{ display: "flex", gap: 8, alignItems: "center", maxWidth: 260 }}>
          <input style={styles.input} type="number" step="any" value={taxDraft} onChange={e => setTaxDraft(e.target.value)} onBlur={() => setHomeTaxRate(Number(taxDraft) || 0)} placeholder="e.g. 9.25" />
          <span style={{ fontWeight: 700, color: C.muted }}>%</span>
        </div>
      </div>

      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
        <div style={styles.sectionTitle}>🎁 Deals</div>
        <button style={styles.btn("primary")} onClick={openAdd}>+ Add Deal</button>
      </div>

      <div className="app-card" style={styles.card}>
        <ResponsiveTable
          rows={deals}
          emptyText="No deals yet. Add quantity breaks or cart-threshold deals — they'll be auto-detected at checkout."
          columns={[
            { key: "name", header: "Deal", primary: true },
            { key: "type", header: "Type", render: d => <span style={styles.badge("ok")}>{d.type === "cart" ? "Cart threshold" : d.type === "bundle" ? "Bundle price" : "Quantity break"}</span> },
            { key: "scope", header: "Applies to", render: d => describe(d).scope },
            { key: "tiers", header: "Tiers", render: d => <span style={{ fontSize: 12 }}>{describe(d).tiers}</span> },
            { key: "active", header: "Status", render: d => d.active ? <span style={styles.badge("ok")}>Active</span> : <span style={{ fontSize: 12, color: C.textSoft }}>Off</span> },
          ]}
          actions={d => (
            <>
              <button style={{ ...styles.btn("ghost"), fontSize: 12, padding: "5px 10px" }} onClick={() => dispatch({ type: "UPDATE", id: d.id, changes: { active: !d.active } })}>{d.active ? "Disable" : "Enable"}</button>
              <button style={{ ...styles.btn("ghost"), fontSize: 12, padding: "5px 10px", marginLeft: 6 }} onClick={() => openEdit(d)}>Edit</button>
              <button style={{ ...styles.btn("danger"), fontSize: 12, padding: "5px 10px", marginLeft: 6 }} onClick={() => dispatch({ type: "DELETE", id: d.id })}>Remove</button>
            </>
          )}
        />
      </div>

      {modal && form && (
        <Modal title={modal === "add" ? "New Deal" : "Edit Deal"} onClose={close}>
          <Field label="Deal name"><input style={styles.input} value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="e.g. Buy 3+ Save 10%" autoFocus /></Field>
          <Field label="Type">
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
              <button style={styles.subNavBtn(form.type === "qty")} onClick={() => setType("qty")}>Quantity break</button>
              <button style={styles.subNavBtn(form.type === "bundle")} onClick={() => setType("bundle")}>Bundle price</button>
              <button style={styles.subNavBtn(form.type === "cart")} onClick={() => setType("cart")}>Cart threshold</button>
            </div>
          </Field>
          {form.type !== "cart" && (
            <Field label="Applies to">
              <select style={styles.input} value={form.scope} onChange={e => setForm({ ...form, scope: e.target.value })}>
                <option value="all">All items</option>
                <option value="product">A specific product</option>
                <option value="section">A category</option>
              </select>
            </Field>
          )}
          {form.type !== "cart" && form.scope === "product" && (
            <Field label="Product">
              <select style={styles.input} value={form.productSku} onChange={e => setForm({ ...form, productSku: e.target.value })}>
                <option value="">— pick a product —</option>
                {products.filter(p => p.sku).map(p => <option key={p.id} value={p.sku}>{p.name} {p.size} ({p.sku})</option>)}
              </select>
            </Field>
          )}
          {form.type !== "cart" && form.scope === "section" && (
            <Field label="Category">
              <select style={styles.input} value={form.sectionName} onChange={e => setForm({ ...form, sectionName: e.target.value })}>
                <option value="">— pick a category —</option>
                {sections.map(s => <option key={s.id} value={s.name}>{s.name}</option>)}
              </select>
            </Field>
          )}

          {form.type === "bundle" && (
            <>
              <label style={styles.label}>Bundle pricing</label>
              <div style={{ fontSize: 12, color: C.textSoft, marginBottom: 10 }}>The first <strong>{Number(form.minQty) || 0}</strong> units cost the flat bundle price; each unit after that uses the per-extra price. Below the bundle quantity, the regular price applies.</div>
              <div className="grid-2" style={styles.grid2}>
                <Field label="Bundle quantity"><input style={styles.input} type="number" min="1" value={form.minQty ?? ""} onChange={e => setForm({ ...form, minQty: e.target.value })} placeholder="e.g. 2" /></Field>
                <Field label="Flat price for that bundle ($)"><input style={styles.input} type="number" step="any" value={form.bundlePrice ?? ""} onChange={e => setForm({ ...form, bundlePrice: e.target.value })} placeholder="e.g. 20" /></Field>
              </div>
              <Field label="Each additional unit ($)"><input style={styles.input} type="number" step="any" value={form.extraUnit ?? ""} onChange={e => setForm({ ...form, extraUnit: e.target.value })} placeholder="e.g. 10" /></Field>
              <div style={{ padding: "10px 14px", background: C.sageLight, borderRadius: 8, marginBottom: 14, fontSize: 13, color: C.sageDark }}>
                Example: {Number(form.minQty) || 0} for <strong>${(Number(form.bundlePrice) || 0).toFixed(2)}</strong>, {(Number(form.minQty) || 0) + 1} for <strong>${((Number(form.bundlePrice) || 0) + (Number(form.extraUnit) || 0)).toFixed(2)}</strong>, {(Number(form.minQty) || 0) + 2} for <strong>${((Number(form.bundlePrice) || 0) + 2 * (Number(form.extraUnit) || 0)).toFixed(2)}</strong>.
              </div>
            </>
          )}

          {form.type !== "bundle" && (<>
          <label style={styles.label}>Tiers</label>
          <div style={{ fontSize: 12, color: C.textSoft, marginBottom: 8 }}>{form.type === "cart" ? "When the cart subtotal reaches the amount, apply the reward. Highest qualifying tier wins." : "When item quantity reaches the count, apply the reward. Highest qualifying tier wins."}</div>
          {form.tiers.map((t, i) => (
            <div key={i} style={{ display: "flex", gap: 6, alignItems: "center", marginBottom: 8 }}>
              <span style={{ fontSize: 12, color: C.muted, width: 38 }}>{form.type === "cart" ? "$ ≥" : "qty ≥"}</span>
              <input style={{ ...styles.input, width: 72 }} type="number" min="0" value={form.type === "cart" ? (t.minSubtotal ?? "") : (t.minQty ?? "")} onChange={e => setTier(i, form.type === "cart" ? { minSubtotal: e.target.value } : { minQty: e.target.value })} />
              <select style={{ ...styles.input, flex: 1 }} value={t.rewardType} onChange={e => setTier(i, { rewardType: e.target.value })}>
                <option value="percent">% off</option>
                <option value="amount">{form.type === "cart" ? "$ off cart" : "$ off each"}</option>
              </select>
              <input style={{ ...styles.input, width: 80 }} type="number" min="0" value={t.rewardValue ?? ""} onChange={e => setTier(i, { rewardValue: e.target.value })} placeholder={t.rewardType === "percent" ? "%" : "$"} />
              {form.tiers.length > 1 && <button style={{ ...styles.btn("ghost"), padding: "6px 9px" }} onClick={() => removeTier(i)}>✕</button>}
            </div>
          ))}
          <button style={{ ...styles.btn("ghost"), fontSize: 13, marginBottom: 14 }} onClick={addTier}>+ Add tier</button>
          </>)}

          <div className="grid-2" style={styles.grid2}>
            <Field label="Priority (higher wins ties)"><input style={styles.input} type="number" value={form.priority ?? 0} onChange={e => setForm({ ...form, priority: e.target.value })} /></Field>
            <Field label="Status">
              <label style={{ display: "flex", alignItems: "center", gap: 8, paddingTop: 8, cursor: "pointer" }}>
                <input type="checkbox" checked={form.active !== false} onChange={e => setForm({ ...form, active: e.target.checked })} style={{ width: 18, height: 18 }} /> Active
              </label>
            </Field>
          </div>

          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 8 }}>
            <button style={styles.btn("ghost")} onClick={close}>Cancel</button>
            <button style={styles.btn("primary")} onClick={save}>Save Deal</button>
          </div>
        </Modal>
      )}
    </div>
  );
}

// ── App Shell ──────────────────────────────────────────────────────────────
const TABS = [
  { id: "dashboard", label: "🏠 Dashboard" },
  { id: "products", label: "🍯 Products" },
  { id: "inventory", label: "📋 Inventory" },
  { id: "materials", label: "📦 Materials" },
  { id: "orders", label: "🧾 Orders" },
  { id: "deals", label: "🎁 Deals" },
  { id: "customers", label: "👥 Customers" },
  { id: "team", label: "🧑‍🤝‍🧑 Team" },
  { id: "financials", label: "📊 Financials" },
  { id: "expenses", label: "💸 Expenses" },
];

// ── Real login (Supabase email + password) ─────────────────────────────────
function LoginGate() {
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submitLogin = async () => {
    setError(""); setBusy(true);
    const { error } = await supabase.auth.signInWithPassword({ email: email.trim(), password: pw });
    setBusy(false);
    if (error) { setError(error.message || "Sign in failed."); setPw(""); }
    // On success, the auth listener in App flips the view automatically.
  };

  const onKey = (e) => { if (e.key === "Enter") submitLogin(); };

  return (
    <div style={{ ...styles.app, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
      <div style={{ background: C.surface, border: `1px solid ${C.border}`, borderRadius: 16, padding: 36, maxWidth: 400, width: "100%", boxShadow: "0 20px 60px rgba(45,27,0,0.15)" }}>
        <div style={{ textAlign: "center", marginBottom: 24 }}>
          <img src={LOGO_SRC} alt="Nashville Bee Company" style={{ width: 96, height: 96, marginBottom: 12 }} />
          <div style={{ fontSize: 22, fontWeight: 800, color: C.amber }}>Nashville Bee Company</div>
          <div style={{ fontSize: 13, color: C.muted, marginTop: 6 }}>Sign in to continue</div>
        </div>

        <Field label="Email">
          <input style={styles.input} type="email" value={email} onChange={e => { setEmail(e.target.value); setError(""); }} onKeyDown={onKey} placeholder="you@example.com" autoFocus />
        </Field>
        <Field label="Password">
          <input style={styles.input} type="password" value={pw} onChange={e => { setPw(e.target.value); setError(""); }} onKeyDown={onKey} placeholder="Your password" />
        </Field>

        {error && <div style={{ fontSize: 13, color: C.danger, marginBottom: 12 }}>{error}</div>}

        <button style={{ ...styles.btn("primary"), width: "100%", padding: "12px", fontSize: 15, marginTop: 4, opacity: busy ? 0.6 : 1 }} disabled={busy} onClick={submitLogin}>
          {busy ? "Signing in…" : "Sign In"}
        </button>

        <div style={{ fontSize: 11, color: C.textSoft, textAlign: "center", marginTop: 16, lineHeight: 1.5 }}>
          Your data is securely stored in the cloud and synced across devices.
        </div>
      </div>
    </div>
  );
}

export default function App() {
  const [session, setSession] = useState(null);
  const [authChecked, setAuthChecked] = useState(false);
  const [guestError, setGuestError] = useState(false);
  const [tab, setTab] = useState("dashboard");
  const [orderTab, setOrderTab] = useState("general");

  // Each demo visitor gets their OWN anonymous session, so there's no shared
  // login token for anyone to revoke — guests can never knock each other off.
  const ensureGuestSession = async () => {
    try {
      const { data: { session: s } } = await supabase.auth.getSession();
      if (s) return s;
      const { data, error } = await supabase.auth.signInAnonymously();
      if (error) { setGuestError(true); return null; }
      return data?.session || null;
    } catch (_) { setGuestError(true); return null; }
  };

  // Auth: track the logged-in session (demo = auto guest, real app = login screen)
  useEffect(() => {
    let active = true;
    (async () => {
      const { data } = await supabase.auth.getSession();
      let s = data.session;
      if (!s && DEMO_MODE) s = await ensureGuestSession();
      if (active) { setSession(s || null); setAuthChecked(true); }
    })();
    const { data: sub } = supabase.auth.onAuthStateChange((_e, s) => setSession(s));
    return () => { active = false; sub.subscription.unsubscribe(); };
  }, []);

  const ready = !!session;

  // Fetch the signed-in user's role (owner vs staff). Defaults to owner if no
  // role row exists yet (keeps existing solo use working before staff are added).
  const [role, setRole] = useState(null);
  useEffect(() => {
    if (!session) { setRole(null); return; }
    let active = true;
    supabase.from((TABLE_PREFIX || "") + "user_roles").select("role").eq("user_id", session.user.id).maybeSingle()
      .then(({ data }) => { if (active) setRole(data?.role || "owner"); })
      .catch(() => { if (active) setRole("owner"); });
    return () => { active = false; };
  }, [session]);

  const isStaff = role === "staff";
  useEffect(() => { if (isStaff) { setTab("orders"); setOrderTab("event"); } }, [isStaff]);

  // Data, all backed by Supabase (only loads once logged in)
  const [products, prodDispatch] = useTable("products", {}, ready);
  const [materials, matDispatch] = useTable("materials", {}, ready);
  const [orders, ordDispatch] = useTable("orders", { channel: "general" }, ready);
  const [storeOrders, storeDispatch] = useTable("orders", { channel: "store" }, ready);
  const [eventOrders, eventDispatch] = useTable("orders", { channel: "event" }, ready);
  const [singleSales, singleSalesDispatch] = useTable("orders", { channel: "single" }, ready);
  const [expenses, expDispatch] = useTable("expenses", {}, ready);
  const [storeInv, storeInvDispatch] = useVenueInventory("store", ready);
  const [eventInv, eventInvDispatch] = useVenueInventory("event", ready);
  const [received, receivedDispatch] = useReceived("store", ready);
  const [eventReceived, eventReceivedDispatch] = useReceived("event", ready);
  const [events, eventsDispatch] = useTable("events", {}, ready);
  const [customers, customersDispatch] = useTable("customers", {}, ready);
  const [sections, sectionsDispatch] = useTable("sections", {}, ready);
  const sortedSections = [...sections].sort((a, b) => (Number(a.position) || 0) - (Number(b.position) || 0) || String(a.name).localeCompare(String(b.name)));
  const [matCategories, matCategoriesDispatch] = useTable("mat_categories", {}, ready);
  const sortedMatCategories = [...matCategories].sort((a, b) => (Number(a.position) || 0) - (Number(b.position) || 0) || String(a.name).localeCompare(String(b.name)));
  const sectionName = (id) => sections.find(s => String(s.id) === String(id))?.name || "";
  const sectionCode = (id) => sections.find(s => String(s.id) === String(id))?.code || "";
  const sectionOrder = sortedSections.map(s => s.name);
  const [settingsRows, settingsDispatch] = useTable("settings", {}, ready);
  const settingsRow = settingsRows[0] || null;
  const vendorPrefix = (settingsRow?.vendorPrefix || "NBC");
  const setVendorPrefix = (val) => {
    if (settingsRow) settingsDispatch({ type: "UPDATE", id: settingsRow.id, changes: { vendorPrefix: val } });
    else settingsDispatch({ type: "ADD", item: { vendorPrefix: val } });
  };
  const homeTaxRate = Number(settingsRow?.taxRate || 0);
  const setHomeTaxRate = (val) => {
    const r = Number(val) || 0;
    if (settingsRow) settingsDispatch({ type: "UPDATE", id: settingsRow.id, changes: { taxRate: r } });
    else settingsDispatch({ type: "ADD", item: { vendorPrefix, taxRate: r } });
  };
  const skuNameLen = Math.max(2, Math.min(8, Number(settingsRow?.skuNameLen) || 4));
  const setSkuNameLen = (val) => {
    const n = Math.max(2, Math.min(8, Number(val) || 4));
    if (settingsRow) settingsDispatch({ type: "UPDATE", id: settingsRow.id, changes: { skuNameLen: n } });
    else settingsDispatch({ type: "ADD", item: { vendorPrefix, skuNameLen: n } });
  };
  const skuMaxLen = Math.max(0, Number(settingsRow?.skuMaxLen) || 0); // 0 = no limit
  const setSkuMaxLen = (val) => {
    const raw = String(val).trim();
    const n = raw === "" ? 0 : Math.max(4, Number(val) || 0);
    if (settingsRow) settingsDispatch({ type: "UPDATE", id: settingsRow.id, changes: { skuMaxLen: n } });
    else settingsDispatch({ type: "ADD", item: { vendorPrefix, skuMaxLen: n } });
  };
  const skuNoDashes = !!settingsRow?.skuNoDashes;
  const setSkuNoDashes = (val) => {
    const b = !!val;
    if (settingsRow) settingsDispatch({ type: "UPDATE", id: settingsRow.id, changes: { skuNoDashes: b } });
    else settingsDispatch({ type: "ADD", item: { vendorPrefix, skuNoDashes: b } });
  };
  const matTaxOn = !!settingsRow?.matTaxOn; // global default: are new materials taxable?
  const setMatTaxOn = (val) => {
    const b = !!val;
    if (settingsRow) settingsDispatch({ type: "UPDATE", id: settingsRow.id, changes: { matTaxOn: b } });
    else settingsDispatch({ type: "ADD", item: { vendorPrefix, matTaxOn: b } });
  };
  const matTaxRate = Number(settingsRow?.matTaxRate || 0); // global default material tax rate
  const setMatTaxRate = (val) => {
    const r = Number(val) || 0;
    if (settingsRow) settingsDispatch({ type: "UPDATE", id: settingsRow.id, changes: { matTaxRate: r } });
    else settingsDispatch({ type: "ADD", item: { vendorPrefix, matTaxRate: r } });
  };
  // Log a material purchase as an expense (owner-confirmed; materials may be donated).
  const logMaterialPurchase = ({ name, amount }) => {
    expDispatch({ type: "ADD", item: {
      date: new Date().toISOString().slice(0, 10),
      category: "Materials",
      description: `Purchased: ${name}`,
      amount: Number(amount) || 0,
    } });
  };
  const collectiveCut = Number(settingsRow?.collectiveCut || 0); // % the Collective keeps of each sale
  const setCollectiveCut = (val) => {
    const r = Math.max(0, Math.min(100, Number(val) || 0));
    if (settingsRow) settingsDispatch({ type: "UPDATE", id: settingsRow.id, changes: { collectiveCut: r } });
    else settingsDispatch({ type: "ADD", item: { vendorPrefix, collectiveCut: r } });
  };
  const dashboardLayout = Array.isArray(settingsRow?.dashboardLayout) ? settingsRow.dashboardLayout : null;
  const setDashboardLayout = (lay) => {
    if (settingsRow) settingsDispatch({ type: "UPDATE", id: settingsRow.id, changes: { dashboardLayout: lay } });
    else settingsDispatch({ type: "ADD", item: { vendorPrefix, dashboardLayout: lay } });
  };
  // Record the Collective's commission on an imported sales batch as an expense, so the
  // gross sale stays on the books and the channel cost is visible in Financials.
  const logCollectiveFee = ({ amount, salesTotal }) => {
    expDispatch({ type: "ADD", item: {
      date: new Date().toISOString().slice(0, 10),
      category: "Collective Fee",
      description: `Collective commission on $${Number(salesTotal || 0).toFixed(2)} of sales`,
      amount: Number(amount) || 0,
    } });
  };
  const [deals, dealsDispatch] = useTable("deals", {}, ready);

  // Save a customer from a sale if info was provided and not opted out.
  // De-dupes by email (or name when no email) so repeat customers aren't duplicated.
  const captureCustomer = (sale) => {
    if (!sale || sale.addToList === false) return;
    const name = (sale.customerName || "").trim();
    const email = (sale.customerEmail || "").trim();
    const phone = (sale.customerPhone || "").trim();
    if (!name && !email && !phone) return; // nothing to save
    const existing = customers.find(c =>
      (email && c.email && c.email.toLowerCase() === email.toLowerCase()) ||
      (!email && name && c.name && c.name.toLowerCase() === name.toLowerCase())
    );
    if (existing) {
      // Fill in any missing contact details on the existing record
      const changes = {};
      if (email && !existing.email) changes.email = email;
      if (phone && !existing.phone) changes.phone = phone;
      if (name && !existing.name) changes.name = name;
      if (Object.keys(changes).length) customersDispatch({ type: "UPDATE", id: existing.id, changes });
    } else {
      customersDispatch({ type: "ADD", item: { name, email, phone, notes: "" } });
    }
  };

  // Push products from main inventory → a venue. Items land in that venue's
  // "Newly Received" list only; they count as inventory after "Mark Labeled".
  const pushToStore = (items) => {
    const today = new Date().toISOString().slice(0, 10);
    items.forEach(({ product, qty }) => {
      // Use the product's store price if set, otherwise fall back to its regular price
      const effPrice = Number(product.storePrice) > 0 ? Number(product.storePrice) : (Number(product.price) || 0);
      receivedDispatch({ type: "ADD", item: { date: today, name: product.name, size: product.size, flavor: product.flavor, price: effPrice, qty: Number(qty), section: sectionName(product.sectionId) || "", sku: product.sku || "", taxable: product.taxable !== false } });
    });
  };
  const pushToEvent = (items, eventId) => {
    const today = new Date().toISOString().slice(0, 10);
    items.forEach(({ product, qty }) => {
      eventReceivedDispatch({ type: "ADD", item: { date: today, eventId, name: product.name, size: product.size, flavor: product.flavor, price: Number(product.price) || 0, qty: Number(qty), section: sectionName(product.sectionId) || "", sku: product.sku || "", taxable: product.taxable !== false } });
    });
  };
  // Return event stock back into main inventory (per item or full close)
  // Add a quantity of a product back into main inventory.
  // Matches the returning stock to a live product by SKU first (most stable across
  // renames), then by name+size. If NOTHING matches — e.g. the product was renamed,
  // re-SKU'd, or deleted after it was sent out — the stock is re-created as a product
  // rather than silently dropped. Previously a no-match here added nothing back while
  // the venue row was still decremented, so returned units vanished.
  const addBackToInventory = (item, n) => {
    if (!n || n <= 0) return;
    const skuKey = String(item.sku || "").toUpperCase();
    let prod = skuKey ? products.find(p => String(p.sku || "").toUpperCase() === skuKey) : null;
    if (!prod) prod = products.find(p => p.name === item.name && String(p.size || "") === String(item.size || ""));
    if (prod) {
      prodDispatch({ type: "UPDATE", id: prod.id, changes: { qty: Number(prod.qty) + n } });
    } else {
      prodDispatch({ type: "ADD", item: {
        name: item.name, size: item.size || "", flavor: item.flavor || "",
        qty: n, price: Number(item.price) || 0, storePrice: 0, lowAlert: 5,
        sectionId: null, sku: item.sku || "", taxable: item.taxable !== false, recipe: [],
      } });
    }
  };
  // Return labeled stock from a venue's current inventory back to main inventory
  const makeReturnHandler = (invDispatch) => (item, qty) => {
    const n = Math.min(Number(qty), Number(item.qty));
    if (!n || n <= 0) return;
    addBackToInventory(item, n);
    invDispatch({ type: "RETURN", id: item.id, qty: n });
  };
  const returnToInventory = makeReturnHandler(eventInvDispatch);
  const returnStoreToInventory = makeReturnHandler(storeInvDispatch);
  // Undo a "newly received" batch (before labeling): return its stock and remove the line
  const makeUndoReceived = (receivedDispatch) => (r) => {
    addBackToInventory(r, Number(r.qty));
    receivedDispatch({ type: "DELETE", id: r.id });
  };
  const undoStoreReceived = makeUndoReceived(receivedDispatch);
  const undoEventReceived = makeUndoReceived(eventReceivedDispatch);

  // Log a lost/broken/spoiled inventory removal as an expense (retail value) so it
  // shows up in Financials. Category "Inventory Loss" keeps it grouped.
  const logLoss = ({ item, qty, reason, venueLabel }) => {
    const value = Number(item.price || 0) * Number(qty);
    expDispatch({ type: "ADD", item: {
      date: new Date().toISOString().slice(0, 10),
      category: "Inventory Loss",
      description: `${reason}: ${item.name} ${item.size} x${qty} (${venueLabel})`,
      amount: value,
    } });
  };

  // Log an event participation fee (booth/table) as an expense.
  const logEventCost = ({ eventName, date, amount }) => {
    expDispatch({ type: "ADD", item: {
      date: date || new Date().toISOString().slice(0, 10),
      category: "Event Cost",
      description: `Participation fee: ${eventName}`,
      amount: Number(amount) || 0,
    } });
  };

  // Export the Collective's current inventory as a Syncrostore-format CSV.
  const exportCollectiveCsv = (rows) => {
    const enriched = rows.map(r => ({ ...r, category: r.category || r.section || "" }));
    const csv = buildSyncrostoreCsv(enriched); // rows already carry the Collective price + denormalized sku
    downloadCsv(`collective-inventory-${new Date().toISOString().slice(0,10)}.csv`, csv);
  };
  // Export all main inventory using each product's Collective price.
  const exportMainCsv = () => {
    const matCost = (id) => matEffectiveCost(materials.find(m => String(m.id) === String(id)));
    const rows = products.map(p => ({
      name: p.name, size: p.size, flavor: p.flavor, qty: p.qty,
      price: Number(p.storePrice) > 0 ? Number(p.storePrice) : Number(p.price || 0),
      sku: p.sku || "", category: sectionName(p.sectionId),
      _recipe: p.recipe,
    }));
    const costOf = (r) => (r._recipe || []).reduce((s, line) => s + matCost(line.materialId) * Number(line.qtyPer || 0), 0);
    downloadCsv(`main-inventory-${new Date().toISOString().slice(0,10)}.csv`, buildSyncrostoreCsv(rows, costOf));
  };
  // Single sale: record a fulfilled single-sale entry (stock deducted in Inventory)
  const singleSale = (product, qty) => {
    singleSalesDispatch({ type: "ADD", item: {
      date: new Date().toISOString().slice(0, 10),
      customer: "Single sale",
      items: `${product.name} ${product.size} x${qty}`,
      total: Number(product.price || 0) * Number(qty),
      status: "Fulfilled",
    } });
  };

  const lock = async () => {
    if (DEMO_MODE) {
      // Reset to a fresh guest session — local scope only, never global.
      await supabase.auth.signOut({ scope: "local" });
      const s = await ensureGuestSession();
      setSession(s || null);
    } else {
      await supabase.auth.signOut({ scope: "local" });
    }
  };

  if (!authChecked) return <div style={{ ...styles.app, display: "flex", alignItems: "center", justifyContent: "center" }}><div style={{ color: C.muted, fontSize: 14 }}>Loading…</div></div>;
  if (!session) {
    if (DEMO_MODE) return (
      <div style={{ ...styles.app, display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 12, textAlign: "center", padding: 24 }}>
        <img src={LOGO_SRC} alt="Nashville Bee Company" style={{ width: 80, height: 80 }} />
        {guestError
          ? <div style={{ color: C.muted, fontSize: 14, maxWidth: 360 }}>Couldn't start the demo session. If you're the owner: enable <strong>Anonymous sign-ins</strong> in Supabase → Authentication → Providers, then reload.</div>
          : <div style={{ color: C.muted, fontSize: 14 }}>Starting demo…</div>}
      </div>
    );
    return <LoginGate />;
  }
  if (role === null) return <div style={{ ...styles.app, display: "flex", alignItems: "center", justifyContent: "center" }}><div style={{ color: C.muted, fontSize: 14 }}>Loading…</div></div>;

  return (
    <div style={styles.app}>
      <header className="app-header" style={styles.header}>
        <div style={styles.headerTitle}><img src={LOGO_SRC} alt="Nashville Bee Company" style={{ height: 46, width: 46, marginRight: 6, display: "block" }} /><span>Nashville Bee Company</span></div>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <span className="hide-mobile" style={{ fontSize: 12, opacity: 0.6 }}>Synced to cloud</span>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span className="hide-mobile" style={{ fontSize: 12, opacity: 0.9, maxWidth: 190, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{session?.user?.email}</span>
            <span style={{ fontSize: 11, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.5px", padding: "3px 10px", borderRadius: 20, background: isStaff ? "rgba(255,255,255,0.2)" : "#FFFFFF", color: isStaff ? "#FFFFFF" : C.amber }}>{isStaff ? "Staff" : "Owner"}</span>
          </div>
          <button style={{ background: "rgba(255,255,255,0.15)", color: "#FFF", border: "none", borderRadius: 8, padding: "7px 14px", fontWeight: 600, fontSize: 13, cursor: "pointer" }} onClick={lock}>{DEMO_MODE ? "Reset Demo" : "Sign Out"}</button>
        </div>
      </header>
      <nav className="app-nav" style={styles.nav}>
        {TABS.filter(t => !isStaff || t.id === "orders").map(t => <button key={t.id} style={styles.navBtn(tab === t.id)} onClick={() => setTab(t.id)}>{t.label}</button>)}
      </nav>
      <main className="page-main" style={styles.page}>
        {!isStaff && tab === "dashboard" && <Dashboard products={products} materials={materials} orders={orders} storeOrders={storeOrders} eventOrders={eventOrders} singleSales={singleSales} expenses={expenses} events={events} storeInv={storeInv} layout={dashboardLayout} onSaveLayout={setDashboardLayout} />}
        {!isStaff && tab === "products" && <Products products={products} dispatch={prodDispatch} materials={materials} sections={sortedSections} sectionsDispatch={sectionsDispatch} vendorPrefix={vendorPrefix} setVendorPrefix={setVendorPrefix} skuNameLen={skuNameLen} setSkuNameLen={setSkuNameLen} skuMaxLen={skuMaxLen} setSkuMaxLen={setSkuMaxLen} skuNoDashes={skuNoDashes} setSkuNoDashes={setSkuNoDashes} />}
        {!isStaff && tab === "inventory" && <Inventory products={products} prodDispatch={prodDispatch} materials={materials} matDispatch={matDispatch} events={events} onPushToStore={pushToStore} onPushToEvent={pushToEvent} onSingleSale={singleSale} onExportCsv={exportMainCsv} sections={sortedSections} storeInv={storeInv} eventInv={eventInv} />}
        {!isStaff && tab === "materials" && <Materials materials={materials} dispatch={matDispatch} categories={sortedMatCategories} categoriesDispatch={matCategoriesDispatch} globalTaxOn={matTaxOn} setGlobalTaxOn={setMatTaxOn} globalTaxRate={matTaxRate} setGlobalTaxRate={setMatTaxRate} onLogPurchase={logMaterialPurchase} />}
        {(tab === "orders" || isStaff) && (
          <div>
            <div className="app-subnav" style={styles.subNav}>
              {!isStaff && <button style={styles.subNavBtn(orderTab === "general")} onClick={() => setOrderTab("general")}>🧾 General</button>}
              {!isStaff && <button style={styles.subNavBtn(orderTab === "store")} onClick={() => setOrderTab("store")}>🏪 Collective</button>}
              <button style={styles.subNavBtn(isStaff ? true : orderTab === "event")} onClick={() => setOrderTab("event")}>🎪 Events</button>
              {!isStaff && <button style={styles.subNavBtn(orderTab === "single")} onClick={() => setOrderTab("single")}>🧍 Single Sale</button>}
            </div>
            {!isStaff && orderTab === "general" && <Orders orders={orders} dispatch={ordDispatch} />}
            {!isStaff && orderTab === "store" && <StoreView storeInv={storeInv} storeInvDispatch={storeInvDispatch} received={received} receivedDispatch={receivedDispatch} orders={storeOrders} ordersDispatch={storeDispatch} onReturn={returnStoreToInventory} onUndoReceived={undoStoreReceived} onLogLoss={logLoss} onExportCsv={exportCollectiveCsv} sectionOrder={sectionOrder} deals={deals} taxRate={0} collectiveCut={collectiveCut} setCollectiveCut={setCollectiveCut} onLogFee={logCollectiveFee} />}
            {(isStaff || orderTab === "event") && <EventView isStaff={isStaff} events={events} eventsDispatch={eventsDispatch} eventInv={eventInv} eventInvDispatch={eventInvDispatch} received={eventReceived} receivedDispatch={eventReceivedDispatch} orders={eventOrders} ordersDispatch={eventDispatch} onReturnToInventory={returnToInventory} onUndoReceived={undoEventReceived} onCaptureCustomer={captureCustomer} onLogLoss={isStaff ? undefined : logLoss} onLogEventCost={isStaff ? undefined : logEventCost} expenses={expenses} sectionOrder={sectionOrder} deals={deals} homeTaxRate={homeTaxRate} />}
            {!isStaff && orderTab === "single" && <SingleSaleView products={products} prodDispatch={prodDispatch} sales={singleSales} salesDispatch={singleSalesDispatch} onCaptureCustomer={captureCustomer} sections={sortedSections} deals={deals} taxRate={homeTaxRate} />}
          </div>
        )}
        {!isStaff && tab === "customers" && <Customers customers={customers} dispatch={customersDispatch} allOrders={[...orders, ...storeOrders, ...eventOrders, ...singleSales]} />}
        {!isStaff && tab === "deals" && <DealsManager deals={deals} dispatch={dealsDispatch} products={products} sections={sortedSections} homeTaxRate={homeTaxRate} setHomeTaxRate={setHomeTaxRate} />}
        {!isStaff && tab === "team" && <Team />}
        {!isStaff && tab === "financials" && <Financials allSales={[
          ...orders.map(o => ({ ...o, _channel: "General" })),
          ...storeOrders.map(o => ({ ...o, _channel: "Collective" })),
          ...eventOrders.map(o => ({ ...o, _channel: "Event" })),
          ...singleSales.map(o => ({ ...o, _channel: "Single" })),
        ]} expenses={expenses} />}
        {!isStaff && tab === "expenses" && <Expenses expenses={expenses} dispatch={expDispatch} />}
      </main>
    </div>
  );
}
